/* eslint-disable react/jsx-key */
/*
 * @Author: liyxt
 * @Date: 2019-08-27 16:34:44
 * @LastEditors: bbqin
 * @LastEditTime: 2023-09-23 14:47:17
 * @Description: file content
 */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable max-lines */
/* eslint-disable no-cond-assign */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-empty */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
// 第三方库
import { HotKeys } from 'react-hotkeys';
import { Resizable } from 're-resizable';
import classNames from 'classnames';
// base
import { Input as FormControl } from '@tinper/next-ui';
import Loading from '../Loading';
import Collapse from '../Collapse';
import NCTable from '../Table';
import Row from '../Row';
import Checkbox from '../Checkbox';
import Button from '../Button';
import Popover from '../Popover';
import Pagination from './components/Pagination';
import Dnd from '../Dnd';
import Tabs from '../Tabs';
import Menu from '../Menu';
import NCHotKeys from '../HotKeys';
import Tooltip from '../Tooltip';
import Selectable from '../Selectable';
import Dropdown from '../Dropdown';
// components
import ArrayTree from './components/ArrayTree';
import DndColumnConfig from './components/columnConfig';
// import sortTable from './components/sortTable';
// import filterTable from './components/filter';
// import Loading from './components/ReferLoading';
// api
import {
    toast,
    ajax,
    getSysFieldid,
    pageTo,
    getSafeRandom,
    ViewModel,
} from '@platform/api';
import BaseRefer from './BaseRefer';
import { getGlobalStorage, getTheme } from '@platform/api';
// drag

import DragWidthCom from '../DragWidthCom';
import { cloneDeep, debounce } from 'lodash';
// util
import {
    resizeOnVertical,
    calculateMinWidth,
    getUniqueClass,
    setContainerStyle,
    modalAlwaysShowInView,
    calculateResizeContainerHeight,
    clearDomReference,
    executePopOverEnterSelect,
    dealTreeFocusItem,
    countTitle,
    perceptionRowIndexWithUp,
    focusToTableHeadCheckBox,
    selectToLastRow,
    selectToFirstRow,
    perceptionRowIndexWithDown,
} from './utils';

//常量
import {
    CONTAINER_DEFAULT_MIN_HEIGHT,
    REFER_CONTENT_AREA_HEIGHT,
    PADDING_LEFT_IN_MAX_STATUS,
    PADDING_TOP_IN_MAX_STATUS,
    GRID_TREE_SEARCH_INPUT,
    TABLE_HEAD_CHECKBOX_CLASS_NAME,
} from './constants';

//common methods
import { findParentTd } from '@platform/api';
import { isIE, isFunction } from '@platform/api';
import { formatNumber, formatDatetime } from '../../api/getDataFormat';

//
const { TabPane: TabPane } = Tabs,
    { SubMenu: SubMenu, Item } = Menu;
const { Panel } = Collapse;
const SAVE_USUAL_URL = '/nccloud/uapbd/refer/SaveUsualAction.do';
const DELETE_USUAL_URL = '/nccloud/uapbd/refer/DeleteUsualAction.do';

// const img = require('./img/donghua.gif');
const tableRowHeight = 30;
// const totalTableHeight = 20;
const defaultColor = ['#111111', '#555555', '#111', '#555'];

// import 'bee-menus/build/Menu.css';

const Table = NCTable.sort(NCTable);

function isUndefined(value) {
    return value === undefined;
}

export default class Refer extends BaseRefer {
    constructor(props) {
        super(props);
        this.originTest = this.test;
        this.originDropDownTableFlag = this.handleDropDownTableFlag;
        this.resetColumnConfigWidth = this.handleColumnConfigWidth;
        this.state = {
            ...this.state,
            searchVal: '', // 搜索框的value
            treeSearchVal: '', // 树搜索框的value
            isFirstShow: true, // 模态框是否是第一次显示
            selectedShow: false, // 已选择是否显示
            selectedKeys: [], // 选择的树节点
            expandedKeys: [props.rootNode[props.idKey]], // 展开的树节点
            isSearch: false, // 是否是表格搜索
            isTreeSearch: false, // 是否是树搜索
            columnConfig: this.getColumnConfig(), // 列设置
            activeKey: props.isShowUsual ? '2' : '1', // 常用 or 全部 页签
            includeChildren: props.containlower === undefined ? (props.defaultIncludeChildren || false) : !!props.containlower, // 是否包含下级, containlower 为设计器里模板传过来的属性和defaultIncludeChildren含义一样，兼容一下
            includeSon: false, // 是否包含直接下级
            runWithChildren: props.defaultRunWithChildren || false, // 执行时包含下级
            isShowDisabledData: props.isDefaultCheckDisableData || false, // 是否显示停用
            max: props.defaultMax, // 是否是最大化状态
            isExpandLeftArea: false, // 是否展开左侧区域
            tableScrollHeight: 0, // 表格滚动区域
            isMultiSelectMode: false, // 是否是多选模式
            isDisabledDataDisabled: false, // 显示停用框是否禁用
            selectedRowIndex: -1, // 表格选中行的index
            keyMap: {}, // 树数据key的map结构
            resizeHeight: 0, // 更改的高度
            referContentAreaHeight: REFER_CONTENT_AREA_HEIGHT, //内容的高度
            dragStartPosition: {
                x: 0,
                y: 0,
            }, // 拖拽开始位置
            resizePosition: {
                x: 0,
                y: 0,
            }, //窗口改变大小位置
            addButtonList: null, // 新增按钮列表
            isAddButtonShow: false, // 新增按钮下拉是否显示
            currentButtonIndex: -1, // 当前选择的新增按钮（快捷键）
            selectLevel: [1, 1], // 级次选择的值
            paginationRefreshKey: 0,
            openKeys: [],
            moreMenuKey: getSafeRandom(),
            filterCondition: {
                isShow: false,
                conditions: [],
                logic: '',
                closeFilterModal: () => { },
            }, // 筛选条件
            addTipVisible: false,
            originFlag: true, //是否发送树数据请求
            largeSizeMore: false, //字体变化时的更多按钮样式
            marginLength: 0,
            DropTabsKey: '1',
            showColumnConfigPop: true,
            currentColumnConfigIndex: -1,
            // columnConfigFlag: false,
            dargname: '',
            configNamesList: [],
            forceUpdateColumn: false, //强制更新表格数据
            changeWidthFlag: false,
            dragOverflow: true,
        };
        this.hotKeyElement = {
            referPopWindow: Symbol('referPopWindow'),
            tableSearchInput: Symbol('tableSearchInput'),
            treeSearchInput: Symbol('treeSearchInput'),
            showDisabledData: Symbol('showDisabledData'),
            includeChildren: Symbol('includeChildren'),
            includeSon: Symbol('includeSon'),
            referTable: Symbol('referTable'),
            runWithChildren: Symbol('runWithChildren'),
            referTree: Symbol('referTree'),
            unit: Symbol('unit'),
            tabs: Symbol('tabs'),
            moreButton: Symbol('moreButton'),
        };
        this.tree = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTree,
                this.hotKeyElement.runWithChildren, // 可能没有
                this.hotKeyElement.unit, // 可能没有
                this.hotKeyElement.treeSearchInput,
                this.hotKeyElement.showDisabledData,
                this.hotKeyElement.includeChildren,
                this.hotKeyElement.includeSon,
                this.hotKeyElement.moreButton, // 一定有
            ]
                .filter((e) => e)
                .map((e, i) => [e, i])
        );
        this.grid = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTable,
                this.hotKeyElement.unit, // 可能没有
                this.hotKeyElement.tableSearchInput, // 一定有
                this.hotKeyElement.showDisabledData, // 可能没有
            ]
                .filter((e) => e)
                .map((e, i) => [e, i])
        );
        this.gridTree = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTree,
                this.hotKeyElement.tableSearchInput,
                this.hotKeyElement.showDisabledData, // 可能没有
                this.hotKeyElement.referTable,
                this.hotKeyElement.unit, // 可能没有
                this.hotKeyElement.treeSearchInput, // 一定有
            ]
                .filter((e) => e)
                .map((e, i) => [e, i])
        );
        this.usual = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTable,
                this.hotKeyElement.unit,
                this.hotKeyElement.tableSearchInput, // 一定有
                this.hotKeyElement.showDisabledData, // 可能没有
            ]
                .filter((e) => e)
                .map((e, i) => [e, i])
        );

        this.onResize = this.onResize.bind(this);
        this.onResizeStop = this.onResizeStop.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.timer = null;
        this.allpks = [];
        this.originTreeData = {}; //限制树的请求次数
        // 此参数为默认确定按钮ref， 为了兼容marcombineRefer 参照复写renderPopoverBottom， 
        // 复写的按钮有校验，校验不通过 不关弹窗 所以不想走alt+y
        // 如果后面问题比较多，就领域适配
        this.sureBtnRef = createRef(null);
    }

    componentDidMount() {
        super.componentDidMount();
        // super.test();
        this.originTest();
        this.oooo = cloneDeep(this.props.columnConfig);

        document.addEventListener('keypress', this.handleKeyPress);
        document.addEventListener('click', this.closeDropDown);

        //将参照移动到app的最后一个元素
        // if(this.popWindow){
        //     this.pageContainer.appendChild(this.popWindow);
        // }

        // this.popWindow?.addEventListener('wheel', this.handleWheel);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        //防止内存泄漏，删除dom引用
        let domList = [
            'referInput',
            'popWindow',
            'popover',
            'loadingContainer',
            'searchTableInput',
            'disableDataCheckbox',
            'moreButtonMenu',
            'table',
            'referTable',
            'refTree',
            'searchTreeInput',
            'hotKeyElement',
            'usual',
            'gridTree',
            'tree',
            'gird',
            'referSearchDom',
        ];
        clearDomReference(this, domList);

        this.lifecycleStatus = 'unmount';
        document.removeEventListener('keypress', this.handleKeyPress);
        document.removeEventListener('click', this.closeDropDown);
        // document.removeEventListener('scroll', this.handlePopTableScroll);

        // this.popWindow?.removeEventListener('wheel', this.handleWheel);
    }

    // handlePopTableScroll = (e) => {
    //     let tableDOM = document.querySelector('.refer-base-table-scroll-body');
    //     let totalDOM = document.querySelector('.refer-total-table-scroll-body');

    //     tableDOM.scrollLeft = totalDOM.scrollLeft;
    // };

    handleWheel = (e) => {
        if (this.popWindow.contains(e.target)) {
            let treeDomArr = this.popWindow.querySelectorAll(
                '.tree-hotkeys-wrapper'
            );
            if (treeDomArr.length) {
                let currentTreeDom = Array.prototype.find.call(
                    treeDomArr,
                    (treeDom) => treeDom.contains(e.target)
                );
                if (currentTreeDom) {
                    let { clientHeight, scrollHeight } = currentTreeDom;
                    if (clientHeight > scrollHeight) {
                        e.preventDefault();
                    }
                } else {
                    e.preventDefault();
                }
            } else {
                e.preventDefault();
            }
        }
    };

    handleKeyPress = (e) => {
        this.spaceKeyPress = e.charCode === 32;
    };

    closeDropDown = (e) => {
        if (this.moreButton) {
            if (e.target === this.moreButton) {
                this.setState(
                    ({ isMoreButtonShow }) => ({
                        isMoreButtonShow: !isMoreButtonShow,
                    }),
                    () => {
                        if (this.state.isMoreButtonShow) {
                            let intervalId = null;
                            intervalId = setInterval(() => {
                                if (this.moreButtonMenu) {
                                    this.moreButtonMenu?.focus();
                                    clearInterval(intervalId);
                                }
                            }, 50);
                        }
                    }
                );
                //如果下拉打开的状态，点击的元素不属于moreButtonMenu
            } else if (
                this.state.isMoreButtonShow &&
                !this.moreButtonMenu.contains(e.target) &&
                !this.customSelect?.contains(e.target)
            ) {
                this.setState({ isMoreButtonShow: false });
            }
        }
    };

    // 表格的按键事件
    onTableKeyPress = (up = false) => {
        let { selectedRowIndex, tableData } = this.state,
            { isMultiSelectedEnabled } = this.props,
            len = tableData[0].rows.length - 1,
            tableBody =
                this.table &&
                this.table.querySelector(`.refer-base-table-scroll-body`);

        if (document.activeElement === this.table) {
            if (up) {
                // up键
                if (selectedRowIndex == 0) {
                    selectedRowIndex = perceptionRowIndexWithUp(
                        selectedRowIndex,
                        isMultiSelectedEnabled
                    );

                    selectedRowIndex === -1 &&
                        focusToTableHeadCheckBox(this.table, this.spaceKeyDown);
                    // 处理焦点行超出视口时的scrollTop
                    this.scrollTop = selectedRowIndex * tableRowHeight;
                } else {
                    selectedRowIndex--;
                    // 处理焦点行超出视口时的scrollTop
                    if (
                        tableBody &&
                        selectedRowIndex * tableRowHeight < tableBody.scrollTop
                    ) {
                        this.scrollTop = selectedRowIndex * tableRowHeight;
                    }
                }
            } else {
                // down键
                if (selectedRowIndex == len) {
                    selectedRowIndex = perceptionRowIndexWithDown(
                        selectedRowIndex,
                        isMultiSelectedEnabled,
                        len
                    );

                    selectedRowIndex === -1 &&
                        focusToTableHeadCheckBox(this.table, this.spaceKeyDown);
                    // 处理焦点行超出视口时的scrollTop
                    this.scrollTop = 0;
                } else {
                    selectedRowIndex++;
                    // 处理焦点行超出视口时的scrollTop
                    if (
                        tableBody &&
                        (selectedRowIndex + 1) * tableRowHeight >
                        tableBody.clientHeight + tableBody.scrollTop
                    ) {
                        this.scrollTop =
                            (selectedRowIndex + 1) * tableRowHeight -
                            tableBody.clientHeight;
                    }
                }
            }
            setTimeout(() => {
                // 直接设不行，好像bee-table里有对scrollTop的操作，把下面的设值冲掉了
                tableBody && (tableBody.scrollTop = this.scrollTop);
            }, 0);
            this.setState({ selectedRowIndex });
        }
    };

    // 表格行的className
    rowClassName = (record, index) => {
        let { selectedRowIndex, selectedValues } = this.state,
            className = '';
        if (selectedValues.get(record.refpk)) {
            className = 'refer-selected-row';
        }
        if (selectedRowIndex === index) {
            className += ' refer-focus-row';
        }
        return className.trim();
    };

    // 根据参照类型，获取参照快捷键的顺序
    getHotKeyMap = () => {
        let { refType } = this.props,
            { activeKey } = this.state;
        if (!['tree', 'grid', 'gridTree'].find((e) => e === refType)) {
            refType = 'grid';
        }
        return {
            tree: this.tree,
            grid: this.grid,
            gridTree: activeKey == '2' ? this.usual : this.gridTree,
        }[refType];
    };

    // 根据ele在hotKeyMap中的顺序计算tabindex
    getTabIndex = (ele) => {
        let { baseTabIndex } = this.props,
            hotKeyMap = this.getHotKeyMap(),
            res = 5 + hotKeyMap.get(ele) * 5 + Number(baseTabIndex);
        return res;
    };

    // 获取hotKeyMap中的最后一个
    getLastHotKey = () => {
        let { refType, isShowDisabledData, isHasDisabledData } = this.props,
            { activeKey } = this.state,
            hotKeyMap = this.getHotKeyMap(),
            len = hotKeyMap.size;

        if (
            (refType === 'grid' ||
                (refType === 'gridTree' && activeKey == '2')) &&
            !(isShowDisabledData && isHasDisabledData)
        ) {
            // 没有显示停用按钮
            len--;
        }

        return [...hotKeyMap.keys()][len - 1];
    };

    // 获取hotKeyMap中的某一个
    getHotKeyByIindex = (index) => {
        let { refType, isShowDisabledData, isHasDisabledData } = this.props,
            { activeKey } = this.state,
            hotKeyMap = this.getHotKeyMap();

        if (
            (refType === 'grid' ||
                (refType === 'gridTree' && activeKey == '2')) &&
            !(isShowDisabledData && isHasDisabledData)
        ) {
            // 没有显示停用按钮
            // len--;
        }

        let hi = [...hotKeyMap][index || 0];

        return hi ? hi[0] : null;
    };

    // 重置快捷键顺序
    resetHotKeyLoop = (ele, e) => {
        let key = e.keyCode || e.which || e.charCode;
        if (key === 9 && !e.shiftKey) {
            if (ele !== this.getLastHotKey()) {
                return;
            }
            // tab
            ele === this.getLastHotKey() &&
                this.popWindow &&
                this.popWindow.focus();
        }
    };

    // tableData highlight---判断每条渲染的行数据是否包含搜索关键字，若存在高亮显示
    renderTableLabelHighLight = (title, tableKey, searchKey, flag) => {
        let searchKeys = this.getSearchConfigCodes(true);
        let res = title;
        if (flag) {
            res = countTitle(title, searchKey);
        } else {
            if (searchKeys.includes(tableKey)) {
                res = countTitle(title, searchKey);
            } else {
                res = title;
            }
        }

        return res;
    };

    // 根据columnConfig获取基本列信息
    getCommonColumns = (selectedShow, DropDownSearchFlag, isSearchNow) => {
        const { treeConfig, refType, abandGridSort, columnRender, customSort } = this.props;
        let { columnConfig, searchVal, referVal, jsonInsideRefer } = this.state,
            {
                name: names,
                code: codes,
                checked = {},
                width = {},
                itemtype = {},
                contentcolor = {},
                // total = {},
            } = columnConfig[0];

        if (!names || names.length === 0) {
            names = [
                '编码',
                // (jsonInsideRefer || {})['containers-refer-0038'],
                '名称',
                // (jsonInsideRefer || {})['containers-refer-0039']
            ];
        }
        if (!codes || codes.length === 0) {
            codes = ['refcode', 'refname'];
        }
        // if (
        //     treeConfig &&
        //     treeConfig.name &&
        //     treeConfig.name[0] === '名称' &&
        //     treeConfig.name.length === 1
        // ) {
        //     treeConfig.name[0] = (jsonInsideRefer || {})[
        //         'containers-refer-0039'
        //     ];
        // }

        //表头添加列设置

        // names.push('columnconfig');
        // names = [...new Set(names)];
        // codes = [...new Set(codes)];
        if (DropDownSearchFlag) {
            searchVal = referVal;
        }
        // if (treeConfig.name.length === 2) {
        //     treeConfig.name = [...names];
        //     treeConfig.code = [...codes];
        // }

        return refType === 'tree'
            ? treeConfig.name.map((e, i) => {
                return {
                    title: (
                        <span
                            className="refer-table-title"
                            fieldid={getSysFieldid(treeConfig.code[i])}
                            title={e}
                        >
                            {e}
                        </span>
                    ),
                    label: e,
                    key: treeConfig.code[i],
                    width: (treeConfig.width && treeConfig.width[codes[i]]) || '150px',
                    isSort: true,
                    filterable: true,
                    sorter: function (a, b) {
                        let key = treeConfig.code[i];
                        if (customSort && typeof customSort[key] === 'function') {
							return customSort[key]('', a, b);
						}else{
                        let aValue =
                            a[key] ||
                            a?.values?.[key]?.value ||
                            a?.values?.[key]?.display ||
                            '';
                        let bValue =
                            b[key] ||
                            b?.values?.[key]?.value ||
                            b?.values?.[key]?.display ||
                            '';
                        return key === 'refname'
                            ? aValue.localeCompare(bValue, 'zh-Hans-CN', {
                                sensitivity: 'accent',
                            })
                            : aValue >= bValue
                                ? 1
                                : -1;
                        }   
                    },
                    render: (text, row) => {
                        if (columnRender && typeof columnRender[codes[i]] == 'function') {
                            return columnRender[codes[i]](text, row);
                        } else {
                            let label =
                                row[treeConfig.code[i]] ||
                                (row.values &&
                                    row.values[codes[i]] &&
                                    (row.values[codes[i]].display ||
                                        row.values[codes[i]].value ||
                                        ''));
                            let highlightLabel =
                                label &&
                                    searchVal &&
                                    !selectedShow &&
                                    (DropDownSearchFlag ? isSearchNow : true)
                                    ? this.renderTableLabelHighLight(
                                        label,
                                        codes[i],
                                        searchVal,
                                        true
                                    )
                                    : label;
                            return (
                                <div
                                    className="refer-td"
                                    fieldid={getSysFieldid(treeConfig.code[i])}
                                    title={label}
                                >
                                    {highlightLabel || <span>&nbsp;</span>}
                                </div>
                            );
                        }
                    },
                };
            })
            : names
                .map((e, i) => {
                    return {
                        title: (
                            <span
                                className="refer-table-title"
                                fieldid={getSysFieldid(codes[i])}
                                title={e}
                                style={{
                                    color: defaultColor.includes(
                                        contentcolor[codes[i]]
                                    )
                                        ? ''
                                        : contentcolor[codes[i]],
                                }}
                            >
                                {e}
                            </span>
                        ),
                        label: e,
                        key: codes[i],
                        width: width[codes[i]] || '150px',
                        isSort: abandGridSort ? false : true,
                        filterable: true,
                        //   istotal: total[codes[i]] || true,
                        //   itemtype: itemtype[codes[i]] || '',
                        sorter: function (a, b) {
                            let key = codes[i];
                             if (customSort && typeof customSort[key] === 'function') {
                                return customSort[key]('', a, b);
                            }else{
                            let aValue =
                                a[key] ||
                                a?.values?.[key]?.value ||
                                a?.values?.[key]?.display ||
                                '';
                            let bValue =
                                b[key] ||
                                b?.values?.[key]?.value ||
                                b?.values?.[key]?.display ||
                                '';
                            return aValue >= bValue ? 1 : -1;
                            }
                        },
                        render: (text, row) => {
                            if (columnRender && typeof columnRender[codes[i]] == 'function') {
                                return columnRender[codes[i]](text, row);
                            } else {
                                const codeKey = codes[i];
                                const currentValue = row[codeKey] ?? row.values?.[codeKey]?.display ?? row.values?.[codeKey]?.value;


                                //在这进行数据的判断、转换
                                //在这解析出itemtype,形如width
                                const itemstyle = itemtype[codeKey] || '';
                                let label = currentValue;
                                switch (itemstyle) {
                                    case 'datepicker':
                                        label = formatDatetime(label ?? '', 'date');
                                        break;
                                    case 'datetimepicker':
                                        label = formatDatetime(label ?? '', 'datetime');
                                        break;
                                    case 'timepicker':
                                        label = formatDatetime(label ?? '', 'time');
                                        break;
                                    case 'number':
                                        label = formatNumber(label ?? '');
                                        break;
                                    case 'checkbox_switch':
                                        label = `${label}`;
                                        break;
                                    default:
                                        label = label ?? ''
                                        break;
                                }
                                //   label =
                                //       itemstyle === 'datepicker'
                                //           ? formatDatetime(label, 'datetime')
                                //           : itemstyle === 'number'
                                //           ? formatNumber(label)
                                //           : label;

                                let highlightLabel =
                                    label &&
                                        searchVal &&
                                        !selectedShow &&
                                        (DropDownSearchFlag ? isSearchNow : true)
                                        ? this.renderTableLabelHighLight(
                                            label,
                                            codes[i],
                                            searchVal,
                                            false
                                        )
                                        : label;
                                return (
                                    <div
                                        className="refer-td"
                                        fieldid={getSysFieldid(codes[i])}
                                        title={label}
                                    >
                                        {highlightLabel || <span>&nbsp;</span>}
                                    </div>
                                );
                            }
                        },
                        __type__: 'commonColumn',
                    };
                })
                .filter((e, i) => checked[codes[i]] !== false);
    };

    // 检查是否是全选
    isAllChecked = () => {
        let { selectedValues, tableData } = this.state;
        let data = tableData[0].rows || [];
        return !!(
            selectedValues.size &&
            data.length &&
            data.every((e) => selectedValues.has(e.refpk))
        );
    };
    // 检查是否是仅当前页全选
    isCurrentAllChecked = () => {
        let { selectedValues, tableData } = this.state;
        let data = tableData[0].rows || [];
        return !!(
            selectedValues.size &&
            selectedValues.size === data.length &&
            data.every((e) => selectedValues.has(e.refpk))
        );
    };

    // 是否是跨页全选
    isRealAllChecked = () => {
        let resultCache,
            pkCache,
            { selectedValues } = this.state;
        if (pkCache === this.allpks) {
            return resultCache;
        }
        pkCache = this.allpks;
        resultCache =
            this.allpks.length > 0 &&
            this.allpks.every((refpk) => selectedValues.has(refpk));
        return resultCache;
    };

    // 检查是否 中间态
    isIndeterminated = () => {
        let { selectedValues, tableData } = this.state;
        let data = tableData[0].rows || [];
        return (
            selectedValues.size > 0 &&
            data.length &&
            !this.isAllChecked() &&
            data.find((e) => selectedValues.has(e.refpk))
        );
    };

    // 处理树选中的方法
    treeSelect = (node, doubleClickFlag) => {
        let { selectedValues, treeData, includeSon } = this.state;
        const { idKey, isMultiSelectedEnabled, rootNode } = this.props,
            treeNodeId = node.props.treeNodeData[idKey];
        if (node.props.treeNodeData[idKey] === rootNode[idKey]) {
            // 选中根节点：全选
            if (isMultiSelectedEnabled) {
                if (
                    (this.shouldCheckedRoot === 'all' ||
                        (includeSon &&
                            this.shouldCheckedRoot === 'indeterminate')) &&
                    !doubleClickFlag
                ) {
                    // 双击时始终全选,

                    selectedValues = new Map();
                } else {
                    //解决包含直接下级的情况下点击根节点，选中所有树数据的情况
                    //如果是树根节点设置了disableCheckbox，就不更新selectedValues数据了
                    if (!node.props.disableCheckbox) {
                        if (includeSon) {
                            selectedValues =
                                this.getSelectTreeValuesThroughIncludeChildren(
                                    node,
                                    doubleClickFlag
                                );
                        } else {
                            //设置一个变量，把selectedValues先保存，执行完下行代码之后，再重新赋值给selectedValues，问题在于怎么去掉重复值
                            //或是参考普通节点的选择加载方式--selectedValues.has(treeNodeId)

                            //---------------------------------添加已选的除当前树数据之外的已选数据------

                            const originSelectedValues = new Map([
                                ...selectedValues.entries(),
                            ]);

                            selectedValues = new Map(
                                treeData
                                    .filter((e) => !this.isDisabled(e))
                                    .map((e) => [e[idKey], e])
                            );

                            originSelectedValues.forEach((val, key) => {
                                if (!selectedValues.has(key)) {
                                    selectedValues.set(key, val);
                                }
                            });
                            // console.log(selectedValues);

                            // treeData
                            //     .filter(
                            //         (e) =>
                            //             !this.isDisabled(e) &&
                            //             e.refpk !==
                            //                 (rootNode.refpk || rootNode[idKey]) &&
                            //             !this.getRowValuesBykey(e, 'virtualRootNote')
                            //     )
                            //     .every((e) => selectedValues.has(e[idKey]));

                            //----------------------------------------------------------------------

                            // selectedValues = new Map(
                            //     treeData
                            //         .filter((e) => !this.isDisabled(e))
                            //         .map((e) => [e[idKey], e])
                            // );
                            // 保证根节点的选中状态
                            selectedValues.set(
                                rootNode.refpk || rootNode[idKey],
                                rootNode
                            );

                            // this.toggleValueForMapOrObject(
                            //     selectedValues,
                            //     treeNodeId,
                            //     data
                            // );
                        }
                    }
                }
                this.setState({ isMultiSelectMode: true });
            }
        } else {
            // 普通节点
            if (!node.props.disableCheckbox) {
                if (isMultiSelectedEnabled) {
                    // 多选
                    selectedValues =
                        this.getSelectTreeValuesThroughIncludeChildren(
                            node,
                            doubleClickFlag
                        );
                } else {
                    // 单选
                    if (
                        this.getRowValuesBykey(
                            node.props.treeNodeData,
                            'virtualRootNote'
                        )
                    ) {
                        selectedValues.clear();
                    } else {
                        selectedValues = new Map(
                            Object.entries({
                                [treeNodeId]: node.props.treeNodeData,
                            })
                        );
                    }
                }
            }
        }
        return { selectedValues };
    };

    // 根据条件获取选中的节点
    getSelectTreeValuesThroughIncludeChildren = (node, doubleClickFlag) => {
        // dbclick: 双击树节点时，始终选中该节点并关闭弹窗
        let { selectedValues, includeChildren, includeSon, isMultiSelectMode } =
            this.state,
            { idKey } = this.props,
            treeNodeId = node.props.treeNodeData[idKey],
            _this = this;
        if (
            includeChildren ||
            includeSon ||
            this.getRowValuesBykey(node.props.treeNodeData, 'virtualRootNote')
        ) {
            let allChildCheck = true;
            if (
                !doubleClickFlag &&
                this.getRowValuesBykey(
                    node.props.treeNodeData,
                    'virtualRootNote'
                )
            ) {
                //检查所有下级是否都选中
                let list = [...(_this.originGroup[treeNodeId] || [])];
                allChildCheck = this.AllChildrenIsCheck(
                    list,
                    selectedValues,
                    treeNodeId
                );
            }
            // 包含下级
            //包含直接下级时且当前节点是虚拟节点时，取消不了勾选，先不改，若改，释放注释代码
            let mapFunc =
                !doubleClickFlag &&
                    allChildCheck &&
                    // (allChildCheck ||
                    //     (selectedValues.get(treeNodeId) &&
                    //         this.getRowValuesBykey(
                    //             node.props.treeNodeData,
                    //             'virtualRootNote'
                    //         ))) &&
                    (selectedValues.get(treeNodeId) ||
                        this.getRowValuesBykey(
                            node.props.treeNodeData,
                            'virtualRootNote'
                        ))
                    ? selectedValues.delete
                    : selectedValues.set;
            // 选中所有下级节点
            (function func(data) {
                // 寻找原始的子节点，而不是过滤之后的子节点
                let children = _this.originGroup[data[idKey]];
                if (!data.disabled) {
                    mapFunc.call(selectedValues, data[idKey], data);
                }
                if (
                    (!includeSon || data[idKey] === treeNodeId) &&
                    Array.isArray(children)
                ) {
                    children.forEach((e) => func(e));
                }
            })(node.props.treeNodeData);
            // 变为多选模式
            this.setState({ isMultiSelectMode: true });
        } else {
            // 选中单个节点
            let data = node.props.treeNodeData;
            if (isMultiSelectMode) {
                // 多选模式
                if (doubleClickFlag) {
                    // 双击
                    selectedValues.set(treeNodeId, data);
                } else {
                    this.toggleValueForMapOrObject(
                        selectedValues,
                        treeNodeId,
                        data
                    );
                }
            } else {
                // 单选模式
                selectedValues = new Map([[treeNodeId, data]]);
            }
        }

        // 额外进行批选操作
        let dataForBatch = this.batchSelectTreeNode(node.props.treeNodeData);
        dataForBatch.forEach((item) => {
            selectedValues.set(item[idKey], item);
        });

        return selectedValues;
    };

    // 检查所有下级是否都选中
    AllChildrenIsCheck = (list, selectedValues = new Map(), treeNodeId) => {
        if (list.length === 0) {
            if (selectedValues.has(treeNodeId)) {
                return true;
            } else {
                return false;
            }
        }
        let { idKey } = this.props;
        let treeNode;
        let allChildCheck = true;
        while ((treeNode = list.shift())) {
            let children = treeNode.children;
            if (
                !treeNode.disabled &&
                !this.getRowValuesBykey(treeNode, 'virtualRootNote') &&
                !selectedValues.get(treeNode[idKey])
            ) {
                allChildCheck = false;
                break;
            }
            if (Array.isArray(children)) {
                list.unshift(...children);
            }
        }
        return allChildCheck;
    };
    //检查父节点的选中状态
    checkAllOrHalfCheck = (list, selectedValues) => {
        let { idKey } = this.props;
        let treeNode;
        let allCheck = true;
        let halfCheck = false;
        while ((treeNode = list.shift())) {
            let children = treeNode.children;
            if (
                !treeNode.disabled &&
                !this.getRowValuesBykey(treeNode, 'virtualRootNote') &&
                !selectedValues.get(treeNode[idKey])
            ) {
                allCheck = false;
            }
            if (
                !treeNode.disabled &&
                !this.getRowValuesBykey(treeNode, 'virtualRootNote') &&
                selectedValues.get(treeNode[idKey])
            ) {
                halfCheck = true;
            }
            if (Array.isArray(children)) {
                list.unshift(...children);
            }
        }
        return allCheck ? 'allCheck' : halfCheck ? 'halfCheck' : '';
    };

    // 树的双击事件
    onTreeNodeDoubleClick = (checkedKeys, { node }) => {
        let {
            refType,
            isMultiSelectedEnabled,
            idKey,
            rootNode,
            onSureBtnClick,
        } = this.props,
            pid = node.props.treeNodeData[idKey],
            { searchVal, expandedKeys, tableData, isExpandLeftArea } =
                this.state;
        if (refType === 'tree') {
            // 单选时，根节点不可双击
            if (
                !(
                    node.props.treeNodeData[idKey] === rootNode[idKey] ||
                    this.getRowValuesBykey(
                        node.props.treeNodeData,
                        'virtualRootNote'
                    )
                ) ||
                isMultiSelectedEnabled
            ) {
                let { selectedValues } = this.treeSelect(node, true);
                if (node.props.disableCheckbox && !isMultiSelectedEnabled) {
                    selectedValues = selectedValues = new Map(
                        Object.entries({ [pid]: node.props.treeNodeData })
                    );
                }
                this.setState({ selectedValues }, async () => {
                    if (isFunction(onSureBtnClick)) {
                        let selections = this.getSelections();
                        let closeFlag = await onSureBtnClick(selections);
                        if (closeFlag === false) {
                            return;
                        }
                    }
                    if (!node.props.disableCheckbox) {
                        // if(!node.props.treeNodeData.values || !node.props.treeNodeData.values.ReturnOnTree){
                        //     isMultiSelectedEnabled
                        //         ? this.multiSelect()
                        //         : this.singleSelect(
                        //             [...selectedValues.values()][0]
                        //         );
                        //     this.handlePopoverBlur();
                        // }else{
                        //     if( node.props.treeNodeData.values.ReturnOnTree.display === 'N' ||
                        //         node.props.treeNodeData.values.ReturnOnTree.value === 'N'){
                        //         console.log('');
                        //     }
                        // }
                        isMultiSelectedEnabled
                            ? this.multiSelect()
                            : this.singleSelect(
                                [...selectedValues.values()][0]
                            );
                        this.handlePopoverBlur();
                    }

                    // 执行下enter关闭弹窗的逻辑
                    if (this.triggerTreeNodeDoubleClick) {
                        this.triggerTreeNodeDoubleClick = false;
                        this.onHotKeyClose();
                    }
                });
            }
        } else if (refType === 'gridTree') {
            if (
                !isExpandLeftArea ||
                node.props.treeNodeData[idKey] === rootNode[idKey]
            ) {
                return;
            }
            // 树表时，并且左侧树展开时：选中节点，收起展开
            if (isExpandLeftArea) {
                this.loadAndSetTableData({
                    pid: node.props.treeNodeData.refpk,
                    pageInfo: {
                        pageIndex: 0,
                        pageSize: tableData[0].page.pageSize,
                    },
                    keyword: searchVal,
                });
                this.setState({
                    isExpandLeftArea: false,
                    expandedKeys: [...new Set([...expandedKeys, pid])],
                });
            }
        }
        this.setState({ selectedKeys: [pid] });
        // onEnter 逻辑添加 by bbqin
        // setTimeout(() => {this.props.onEnter && this.props.onEnter({e: event, target: this.referInput});}, 20);
    };

    // 左树的点击事件：左树右表时查右表数据, 树时选中节点
    //根据左树点击的值获取其对应的pid,基于此去查右表数据，如果有缓存的数据，则不再发送网络请求
    onTreeNodeSelect = (_selectedKeys, { node }) => {
        // console.log('点击树：', _selectedKeys, { selected, selectedNodes, node, event });
        let keyPressFlag = false;
        if (
            window.event &&
            ['keyCode', 'charCode', 'which'].find((e) => window.event[e])
        ) {
            keyPressFlag = true;
        }
        let {
            refType,
            idKey,
            rootNode,
            isMultiSelectedEnabled,
            rootNodeSelectable,
            pageTemplate,
        } = this.props,
            pid = node.props.treeNodeData[idKey],
            {
                searchVal,
                isExpandLeftArea,
                selectedValues,
                selectedKeys,
                expandedKeys,
                isTreeSearch,
                isMultiSelectMode,
                includeChildren,
                includeSon,
                tableData,
                isSearch,
            } = this.state;
        let expandedKeysSet = new Set([...expandedKeys]);
        // let selectNodeIsExpand = expandedKeysSet.has(pid);
        // 单击展开并选中,快捷键只选中不展开

        //再点击树，收起子项
        // if (expandedKeys.includes(pid)) {
        //     // expandedKeys.forEach((e, index) => {
        //     //     if (e === pid) {
        //     //         expandedKeys.splice(index, 1);
        //     //     }
        //     // });
        //     // expandedKeys = [...expandedKeys];
        //     expandedKeysSet.delete(pid);

        //     expandedKeys = keyPressFlag ? expandedKeys : [...expandedKeysSet];
        //     selectedKeys = [pid];
        // } else {
        //     expandedKeys = keyPressFlag
        //         ? expandedKeys
        //         : [...expandedKeysSet.add(pid)];
        //     selectedKeys = [pid];
        // }

        expandedKeys = keyPressFlag
            ? expandedKeys
            : [...expandedKeysSet.add(pid)];
        selectedKeys = [pid];

        // 查下级--懒加载时使用
        // let {treeNodeData} = node;
        this.loadTreeChildrenDataIfNeeded(node);

        if (refType === 'gridTree') {
            // 左树右表
            let searchPid = node.props.treeNodeData.refpk;
            if (node.props.treeNodeData[idKey] === rootNode[idKey]) {
                if (isSearch || rootNodeSelectable) {
                    searchPid = '';
                } else {
                    return;
                }
            } else {
                this.lastSelectNode = node.props.treeNodeData[idKey];
            }
            if (!node.props.disableCheckbox) {
                if (!isExpandLeftArea) {
                    // 查右表数据
                    let a = this.findParent(node.props.treeNodeData); //适配岳鹏
                    // if (pageTemplate && !node.props.treeNodeData.isLeaf) {
                    //     return;
                    // }
                    this.loadAndSetTableData({
                        pid: searchPid,
                        pageInfo: {
                            pageIndex: 0,
                            pageSize: tableData[0].page.pageSize,
                        },
                        keyword: searchVal,
                        queryInfo: this.getQueryInfo(),
                        multiPid: pageTemplate
                            ? {
                                pageCode: node.props.treeNodeData['refcode'],
                                appCode: a && a['refcode'],
                            }
                            : {},
                    });
                }
            }
        } else if (refType === 'tree') {
            // 树 TODO:包含下级待确认
            /**
             * 点击树节点需要选中的情况
             * 1：多选情况下：不包含下级，并且是单选模式下，勾选，选中并展开。
             * 2：多选情况下：虚拟节点，并且是单选模式下，勾选自己及下级，选中并展开。
             * 2：单选情况下：选中节点。
             */
            // 多选树：快捷键space选中时，onSelect和onCheck都会触发，会导致选择无效，所以做此处理,
            if (
                !(
                    (keyPressFlag || isMultiSelectMode) &&
                    isMultiSelectedEnabled
                ) &&
                !(includeChildren || includeSon)
            ) {
                if (node.props.disableCheckbox && !isMultiSelectedEnabled) {
                    selectedValues = new Map(
                        Object.entries({ [pid]: node.props.treeNodeData })
                    );
                } else if (!node.props.disableCheckbox) {
                    if (isMultiSelectedEnabled && !isMultiSelectMode) {
                        selectedValues.clear();
                    }
                    ({ selectedValues } = this.treeSelect(node));
                }
                this.setState({ selectedValues });
            }
        }
        this.setState({
            expandedKeys,
            selectedKeys,
        });
    };

    // 根据条件获取下级数据
    loadTreeChildrenDataIfNeeded = (node) => {
        let { pageSize, idKey, isTreelazyLoad } = this.props,
            { isTreeSearch } = this.state,
            treeNodeData = node.props.treeNodeData;
        if (isTreelazyLoad && !isTreeSearch) {
            !node.props?.treeNodeData?.isleaf &&
                this.loadAndSetTreeData(
                    {
                        pid: treeNodeData[idKey],
                        pageInfo: {
                            pageSize,
                            pageIndex: -1,
                        },
                    },
                    treeNodeData
                );
        }
    };

    // 左树的勾选事件：多选树时
    onTreeNodeCheck = (checkedKeys, { node }) => {
        console.log('树选中', checkedKeys, node);
        let keyPressFlag = false;
        if (
            window.event &&
            ['keyCode', 'charCode', 'which'].find((e) => window.event[e])
        ) {
            keyPressFlag = true;
        }
        //如果是批量选择就不去做防抖 批量选择时添加的状态[selectTreeNodeWithBatch]
        if (keyPressFlag === false || this.selectTreeNodeWithBatch) {
            this.setState(
                {
                    isMultiSelectMode: true,
                    selectedKeys: [node.props.treeNodeData[this.props.idKey]],
                },
                () => {
                    let { selectedValues } = this.treeSelect(node);
                    this.setState({ selectedValues });
                }
            );
        } else {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                /**
                 * 长按space键时在按钮keyUp时会再次触发此回调，所以在keyFun中添加标识pressOnTreeNode判断一下
                 */
                if (this.pressOnTreeNode) {
                    this.pressOnTreeNode = false;
                    return;
                }
                this.setState(
                    {
                        isMultiSelectMode: true,
                        selectedKeys: [
                            node.props.treeNodeData[this.props.idKey],
                        ],
                    },
                    () => {
                        let { selectedValues } = this.treeSelect(node);
                        this.setState({ selectedValues });
                        this.pressOnTreeNode = false;
                    }
                );
                clearTimeout(this.timer);
                this.timer = null;
            }, 200);
        }
    };

    // 左树的展开事件
    onTreeNodeExpand = (expandedKeys, { expanded, node }) => {
        // console.log('节点展开：', expandedKeys, { expanded, node });
        let { onTreeNodeExpand, isTreelazyLoad, pageSize, idKey } = this.props,
            { isTreeSearch } = this.state;
        this.run(onTreeNodeExpand, node);
        if (expanded && isTreelazyLoad && !isTreeSearch) {
            this.loadAndSetTreeData(
                {
                    pid: node.props.treeNodeData[idKey],
                    pageInfo: {
                        pageSize,
                        pageIndex: -1,
                    },
                },
                node.props.treeNodeData
            );
        }
        this.setState({ expandedKeys });
    };

    // ctrl/shift快捷键批量选树节点
    batchSelectTreeNode = (node) => {
        if (this.shiftKey) {
            if (this.startIndex === 0) {
                // 还没选开始节点
                this.startIndex = node.index;
                this.endIndex = 0;
            } else {
                this.endIndex = node.index;
            }
        } else {
            this.startIndex = node.index;
            this.endIndex = 0;
        }
        if (this.endIndex > 1) {
            // 1是根节点
            // 批量选
            let dataForBatch;
            if (this.startIndex < this.endIndex) {
                dataForBatch = this.state.treeData.slice(
                    this.startIndex - 1,
                    this.endIndex
                );
            } else {
                dataForBatch = this.state.treeData.slice(
                    this.endIndex - 1,
                    this.startIndex
                );
            }
            this.startIndex = 0;
            this.endIndex = 0;
            this.setState({ isMultiSelectMode: true });
            return dataForBatch;
        } else {
            return [];
        }
    };

    // ctrl/shift快捷键批量选表格数据
    batchSelectTableData = (row, index) => {
        if (this.shiftKey) {
            if (this.startIndex === 0) {
                // 还没选开始节点
                this.startIndex = index;
                this.endIndex = 0;
            } else {
                this.endIndex = index;
            }
        } else {
            this.startIndex = index;
            this.endIndex = -1;
        }
        if (this.endIndex >= 0) {
            // 1是根节点
            // 批量选
            let dataForBatch;
            if (this.startIndex < this.endIndex) {
                dataForBatch = this.state.tableData[0].rows.slice(
                    this.startIndex,
                    this.endIndex + 1
                );
            } else {
                dataForBatch = this.state.tableData[0].rows.slice(
                    this.endIndex,
                    this.startIndex + 1
                );
            }
            this.startIndex = 0;
            this.endIndex = 0;
            return dataForBatch;
        } else {
            return [];
        }
    };

    // 已选择页签中的删除事件
    onSelectedRowClick = (row) => {
        let { selectedValues } = this.state;
        selectedValues.delete(row.refpk);
        this.setState({ selectedValues });
    };

    // 右侧表格行点击
    onRowClick = (record, index, e) => {
        let { selectedKeys } = this.state;
        if(this.props.defaultCheckedTreeNode){
            selectedKeys = record && [record.pid];
        }
        // 为了避免和新开发的行框选点选区域选事件冲突
        if (e.ctrlKey || e.metaKey) {
            return;
        }
        e.stopPropagation();
        let { isMultiSelectedEnabled } = this.props,
            { selectedValues, isMultiSelectMode } = this.state;

        //点击收藏按钮的时候，禁止表格行的点击事件
        if (
            !isMultiSelectedEnabled &&
            (e.target?.outerHTML ==
                '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>' ||
                e.target?.outerHTML ==
                '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>')
        ) {
            console.log('点击收藏跳过表格');
            return;
        } else if (
            isMultiSelectedEnabled &&
            (e.target?.outerHTML ==
                '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>' ||
                e.target?.outerHTML ==
                '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>')
        ) {
            console.log('点击收藏跳过表格');
            return;
        }

        if (isMultiSelectedEnabled) {
            // 多选
            if (!isMultiSelectMode) {
                // 单选模式
                selectedValues = new Map([[record.refpk, record]]);
            }

            // let { selectedValues } = this.state;
            // // 额外进行批选操作
            // let dataForBatch = this.batchSelectTableData(record);
            // dataForBatch.forEach((item) => {
            //     selectedValues.set(item[idKey], item);
            // });

            // this.setState({
            //     selectedValues,
            //     isMultiSelectMode: true,
            // });
        } else {
            // 单选
            selectedValues = new Map(
                Object.entries({ [record.refpk]: record })
            );
        }
        this.setState({
            selectedValues,
            selectedRowIndex: index,
            selectedKeys,
        });
    };

    // 表格行双击
    onRowDoubleClick = async (record, index, e) => {
        e.stopPropagation();
        let { onSureBtnClick } = this.props;
        // let selections = this.getSelections();
        if (isFunction(onSureBtnClick) && this.props.isLabelDesign) {
            let closeFlag = await onSureBtnClick([record]);
            if (closeFlag === false) {
                return;
            }
        }
        let { isMultiSelectedEnabled } = this.props,
            { selectedValues, isMultiSelectMode } = this.state;

        //点击收藏按钮的时候，禁止表格行的点击事件
        if (
            !isMultiSelectedEnabled &&
            (e.target?.outerHTML ==
                '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>' ||
                e.target?.outerHTML ==
                '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>')
        ) {
            console.log('点击收藏跳过表格');
            return;
        } else if (
            isMultiSelectedEnabled &&
            (e.target?.outerHTML ==
                '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>' ||
                e.target?.outerHTML ==
                '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>')
        ) {
            console.log('点击收藏跳过表格');
            return;
        }

        if (isMultiSelectedEnabled && isMultiSelectMode) {
            // 多选
            selectedValues.set(record.refpk, record);
            this.multiSelect();
        } else {
            // 单选
            // selectedValues = new Map(
            // 	Object.entries({
            // 		[record.refpk]: record
            // 	})
            // );
            selectedValues.clear();
            this.singleSelect(record);
        }
        this.handlePopoverBlur();
    };

    //下拉表格行的点击事件
    onDropDownRowClick = (record, index, e) => {
        // 为了避免和新开发的行框选点选区域选事件冲突
        if (e.ctrlKey || e.shiftKey || e.metaKey) {
            return;
        }
        e.stopPropagation();
        if (this.getStatus().isFocusStatus) {
            this.focusFlag = true;
        }
        let { isMultiSelectedEnabled } = this.props,
            { selectedValues } = this.state;
        if (isMultiSelectedEnabled) {
            // 多选
            selectedValues.set(record.refpk, record);
        } else {
            // 单选
            selectedValues = new Map(
                Object.entries({ [record.refpk]: record })
            );
        }
        // this.originDropDownTableFlag(false, true);

        this.setState({
            selectedValues,
            selectedRowIndex: index,
        });
    };

    //下拉面板点击行选中值事件
    onDropDownRowDoubleClick = (record, index, e) => {
        e.stopPropagation();
        if (this.getStatus().isFocusStatus) {
            this.focusFlag = true;
        }
        let { isMultiSelectedEnabled } = this.props,
            { selectedValues } = this.state;
        if (isMultiSelectedEnabled) {
            // 多选
            selectedValues.set(record.refpk, record);
            this.multiSelect();
        } else {
            // 单选
            // selectedValues = new Map(
            // 	Object.entries({
            // 		[record.refpk]: record
            // 	})
            // );
            selectedValues.clear();
            this.singleSelect(record);
        }
        // this.originDropDownTableFlag(false);
        this.handlePopoverBlur();
    };

    // 获取并设置表格值
    loadAndSetTableData = (_param, useCache = true, callback) => {
        let param = this.__getParam(_param);
        this.currentSelectedNodePid = param.pid;
        this.currentSelectedKeyword = param.keyword;
        this.loadTableData(param, useCache, false).then((data) => {
            let isContinue = true
            if (param && param.keyword !== undefined && this.currentSelectedKeyword !== param.keyword) {
                isContinue = false
            } else if (param && param.pid && param.pid !== this.currentSelectedNodePid) {
                isContinue = false
            }
            if (isContinue) {
                this.setTableData('tableData', 0, data);
                callback?.(data);
            }
        });
    };

    // 获取并且设置树的数据
    loadAndSetTreeData = (_param, rootNode) => {
        let param = this.__getParam(_param);
        this.loadTreeData(param).then((data) => {
            this.setTreeData('treeData', rootNode, data);
        });
    };

    // 弹出框中的搜索表事件
    popSearchTable = (keyword) => {
        // grid和gridTree走这个方法
        let { selectedKeys, tableData, activeKey } = this.state,
            {
                rootNode,
                refType,
                idKey,
                selectRootNodeWhenGridTreeReferSearch,
            } = this.props;

        let pid = '';
        if (refType === 'gridTree' && activeKey == '1') {
            if (keyword) {
                if (selectRootNodeWhenGridTreeReferSearch) {
                    this.lastSelectNode = selectedKeys[0];
                    selectedKeys = [rootNode[idKey]];
                }
            } else {
                selectedKeys = [this.lastSelectNode];
                pid = this.lastSelectNode;
            }
        }

        tableData[0].page.pageIndex = 0;
        this.loadAndSetTableData({
            pageInfo: tableData[0].page,
            keyword,
            pid,
            queryInfo: this.getQueryInfo(),
        }, false, () => {
            this.setState(
                {
                    isSearch: !!keyword,
                    selectedKeys,
                },
                () => {
                    refType === 'gridTree' &&
                        this.refTree &&
                        dealTreeFocusItem(this.refTree);
                }
            );
        });//查常用用缓存有问题
    };

    // 弹出框中树的搜索事件
    popSearchTree = (keyword) => {
        // tree走这个方法
        let { expandedKeys, isTreeSearch, originFlag, treeData } = this.state;
        const { rootNode, filterOriginData, isTreelazyLoad, isCacheable } =
            this.props;
        isTreeSearch = !!keyword;
        if (keyword) {
            this._expandedKeys =
                this._expandedKeys || JSON.parse(JSON.stringify(expandedKeys));
        }

        let param = this.__getParam({
            keyword: isTreelazyLoad ? keyword : isCacheable ? '' : keyword,
            pageInfo: { pageIndex: -1 },
        });

        if (!filterOriginData) {
            this.loadTreeData(param, true, true).then((data) => {
                !this.props.useExtraTreeData &&
                    !isTreelazyLoad &&
                    (data.rows = this.treeFilter(data.rows, keyword));
                this.setTreeData('treeData', rootNode, data);
            });

            this.setState({ isTreeSearch });
        } else {
            this.setState({ isTreeSearch });

            if (!originFlag) {
                let originTreeData = { ...this.originTreeData };
                originTreeData.rows = this.treeFilter(
                    originTreeData.rows,
                    keyword
                );
                this.setTreeData('treeData', rootNode, originTreeData);
            } else {
                this.originTreeData['rows'] = [...treeData.slice(1)];
                let data = {};
                data['rows'] = [
                    ...this.treeFilter(this.originTreeData.rows, keyword),
                ];
                this.setTreeData('treeData', rootNode, data);
                this.setState({ originFlag: false });
            }
        }

        //若非第一次搜索关键字，那就直接用state中存取的数据过滤，而不是再次发送请求keyword=''的请求后再过滤--异步树
        //每次输入不同的关键字都发送请求，通过返回后的数据再进行过滤--同步树
        // if (!originFlag) {
        //     let originTreeData = { ...this.originTreeData };
        //     originTreeData.rows = this.treeFilter(originTreeData.rows, keyword);
        //     this.setTreeData('treeData', rootNode, originTreeData);
        // } else {
        //     //请求一次数据
        //     // this.loadTreeData(param).then((data) => {
        //     //     this.originTreeData = { ...data };
        //     //     // console.log(this.state.treeData);
        //     //     console.log(this.originTreeData);
        //     //     // this.originTreeData['rows'] = [...this.state.treeData.slice(1)];
        //     //     data.rows = this.treeFilter(data.rows, keyword);
        //     //     this.setTreeData('treeData', rootNode, data);
        //     //     this.setState({
        //     //         originFlag: false,
        //     //     });
        //     // });
        //     //---------------------------
        //     // this.originTreeData['rows'] = [...treeData.slice(1)];
        //     // let data = {};
        //     // data['rows'] = [
        //     //     ...this.treeFilter(this.originTreeData.rows, keyword),
        //     // ];
        //     // this.setTreeData('treeData', rootNode, data);
        //     // this.setState({
        //     //     originFlag: false,
        //     // });
        // }
    };

    // 取消按钮事件
    cancel = async () => {
        const {
            isMultiSelectedEnabled,
            refType,
            onCancelBtnClick,
            isTreelazyLoad,
        } = this.props;
        let selections = this.getSelections();
        if (isFunction(onCancelBtnClick)) {
            let closeFlag = await onCancelBtnClick(selections);
            if (closeFlag === false) {
                return;
            }
        }
        //隐藏popover的dom
        let popDom = document.querySelector('.popover-in-refer');
        if (popDom) {
            popDom.style.display = 'none';
        }
        popDom = null;
        let resizeContainer = this.dragContainer.querySelector(
            '.js-resize-container'
        );
        // let height =
        //     calculateResizeContainerHeight(this.dragContainer, 'close') + 'px';
        // setContainerStyle({
        //     container: resizeContainer,
        //     width: resizeContainer.style.minWidth,
        //     minHeight: height,
        //     transform: 'translate(0px, 0px)',
        //     height,
        // });
        let maxWidth =
            this.popWindow.clientWidth - PADDING_LEFT_IN_MAX_STATUS * 2;
        let maxHeight =
            this.popWindow.clientHeight - PADDING_TOP_IN_MAX_STATUS * 2;
        let resizeWidth = resizeContainer.clientWidth;
        let resizeHeight = resizeContainer.clientHeight;
        let pushWidth = resizeWidth >= maxWidth ? maxWidth : resizeWidth;
        let pushHeight = resizeHeight >= maxHeight ? maxHeight : resizeHeight;
        let size = {
            width: pushWidth + 'px',
            height: pushHeight + 'px',
            max:
                (resizeWidth >= maxWidth && resizeHeight >= maxHeight) ||
                this.state.max,
            changeWidthFlag: this.state.changeWidthFlag,
        };
        this.pushToReferModalSize(size);
        if (refType === 'tree' && isTreelazyLoad) {
            // this.clearCache(); // 同步树树数据没选值且再次打开时，滚动条不改变位置，缓存数据清空
            this.refreshTree();
        }

        resizeContainer = null;

        this.setState(() => {
            let resizePosition = {
                x: 0,
                y: 0,
            };
            let params = isMultiSelectedEnabled
                ? {
                    selectedValues: new Map(
                        JSON.parse(JSON.stringify(this._value))
                    ),
                    // referVal: '',
                    isMoreButtonShow: false,
                    referContentAreaHeight: REFER_CONTENT_AREA_HEIGHT,
                }
                : {
                    selectedValues: new Map(
                        JSON.parse(JSON.stringify(this._value))
                    ),
                    isMoreButtonShow: false,
                    referContentAreaHeight: REFER_CONTENT_AREA_HEIGHT,
                };
            return { ...params, resizePosition };
        });
        this.handlePopoverBlur();
        this.setState({ originFlag: true });
        // show 的时候 给了true，隐藏的时候给了false，所以这里要反过来
        this.delayShow = false;
    };

    // 存入列设置
    pushToColumnConfig = () => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            { columnConfig: config } = this.state,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfig = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            );

        ColumnConfig[configKey] = config;
        this.setStorage('ColumnConfig', JSON.stringify(ColumnConfig));
    };

    // 从localStorage中取列设置
    getColumnConfig = (props) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { columnConfig, queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;
        return (
            JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            )[configKey] || JSON.parse(JSON.stringify(columnConfig))
        );
    };

    // 重置列设置
    resetColumnConfig = () => {
        let { columnConfig } = this.props;

        this.resetColumnConfigWidth();

        this.setState({ showColumnConfigPop: false });

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfig = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            );
        delete ColumnConfig[configKey];
        // ColumnConfig[configKey][0].width = columnConfig[0].width;
        this.setStorage('ColumnConfig', JSON.stringify(ColumnConfig));
        this.setState({
            columnConfig: this.getColumnConfig(),
            forceUpdateColumn: true,
        });

        // this.setState({ columnConfig: columnConfig });
    };

    // 重置列设置
    resetSearchColumnConfig = () => {
        let {
            name: names,
            search = {},
            fullTxtCode,
            fullTxtCodeDisable = [],
        } = this.oooo[0];

        let a;
        a = search ? search : {};

        let originColumnConfig = cloneDeep(this.state.columnConfig);
        if (
            originColumnConfig &&
            originColumnConfig[0] &&
            originColumnConfig[0].search
        ) {
            originColumnConfig[0].search = cloneDeep(a);
        }

        this.setState(
            {
                columnConfig: originColumnConfig,
            },
            () => {
                this.pushToColumnConfig();
            }
        );

        // this.setState({ columnConfig: columnConfig });
    };

    pushToReferTreeConfig = (width) => {
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl,
            referTreeConfig = JSON.parse(
                getGlobalStorage('localStorage', 'referTreeConfig') || '{}'
            );

        referTreeConfig[configKey] = width;
        this.setStorage('referTreeConfig', JSON.stringify(referTreeConfig));
    };

    // 从localStorage中取列设置
    getReferTreeConfig = () => {
        let { queryGridUrl, queryTreeUrl, treeWidth } = this.props,
            configKey = queryGridUrl + queryTreeUrl;
        return (
            JSON.parse(
                getGlobalStorage('localStorage', 'referTreeConfig') || '{}'
            )[configKey] || treeWidth
        );
    };

    // 表格部分的全选
    checkAll = (val) => {
        let { tableData, selectedValues } = this.state;
        let data = tableData[0].rows || [];
        if (val) {
            data.forEach((e) => {
                selectedValues.set(e.refpk, e);
            });
        } else {
            data.forEach((e) => {
                selectedValues.delete(e.refpk);
            });
        }
        this.setState({ selectedValues });
    };

    checkCurrentPage = () => {
        let { tableData } = this.state,
            selectedValues = new Map();
        let data = tableData[0].rows || [];
        data.forEach((e) => {
            selectedValues.set(e.refpk, e);
        });
        this.setState({ selectedValues });
    };

    handleSort = (sortCol) => {
        this.sortCol = sortCol;
    };

    // 复写原型方法：设置表格数据
    setTableData = (target, level, data) => {
        this.setState({ loading: false });
        let targetData = this.state[target];
        // 防止出现展开箭头
        data.rows.forEach((row) => {
            delete row.children;
            delete row.isleaf;
        });
        targetData[level] = {
            page: data.page,
            rows: data.rows,
        };
        if (data.page && data.page.pageIndex == 0) {
            this.allpks = data.page.allpks || [];
            this.totalPage = data.page.totalPage;
        }
        targetData[level].page &&
            (targetData[level].page.totalPage = this.totalPage || 0);
        this.sortCol = null;
        this.setState({ [target]: targetData }, () => {
            this.refreshTip();
        });
    };

    loadUsualData = (loading = true, useUsualCache = false) => {
        let { pageSize, queryGridUrl } = this.props,
            param = this.__getParam({
                pageInfo: {
                    pageIndex: -1,
                    pageSize,
                },
            });
        param.queryCondition.isShowUsual = true;
        param.queryCondition.UsualActionURL = queryGridUrl;
        return this.loadTableData(param, useUsualCache, loading);
        // return this.loadTableData(param, true, loading); //先显示无数据，再展示数据，去除中间状态
    };

    // 检查是否存在常用数据，添加表格查常用功能,无常用数据，页签置为“全部”且查全部
    checkUsual = (callback, dropTableFlag) => {
        const {
            isShowUsual,
            refType,
            queryCommonUseWhenOpen,
            isTreelazyLoad,
            rootNode,
            idKey,
        } = this.props;
        if (
            queryCommonUseWhenOpen &&
            isShowUsual &&
            (refType === 'gridTree' || refType === 'grid')
        ) {
            // 先查左树数据，作为filterPids
            this.loadUsualData(false, false).then((data) => {
                if (data.rows.length) {
                    // 有常用--更新下拉面板常用数据
                    this.setTableData('tableData', 0, data);
                    // data.rows.forEach((e) => {
                    //     this.toggleValueForMapOrObject(
                    //         collectUsualData,
                    //         e.refpk,
                    //         e
                    //     );
                    // });
                    let collectUsualData = new Map();
                    data.rows.forEach((e) => {
                        collectUsualData.set(e.refpk, e);
                    });

                    this.setState({ activeKey: '2', collectUsualData }, () => {
                        this.focusAreaOnPopup(true);
                    });

                    // 查树的数据，为了显示所属分类
                    if (refType === 'gridTree') {
                        let param = this.__getParam({
                            pid: isTreelazyLoad
                                ? rootNode.refpk || rootNode[idKey]
                                : '',
                            pageInfo: { pageIndex: -1 },
                            keyword: '',
                        });
                        this.loadAndSetTreeData(param, rootNode);
                    }
                } else {
                    // //常用数据没有值直接置为空，别查常用了
                    // data.rows = [];
                    // this.setState({
                    //     tableData: [data], //转换为tableData格式
                    // });
                    // // let tableData = [
                    // //     {
                    // //         rows: [],
                    // //         page: {
                    // //             pageIndex: 0,
                    // //             totalPage: 1,
                    // //         },
                    // //     },
                    // // ];
                    // // this.setTableData('tableData', 0, tableData);
                    // // else {
                    // //     this.setState({ activeKey: '1' }, () => {
                    // //         this.run(callback);
                    // //     });
                    // // }
                    if (!callback) {
                        data.rows = [];
                        this.setState({
                            tableData: [data], //转换为tableData格式
                        });
                    } else {
                        this.setState({ activeKey: '1' }, () => {
                            this.run(callback);
                        });
                    }
                }
            });
        } else {
            if (callback) {
                this.run(callback);
            }
            //列表参照没配置常用接口时，列表展示默认数据
            // if (
            //     (refType === 'grid' || refType === 'gridTree') &&
            //     !isShowUsual
            // ) {
            //     this.setState({
            //         tableData: [
            //             {
            //                 rows: [],
            //                 page: {
            //                     pageIndex: 0,
            //                     pageSize: 50,
            //                     totalPage: 1,
            //                 },
            //             },
            //         ],
            //     });
            // }
        }
    };

    // 焦点选中某个节点 bbqin
    focusAreaOnPopup(showing) {
        if (showing) {
            let { baseTabIndex } = this.props,
                firstIndex = 5 + 1 * 5 + Number(baseTabIndex);

            let timer = setTimeout(() => {
                if (firstIndex && this.popWindow) {
                    let first = this.popWindow.querySelector(
                        `[tabindex="${firstIndex}"]`
                    );
                    // console.log(this.popWindow, first, firstIndex);
                    // 让树获取焦点即可，详见onTreeFocus方法
                    // if (first && first.className.indexOf('nc-tree') != -1) {
                    // 	first = first.querySelector(`[tabindex="${firstIndex}"]`);
                    // }
                    first && first.blur();
                    first && first.focus();
                    first = null;
                }
                clearTimeout(timer);
            }, 20);
        }
    }

    checkAddButtons = () => {
        let { addButtonList } = this.state;
        let { addButtons, hasAddButton } = this.props;
        if (hasAddButton && !addButtonList && Array.isArray(addButtons)) {
            let buttonsMap = {};
            ajax({
                url: '/nccloud/platform/pub/refadd.do',
                data: {
                    appcodes: addButtons.map((button) => {
                        let { appcode } = button;
                        buttonsMap[appcode] = button;
                        return appcode;
                    }),
                },
                loading: false,
                success: (res) => {
                    if (res.success) {
                        let userData = JSON.parse(
                            getGlobalStorage('localStorage', 'STOREFORINFODATA')
                        );
                        let langseq = (userData && userData.langseq) || '';

                        this.setState({
                            addButtonList: res.data.AppRegisterVOs.map(
                                ({ code, name, name2, name3 }) => {
                                    if (langseq == '3') {
                                        buttonsMap[code].name =
                                            buttonsMap[code].name || name3;
                                    } else if (langseq == '2') {
                                        buttonsMap[code].name =
                                            buttonsMap[code].name || name2;
                                    } else {
                                        buttonsMap[code].name =
                                            buttonsMap[code].name || name;
                                    }

                                    return buttonsMap[code];
                                }
                            ),
                        });
                    }
                },
            });
        }
    };

    loadAndSetTableDataAgainIfEmpty = (_param, useCache = true, callback) => {
        let param = this.__getParam(_param);
        this.loadTableData(param, useCache).then((data) => {
            if (!data.rows.length && param.pageInfo.pageIndex > 0) {
                param.pageInfo.pageIndex = 0;
                this.loadAndSetTableData(param, useCache, callback);
            } else {
                this.setTableData('tableData', 0, data);
                callback?.();
            }
        });
    };

    //添加一个复写方法-适配陈道诚
    resetFirstSelectedKeys = (keys, refval) => {
        console.log('ss');
        return false;
    };

    // 复写原型方法：点击参照三个点的事件
    show = (lazyRefresh = false, clearCache = true, isCheckUsual) => {
        this.focusFlag = false;
        let {
            refType,
            queryGridUrl,
            rootNode,
            pageSize,
            isMultiSelectedEnabled,
        } = this.props;
        if (refType === 'grid' && !queryGridUrl) {
            this.delayShow = true;
        }
        let {
            disabled,
            isTreelazyLoad,
            idKey,
            searchWithKeywordOutsideWhenOpen,
            clearUnitValueWhenOpen,
            expandAllNodeWhenFirstOpen,
            isShowUsual,
        } = this.props,
            {
                selectedValues,
                selectedKeys,
                includeChildren,
                includeSon,
                activeKey,
                isExpandLeftArea,
                searchVal,
                referVal,
                expandedKeys,
                multiSearch,
                isFirstShow,
                filterCondition,
                DropTabsKey,
                cancelSearchStatus,
                collectUsualData,
            } = this.state,
            { isSearchStatus } = this.getStatus(),
            needSearch =
                searchWithKeywordOutsideWhenOpen &&
                isSearchStatus &&
                !multiSearch;

        if (disabled) {
            return false;
        }

        if (!lazyRefresh && clearUnitValueWhenOpen) {
            this.state.unit = {};
        }

        if (isFirstShow && refType === 'tree') {
            let userData = JSON.parse(
                getGlobalStorage('localStorage', 'STOREFORINFODATA')
            );
            let langseq = (userData && userData.langseq) || '';
            setTimeout(() => {
                // let fitmargin =
                //     this.popover &&
                //     this.popover.clientWidth -
                //         32 -
                //         (this.searchTableInput &&
                //             this.searchTableInput.clientWidth +
                //                 this.disableDataCheckbox &&
                //             this.disableDataCheckbox.clientWidth +
                //                 this.includeAllCheckbox &&
                //             this.includeAllCheckbox.clientWidth +
                //                 this.includeSonCheckbox &&
                //             this.includeSonCheckbox.clientWidth);
                if (
                    this.searchTreeInput &&
                    this.disableDataCheckbox &&
                    this.includeAllCheckbox &&
                    this.includeSonCheckbox
                ) {
                    let moreButtonWidth;
                    if (this.includeSonCheckbox.offsetWidth === 122 || this.includeSonCheckbox.offsetWidth === 125) {
                        moreButtonWidth = 62;
                    } else if (this.includeSonCheckbox.offsetWidth === 134) {
                        moreButtonWidth = 68;
                    } else if (this.includeSonCheckbox.offsetWidth === 189) {
                        moreButtonWidth = 68;
                    }
                    let fitmargin =
                        this.searchTreeInput.clientWidth +
                        this.disableDataCheckbox.clientWidth +
                        this.includeAllCheckbox.clientWidth +
                        this.includeSonCheckbox.offsetWidth -
                        moreButtonWidth +
                        36;
                    if (
                        this.moreButton &&
                        (this.moreButton.offsetHeight > 35 ||
                            (langseq === '3' &&
                                this.moreButton.offsetHeight > 15))
                    ) {
                        this.setState({ marginLength: fitmargin });
                    }
                }

                if (
                    this.searchTreeInput &&
                    this.disableDataCheckbox &&
                    this.includeAllCheckbox &&
                    this.includeSonCheckbox &&
                    ((this.moreButton && this.moreButton.offsetHeight > 35) ||
                        (langseq === '3' && this.moreButton.offsetHeight > 15))
                ) {
                    this.setState({
                        largeSizeMore: true,
                        // marginLength: fitmargin,
                    });
                }
            }, 100);
        }
        if (
            isFirstShow &&
            refType === 'gridTree' &&
            isShowUsual &&
            collectUsualData.size === 0
        ) {
            this.setState({
                activeKey: '1',
            });
        }

        let { tableData } = this.state,
            param;

        this.checkAddButtons();

        //通过activekey的值去判断，若当前页签是“最近使用”且是树表参照，更新表格的值setTableData，这里取localStorage中的历史数据
        // if (activeKey === '3') {
        //     // let { queryGridUrl, hotDataSize } = this.props;
        //     // // 没值历史记录
        //     // let history = this.localToList('referHistory');
        //     // if (history.length) {
        //     //     let param = this.__getParam({
        //     //         pageInfo: { pageSize: hotDataSize },
        //     //         searchPks: history,
        //     //         isHistory: true,
        //     //     });
        //     //     if (queryGridUrl) {
        //     //         this.loadTableData(param, true, false).then((data) => {
        //     //             data.rows = this.sortRowsByPk(data.rows, history, true);
        //     //             this.setTableData('tableData', 0, data);
        //     //         });
        //     //     }
        //     // } else {
        //     //     data.rows = [];
        //     //     this.setTableData('tableData', 0, data);
        //     // }
        //     this.loadHistoryData();
        // }
        //否则，再去查常用
        // 先查常用，常用没有的话再查全部
        ((cb) => {
            if (needSearch) {
                //把搜索结果带到界面
                cb();
            } else {
                // lazyRefresh：只刷新当前页面
                // lazyRefresh可能是e
                if (lazyRefresh) {
                    activeKey === '1'
                        ? isCheckUsual ? this.checkUsual(cb) : cb()
                        : isShowUsual
                            ? this.loadAndSetTableData(
                                {
                                    pageInfo: {
                                        pageIndex: -1,
                                        pageSize,
                                    },
                                    queryInfo: this.getQueryInfo(),
                                },
                                false,
                                data => {
                                    if (data.rows.length) {
                                        let collectUsualData = new Map();
                                        data.rows.forEach((e) => {
                                            collectUsualData.set(e.refpk, e);
                                        });
                                        this.setState({ collectUsualData });
                                    }
                                },
                            )
                            : this.setState({
                                tableData: [
                                    {
                                        rows: [],
                                        page: {
                                            pageIndex: 0,
                                            pageSize: pageSize || 50,
                                            totalPage: 1,
                                        },
                                    },
                                ],
                            });
                } else {
                    //点击“icon-refer”的时候，若此时为“常用”页签，则此时打开弹窗时先查常用，若无常用数据，跳转页签为“全部”，这里可以确定一下，是显示“暂无数据”还是跳转页签为“全部”
                    // DropTabsKey === '2' ? this.checkUsual(cb) : this.run(cb); //查常用操作不仅仅是“gridTree”,列表参照下也要查,通过下拉面板页签判断弹窗页签
                    // activeKey === '2' ? this.checkUsual(cb) : this.run(cb);
                    this.checkUsual(cb);
                }
            }
        })(() => {
            //查常用数据，已确定收藏亮不亮
            // if (isShowUsual) {
            //     this.loadUsualData().then((data) => {
            //         if (data.rows.length) {
            //             data.rows.forEach((e) => {
            //                 collectUsualData.set(e.refpk, e);
            //             });

            //             this.setState({ collectUsualData });
            //         }
            //     });
            // }
            // 没常用，查全部
            if (refType === 'grid') {
                searchVal && (tableData[0].page.pageIndex = 0);
                param = this.__getParam({
                    pageInfo: tableData[0].page,
                    keyword: needSearch ? referVal : '',
                    queryInfo: this.getQueryInfo(),
                });
                this.loadAndSetTableDataAgainIfEmpty(param, true, () => {
                    !lazyRefresh && this.focusAreaOnPopup(true);
                });
            } else {
                param = this.__getParam({
                    pid: isTreelazyLoad
                        ? rootNode.refpk || rootNode[idKey]
                        : '',
                    pageInfo: {
                        pageSize,
                        pageIndex: -1,
                    },
                    keyword: '',
                });
                this.loadTreeData(param).then((data) => {
                    this.setTreeData('treeData', rootNode, data, () => {
                        if (isFirstShow && expandAllNodeWhenFirstOpen) {
                            this.setState({
                                expandedKeys: [rootNode[idKey]].concat(
                                    data.rows.map((e) => e[idKey])
                                ),
                            });
                        }
                        !lazyRefresh && this.focusAreaOnPopup(true);
                        if (
                            lazyRefresh &&
                            clearCache &&
                            refType === 'tree' &&
                            data.rows
                        ) {
                            //直接删除树数据，点击刷新，已选数据未更新
                            let newTableData = [];
                            let selectedAllKeys = [...selectedValues.keys()];
                            data.rows.forEach((e) => {
                                if (selectedAllKeys.includes(e.refpk)) {
                                    newTableData.push(e);
                                }
                            });

                            // if (
                            //     refType === 'tree' &&
                            //     selectedAllKeys.length !== tableData[0].rows.length &&
                            //     tableData[0].rows.length > 0
                            // ) {
                            // tableData[0].rows.forEach((e) => {
                            //     if (selectedAllKeys.includes(e.refpk)) {
                            //         newTableData.push(e);
                            //     }
                            // });
                            //     tableData[0].rows = cloneDeep(newTableData);
                            //     this._value.forEach((e) => {
                            //         if (!selectedAllKeys.includes(e.refpk)) {
                            //             this._value.delete(e.refpk);
                            //         }
                            //     });
                            // }

                            this.setState({
                                selectedValues: new Map(
                                    newTableData.map((e) => [e.refpk, e])
                                ),
                            });
                        }
                    });
                    if (refType === 'gridTree') {
                        if (needSearch) {
                            param = this.__getParam({
                                keyword: referVal,
                                queryInfo: this.getQueryInfo(),
                            });
                            this.loadAndSetTableDataAgainIfEmpty(param, true);
                        } else {
                            let { treeDataWithChildren, keyMap } = this.state,
                                { selectFirstTreeNodeWhenOpen } = this.props,
                                firstSelectedKeys = selectedKeys[0];

                            if (
                                this.resetFirstSelectedKeys(
                                    treeDataWithChildren,
                                    referVal
                                ) !== false
                            ) {
                                firstSelectedKeys = this.resetFirstSelectedKeys(
                                    treeDataWithChildren,
                                    referVal
                                );
                            }
                            if (keyMap[firstSelectedKeys]) {
                                // 选中的节点是真实存在的
                                firstSelectedKeys =
                                    keyMap[firstSelectedKeys].refpk;
                                firstSelectedKeys ===
                                    (rootNode.refpk || rootNode[idKey]) &&
                                    (firstSelectedKeys =
                                        this.lastSelectNode || '');
                            } else {
                                firstSelectedKeys = '';
                            }
                            // 默认第一个节点
                            let firstTreeNode =
                                treeDataWithChildren?.[0]?.children?.[0];
                            !firstSelectedKeys &&
                                (firstSelectedKeys =
                                    firstTreeNode?.refpk ||
                                    firstTreeNode?.[idKey] ||
                                    '');
                            if (
                                selectFirstTreeNodeWhenOpen &&
                                firstSelectedKeys
                            ) {
                                // 查右表
                                param = this.__getParam({
                                    pid: firstSelectedKeys,
                                    pageInfo: tableData[0].page, //保留上次分页的设置
                                    queryInfo: this.getQueryInfo(),
                                });
                                this.loadAndSetTableDataAgainIfEmpty(
                                    param,
                                    true
                                );
                                this.setState({
                                    selectedKeys: [firstSelectedKeys],
                                });
                            } else {
                                // 重置左树和右表
                                selectedKeys = [];
                                tableData[0].rows = [];
                                this.setState(
                                    {
                                        tableData,
                                        selectedKeys,
                                    },
                                    () => {
                                        this.refreshTip();
                                    }
                                );
                            }
                        }
                    }
                });
            }
            this.setState({ activeKey: '1' });
        });

        if (refType === 'tree') {
            if (isMultiSelectedEnabled) {
                // 多选时选中第一个节点
                let trueValue = this.getTrueValue();
                let firstSelectedNode;
                let { idKey } = this.props;
                if (trueValue) {
                    if(!trueValue.length) {
                        firstSelectedNode = selectedValues.values().next().value;
                    } else {
                        firstSelectedNode = trueValue[0];
                    }
                }

                if (firstSelectedNode) {
                    let firstSelectedKey =
                        firstSelectedNode.refpk || firstSelectedNode[idKey];
                    selectedKeys = [firstSelectedKey];
                } else {
                    selectedKeys = [];
                }
            } else {
                selectedKeys = [...this._value.values()]
                    .slice(0, 1)
                    .map((e) => e[idKey]);
            }
        }
        this.runWithChildren = !!this.state.runWithChildren;
        this.setState(
            {
                isShow: true,
                isFirstShow: false,
                dropDownShow: false,
                isSelectedShow: false,
                searchVal: needSearch && refType !== 'tree' ? referVal : '',
                treeSearchVal: !isMultiSelectedEnabled && needSearch && refType === 'tree' ? referVal : '',
                selectedShow: false,
                isAddButtonShow: false,
                currentButtonIndex: -1,
                // max: lazyRefresh === true ? max : false,
                isExpandLeftArea: lazyRefresh ? isExpandLeftArea : false,
                selectedKeys,
                isMultiSelectMode:
                    isMultiSelectedEnabled &&
                    !(
                        [...selectedValues.keys()].length <= 1 &&
                        !(includeChildren || includeSon)
                    ),
                selectedRowIndex: -1,
                //刷新的时候弹出位置和大小不变
                dragStartPosition: lazyRefresh
                    ? this.state.dragStartPosition
                    : { x: 0, y: 0 },
                isTreeSearch: !isMultiSelectedEnabled && needSearch && refType === 'tree',
                isSearch: needSearch && refType !== 'tree',
                expandedKeys: isTreelazyLoad ? [rootNode[idKey]] : expandedKeys,
                unit: this.state.unit,
                // activeKey: DropTabsKey,
            },
            () => {
                //分别监听表格滚动与合计行滚动
                // let tableDOM = document.querySelector(
                //     '.refer-base-table-scroll-body'
                // );
                // let totalDOM = document.querySelector(
                //     '.refer-total-table-scroll-body'
                // );

                // if (totalDOM) {
                //     totalDOM.addEventListener(
                //         'scroll',
                //         this.handlePopTableScroll
                //     );
                // }

                this.referInput && this.referInput.blur();
                // 防止焦点丢失
                // !this.unitReferFocusFlag &&
                this.popWindow &&
                    !this.popWindow.contains(document.activeElement) &&
                    this.popWindow.focus();

                //刷新时不去计算高度
                !lazyRefresh &&
                    calculateResizeContainerHeight(this.dragContainer);
                if (!isMultiSelectedEnabled && needSearch) {
                    refType === 'tree'
                        ? this.popSearchTree(referVal)
                        : this.popSearchTable(referVal);
                }
                if (lazyRefresh) {
                    return;
                }
                this.max(this.state.max);
                //还原缓存中的宽高
                if (this.dragContainer) {
                    let resizeContainer = this.dragContainer.querySelector(
                        '.js-resize-container'
                    );
                    let height =
                        calculateResizeContainerHeight(
                            this.dragContainer,
                            'close'
                        ) + 'px';
                    let width = this.props.popWidth || calculateMinWidth({
                        refType,
                        max: this.state.max,
                        activeKey,
                        isExpandLeftArea,
                    });
                    let size = this.getReferModalSize();
                    if (size.max) {
                        this.setState({ max: true });
                    } else {
                        setContainerStyle({
                            container: resizeContainer,
                            width: size.width || width,
                            minWidth: width,
                            minHeight: height,
                            transform: 'translate(0px, 0px)',
                            height: size.height || height,
                        });
                        setContainerStyle({
                            container:
                                this.dragContainer.querySelector(
                                    '.js-drag-wrapped'
                                ),
                            width: size.width || width,
                            transform: 'translate(0px, 0px)',
                            height: size.height || height,
                        });
                        if (size.changeWidthFlag) {
                            this.setState({ changeWidthFlag: true });
                        }
                    }
                }
            }
        );
    };

    // 树获取焦点的事件
    onTreeFocus = (existFlag) => {
        let { scrollSelectedNodeIntoView } = this.props;
        if (!existFlag && scrollSelectedNodeIntoView) {
            return new Promise((resolve) => {
                let { pidKey, idKey, rootNode } = this.props,
                    { selectedKeys, expandedKeys, keyMap } = this.state,
                    targetKey = (selectedKeys || [])[0],
                    parents = [],
                    pid;
                if (targetKey) {
                    while (keyMap[targetKey]) {
                        pid = keyMap[targetKey][pidKey];
                        pid = keyMap[pid] ? pid : rootNode[idKey];
                        pid && parents.push(pid);
                        if (pid === rootNode[idKey]) {
                            targetKey = '';
                        } else {
                            targetKey = keyMap[pid] ? keyMap[pid][idKey] : '';
                        }
                    }
                    this.setState(
                        {
                            expandedKeys: [
                                ...new Set([...expandedKeys, ...parents]),
                            ],
                        },
                        () => {
                            try {
                                // 定位到选中节点
                                setTimeout(() => {
                                    document.activeElement.scrollIntoView();
                                }, 150);
                            } catch (e) { }
                            resolve(true);
                        }
                    );
                }
            });
        }
    };

    // 界面最大化
    max = (max) => {
        // 目的是不动下面的原有逻辑，且使max不变
        if (max !== undefined) {
            this.state.max = !max;
        }
        /*
         * 如果窗口状态为最小化重新赋值内容高度，
         * 窗口改变时都初始化拖动位置，防止拖动位置计算出错
         */

        this.setState(
            {
                max: !this.state.max,
                referContentAreaHeight:
                    !this.state.max === false
                        ? REFER_CONTENT_AREA_HEIGHT
                        : this.state.referContentAreaHeight,
                dragStartPosition: { x: 0, y: 0 },
                resizePosition: { x: 0, y: 0 },
                resizeHeight: 0,
            },
            () => {
                if (this.dragContainer) {
                    let resizeContainer = this.dragContainer.querySelector(
                        '.js-resize-container'
                    );
                    let width = this.props.popWidth || calculateMinWidth({
                        refType: this.props.refType,
                        max: this.state.max,
                        activeKey: this.state.activeKey,
                        isExpandLeftArea: this.state.activeKey,
                    });
                    // 点击了最大化时候恢复居中
                    setContainerStyle({
                        container: resizeContainer,
                        transform: 'translate(0px, 0px)',
                    });
                    if (
                        (max === undefined || max === false) &&
                        !this.state.changeWidthFlag
                    ) {
                        calculateResizeContainerHeight(this.dragContainer);
                        setContainerStyle({
                            container: resizeContainer,
                            width: width + 'px',
                        });
                        setContainerStyle({
                            container:
                                this.dragContainer.querySelector(
                                    '.js-drag-wrapped'
                                ),
                            width: width + 'px',
                        });
                    }
                }
            }
        );
    };

    // 树表：展开左侧树
    toggleExpandLeftArea = () => {
        this.setState({ isExpandLeftArea: !this.state.isExpandLeftArea });
    };

    // shift + tab 切換面板内元素 目前树中没有事件所以树不能触发 bbqin TODO 等树更新onKeydown回调
    popWindowKeyDownHandle = (e) => {
        // console.log(e.keyCode, e.shiftKey, document.activeElement);
        e.stopPropagation();
        let tabIndex = document.activeElement.tabIndex;
        if (tabIndex > 0 && e.keyCode === 9) {
            let hotKeyList = [...this.getHotKeyMap()];
            let maxLen = hotKeyList.length - 1;
            let baseTabIndex = Number(this.props.baseTabIndex);
            let currentIndex = (tabIndex - baseTabIndex - 5) / 5;

            if (currentIndex === 1 && e.shiftKey) {
                // shift + tab
                e.preventDefault();
                // 判斷是否 臨界點
                currentIndex = maxLen;
                let nextIndex =
                    5 + maxLen * 5 + Number(this.props.baseTabIndex);
                let nextElem = this.popWindow.querySelector(
                    `[tabindex="${nextIndex}"]`
                );
                // console.log(currentIndex, nextElem, nextIndex, `[tabindex="${nextIndex}"]`, this.popWindow);
                while (nextElem === null) {
                    maxLen = maxLen - 1;
                    nextIndex =
                        5 + maxLen * 5 + Number(this.props.baseTabIndex);
                    nextElem = this.popWindow.querySelector(
                        `[tabindex="${nextIndex}"]`
                    );
                }
                nextElem && nextElem.focus();

                nextElem = null;
            }
        }
    };

    handleSelectedClear = () => {
        this.setState({ selectedValues: new Map() });
    };

    getSelectColumns = () => {
        let { selectedShow } = this.state;
        let selectColumns = [];
        selectColumns.push({
            // 操作
            title: (
                <span fieldid={getSysFieldid('opr')}>
                    {' '}
                    {this.state.jsonInsideRefer['containers-refer-0025']}{' '}
                </span>
            ),
            key: 'operate',
            width: 90,
            fixed: 'right',
            render: (text, row, index) => {
                return (
                    <span
                        fieldid={getSysFieldid('opr')}
                        className="refer-del"
                        onClick={this.onSelectedRowClick.bind(null, row, index)}
                    >
                        {/* 移除 */}
                        {this.state.jsonInsideRefer['containers-refer-0026']}
                    </span>
                );
            },
        });

        selectColumns.unshift(...this.getCommonColumns(selectedShow));
        return selectColumns;
    };

    onDropBorderHandler = (dropWidth, column, DropTabsFlag) => {
        let columnConfig = this.state.columnConfig;
        let { width = {} } = columnConfig[0];
        width[column.key] = dropWidth;
        columnConfig[0].width = width;
        // console.log(DropTabsFlag);
        // if (DropTabsFlag) {
        //     this.referInput && this.referInput.focus();
        // }

        this.setState({ columnConfig }, () => {
            this.pushToColumnConfig();
        });
    };

    pushToReferModalSize = (size) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl, attrcode } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId + attrcode,
            referModalSize = JSON.parse(
                getGlobalStorage('localStorage', 'referModalSize') || '{}'
            );
        referModalSize[configKey] = size;
        this.setStorage('referModalSize', JSON.stringify(referModalSize));
    };

    getReferModalSize = () => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl, attrcode } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId + attrcode,
            referModalSize = JSON.parse(
                getGlobalStorage('localStorage', 'referModalSize') || '{}'
            );
        let size = referModalSize[configKey] || {};
        return size;
    };

    // 复写原型方法：渲染弹出层
    renderPopover = () => {

        let {
            container,
            popWindowClassName,
            isMultiSelectedEnabled,
            refType,
            isShowUsual,
            attrcode,
            fieldid,
            useLoading,
            refcode,
            disabledDrag,
            zIndex,
        } = this.props;
        let newContainer = container;
        if (
            container?.firstElementChild?.getAttribute('id') === 'forwardFrame'
        ) {
            newContainer =
                container.firstElementChild.contentWindow.document.body;
        }

        // if (this.homePageContainer) {
        //     newContainer = this.homePageContainer;
        // }

        let {
            isFirstShow,
            isShow,
            max,
            activeKey,
            isExpandLeftArea,
            dragStartPosition,
            selectedShow,
            loading,
            dragOverflow,
        } = this.state;
        let bottom = this.renderPopoverBottom();
        let fieldidValue = null;
        let minWidth = calculateMinWidth({
            refType,
            max,
            activeKey,
            isExpandLeftArea,
        });
        if (fieldid || attrcode) {
            fieldidValue = `${fieldid || attrcode}_refer-window`;
        }
        fieldidValue = getSysFieldid(fieldidValue);

        //有两个弹窗时拖动一个另一个也会跟着移动，因此每个弹窗都生成唯一的类名
        let uniqueBoundsClass = getUniqueClass();

        let height = isShow
            ? ((this.popover || {}).clientHeight || 0) - 85 - 1
            : 0; // header + footer = 85

        const { rowKey, columnConfig } = this.props,
            { sort } = columnConfig[0];
        let selectColumns = this.getSelectColumns();
        // selectColumns.push({
        // 	// 操作
        // 	title: <span fieldid={getSysFieldid('opr')}> {this.state.jsonInsideRefer['containers-refer-0025']} </span>,
        // 	key: 'operate',
        // 	width: 100,
        // 	fixed: 'right',
        // 	render: (text, row, index) => {
        // 		return (
        // 			<span
        // 				fieldid={getSysFieldid('opr')}
        // 				className="refer-del"
        // 				onClick={this.onSelectedRowClick.bind(null, row, index)}
        // 			>
        // 				{/* 移除 */}
        // 				{this.state.jsonInsideRefer['containers-refer-0026']}
        // 			</span>
        // 		);
        // 	},
        // });
        // selectColumns.unshift(...this.getCommonColumns(selectedShow));
        // selectColumns.forEach(element => {
        // 	if(this.sortCol && this.sortCol[0] && this.sortCol[0].field === element.key){
        // 		element.sortFlag = true;
        // 		element.order = this.sortCol[0].order;
        // 	}
        // });

        let topZIndex = this.popWindowzIndex || zIndex;
        if (this.props.popWidth) {
            minWidth = this.props.popWidth;
        }

        return ReactDOM.createPortal(
            // eslint-disable-next-line
            <div
                fieldid={fieldidValue}
                className={`refer-pop-window ${popWindowClassName} drag-area ${isShow
                        ? 'disabled-bg-btn refer-pop-window-show'
                        : 'refer-pop-window-hide'
                    } reftype-${refType} ${max ? 'refer-max' : ''}`}
                style={{
                    // overflow: 'hidden',--控制非首次弹出且点击最大、最小化按钮后整体弹窗样式
                    display: isShow ? (max ? 'block' : 'flex') : 'none',
                    padding: max
                        ? `${PADDING_TOP_IN_MAX_STATUS}px ${PADDING_LEFT_IN_MAX_STATUS}px`
                        : '0',
                    zIndex: topZIndex,
                    overflow: dragOverflow ? 'auto' : 'unset',
                }}
                // 這裏原來用來解決 表格内編輯導致 多次渲染的問題
                // 但是在firefox 61.0.2 版本導致 面板内input不显示光标
                onMouseOver={(e) => {
                    e.stopPropagation();
                }}
                onDoubleClick={(e) => {
                    e.stopPropagation();
                }}
                // 阻止传送门 事件
                onFocus={(e) => {
                    e.stopPropagation();
                }}
                ref={(dom) => {
                    this.popWindow = dom;
                }}
                tabIndex={this.getTabIndex(this.hotKeyElement.referPopWindow)}
                onKeyDown={this.popWindowKeyDownHandle}
                refCode={refcode}
            >
                {isFirstShow || (
                    <Dnd
                        disabled={disabledDrag}
                        handle={`.drag-modal-${uniqueBoundsClass}`}
                        cancel=".cancel-drag"
                        ref={(dom) => {
                            this.dragContainer = ReactDOM.findDOMNode(dom);
                        }}
                        defaultClassName={`js-drag-wrapped`}
                        position={dragStartPosition}
                        onStart={this.onDragStart}
                        onStop={this.onDragStop}
                        bounds="html"
                        defaultStyle={
                            this.props.popWidth && {
                                width: this.props.popWidth + 'px',
                            }
                        }
                    >
                        <div
                        // style={
                        //     // {
                        //     //     //width: max ? '100%' : minWidth,
                        //     // }
                        //     this.props.popWidth && {
                        //         width: this.props.popWidth + 'px',
                        //     }
                        // }
                        >
                            <Resizable
                                // bounds="window"
                                onResize={this.onResize}
                                onResizeStop={this.onResizeStop}
                                onResizeStart={this.onResizeStart}
                                minWidth={minWidth}
                                // minHeight={520}
                                // minHeight={max ? 520 : this.popover?.clientHeight}
                                defaultSize={{ width: minWidth }}
                                className={`js-resize-container popover-shadow ${refType === 'grid'
                                        ? 'add-popover-height'
                                        : ''
                                    }`}
                                enable={{
                                    top: !max,
                                    right: !max,
                                    bottom: !max,
                                    left: !max,
                                    topRight: false,
                                    bottomRight: !max,
                                    bottomLeft: false,
                                    topLeft: false,
                                }}
                            >
                                <div
                                    className={`refer-popover clearfix ${max ? 'max' : ''
                                        }`}
                                    ref={(dom) => {
                                        this.popover = dom;
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                    onDoubleClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    <div
                                        className={`refer-header drag-modal-${uniqueBoundsClass}`}
                                        fieldid={getSysFieldid('header-area')}
                                    >
                                        {isFirstShow ||
                                            this.renderPopoverHeader()}
                                    </div>

                                    <div
                                        className="loading-container"
                                        ref={(dom) => {
                                            this.loadingContainer = dom;
                                        }}
                                    >
                                        <Loading
                                            container={this.loadingContainer}
                                            show={useLoading && loading}
                                        />
                                        {isFirstShow ||
                                            this.renderPopoverContain()}
                                        {bottom && (
                                            <div
                                                className="refer-bottom refer-resize-icon"
                                                fieldid={getSysFieldid(
                                                    'bottom-area'
                                                )}
                                            >
                                                {isFirstShow || bottom}
                                            </div>
                                        )}
                                    </div>
                                    <Panel
                                        expanded={selectedShow}
                                        className="refer-collapse"
                                        bodyClassName="refer-collapse-body"
                                    >
                                        <div className="refer-collapse-header">
                                            <div
                                                className="refer-title"
                                                key="1"
                                                fieldid={getSysFieldid(
                                                    'catSelected_btn'
                                                )}
                                            >
                                                {/* 查看已选 */}
                                                {
                                                    this.state.jsonInsideRefer[
                                                    'containers-refer-0028'
                                                    ]
                                                }
                                            </div>
                                            <div
                                                className="refer-close"
                                                key="3"
                                            >
                                                <span
                                                    className="clear_btn"
                                                    fieldid={getSysFieldid(
                                                        'clear_btn'
                                                    )}
                                                    onClick={
                                                        this.handleSelectedClear
                                                    }
                                                >
                                                    {/* 清空 */}
                                                    {
                                                        this.state
                                                            .jsonInsideRefer[
                                                        'containers-refer-0029'
                                                        ]
                                                    }
                                                </span>
                                                <span
                                                    className="close_btn"
                                                    fieldid={getSysFieldid(
                                                        'close_btn'
                                                    )}
                                                    onClick={() => {
                                                        this.setState({
                                                            selectedShow: false,
                                                        });
                                                    }}
                                                >
                                                    {/* 收起 */}
                                                    {
                                                        this.state
                                                            .jsonInsideRefer[
                                                        'containers-refer-0030'
                                                        ]
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="refer-table"
                                            fieldid={getSysFieldid(
                                                'selected_table'
                                            )}
                                            style={{
                                                height,
                                                // paddingTop: "20px",
                                                padding: '15px 20px 0',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <Table
                                                // lazyload={false}
                                                height={tableRowHeight}
                                                headerHeight={tableRowHeight}
                                                rowKey={(record) =>
                                                    this.getDisplayOrValue(
                                                        record,
                                                        rowKey
                                                    )
                                                }
                                                scroll={{
                                                    x: true,
                                                    y: height - 45 - 1,
                                                }} // 表头 + padding-top = 50
                                                columns={selectColumns}
                                                data={this.getSelections({
                                                    cleanIsLeaf: true,
                                                })}
                                                addBlankCol={false}
                                                bodyStyle={{
                                                    height: height - 45 - 1,
                                                }}
                                                customSort={sort}
                                                // {...emptyText}
                                                className="refer-select-table"
                                                bodyClassName="refer-select-table-scroll-body"
                                                emptyClassName="refer-select-empty" //只要表格为空自动渲染暂无数据？？？
                                                columnWidthConfig={false}
                                                sort={{
                                                    sortFun: this.handleSort,
                                                }}
                                                onDropBorderHandler={
                                                    this.onDropBorderHandler
                                                }
                                            />
                                        </div>
                                    </Panel>
                                </div>
                            </Resizable>
                        </div>
                    </Dnd>
                )}
                {isFirstShow || (
                    <HotKeys
                        keyMap={{
                            add: 'ctrl+/',
                            ok: 'alt+y',
                            cancel: {
                                sequence: ['alt+n', 'esc'],
                                action: 'keyup',
                            },
                            tab: 'tab',
                            space: {
                                sequence: 'space',
                                action: 'keydown',
                            },
                            enter: 'enter',
                            up: 'up',
                            down: 'down',
                            toUsual: 'shift+right',
                            toAll: 'shift+left',
                            pageLeft: 'ctrl+left',
                            pageRight: 'ctrl+right',
                            batchSelectTableRow: ['space+up', 'space+down'],
                            spaceKeyUp: {
                                sequence: 'space',
                                action: 'keyup',
                            },
                            batchSelectTreeNode: {
                                action: 'keyup',
                                sequence: ['space+up', 'space+down'],
                            },
                            test: {
                                sequence: 'space',
                                action: 'keypress',
                            },
                        }}
                        handlers={{
                            add: () => {
                                if (this.getStatus().isShowStatus) {
                                    let { addButtonList } = this.state;

                                    if (Array.isArray(addButtonList)) {
                                        if (addButtonList.length === 1) {
                                            // 直接新增
                                            let {
                                                appcode,
                                                pagecode,
                                                urlParam,
                                            } = addButtonList[0];
                                            pageTo.openTo(null, {
                                                appcode,
                                                pagecode,
                                                status: 'browse',
                                                ...(typeof urlParam ===
                                                    'function' && urlParam()),
                                            });
                                        } else if (addButtonList.length > 1) {
                                            // 展开下拉
                                            this.setState(
                                                ({ isAddButtonShow }) => {
                                                    isAddButtonShow =
                                                        !isAddButtonShow;
                                                    if (isAddButtonShow) {
                                                        this.preActiveElement =
                                                            document.activeElement;
                                                        document.activeElement &&
                                                            document.activeElement.blur();
                                                    } else {
                                                        this.preActiveElement &&
                                                            this.preActiveElement.focus();
                                                        this.preActiveElement =
                                                            null;
                                                    }
                                                    return { isAddButtonShow };
                                                }
                                            );
                                        }
                                    }
                                }
                            },
                            ok: (event) => {
                                if (
                                    this.getStatus().isShowStatus &&
                                    !this.isSureButtonDisabled() && 
                                    this.sureBtnRef?.current
                                ) {
                                    event.preventDefault();
                                    (isMultiSelectedEnabled
                                        ? this.multiSelect
                                        : this.singleSelect.bind(
                                            this,
                                            this.getSelections()[0]
                                        ))(event);
                                    this.handlePopoverBlur();
                                    this.onHotKeyClose();
                                }
                            },
                            cancel: (event) => {
                                if (
                                    !this.popWindow.contains(
                                        document.activeElement
                                    )
                                ) {
                                    return;
                                }
                                if (this.getStatus().isShowStatus) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    if (this.state.filterCondition.isShow) {
                                        this.state.filterCondition.closeFilterModal();
                                    } else {
                                        this.cancel(event);
                                        this.onHotKeyClose();
                                    }
                                }
                            },
                            tab: () => {
                                if (this.getStatus().isShowStatus) {
                                    if (this.state.isMoreButtonShow) {
                                        this.setState(
                                            { isMoreButtonShow: false },
                                            () => {
                                                this.popWindow &&
                                                    this.popWindow.focus();
                                            }
                                        );
                                    }
                                    setTimeout(() => {
                                        this.setState({
                                            selectedRowIndex:
                                                document.activeElement ===
                                                    this.table
                                                    ? 0
                                                    : -1,
                                        });
                                    }, 0);
                                }
                            },
                            space: () => {
                                //如果一直按着space不执行选中效果
                                if (this.spaceKeyPress) {
                                    return;
                                }

                                let isShowStatus =
                                    this.getStatus().isShowStatus;
                                this.spaceKeyDown = true;
                                this.spaceKeyUp = false;

                                if (
                                    isShowStatus &&
                                    document.activeElement.contains(this.table)
                                ) {
                                    let {
                                        selectedValues,
                                        selectedRowIndex,
                                        tableData,
                                    } = this.state,
                                        row =
                                            tableData[0].rows[selectedRowIndex];
                                    if (isMultiSelectedEnabled) {
                                        this.toggleValueForMapOrObject(
                                            selectedValues,
                                            row.refpk,
                                            row
                                        );
                                    } else {
                                        selectedValues = new Map([
                                            [row.refpk, row],
                                        ]);
                                    }
                                    this.setState({
                                        isMultiSelectMode: true,
                                        selectedValues,
                                    });
                                }
                                // if (isShowStatus && this.refTree && this.refTree.contains(document.activeElement)) {
                                //     let key,
                                //         { selectedKeys, expandedKeys, treeData } = this.state,
                                //         { idKey } = this.props;
                                //     if (Array.isArray(selectedKeys) && (key = selectedKeys[0])) {
                                //         let node = treeData.find(e => e[idKey] === key);
                                //         // 单击展开并选中
                                //         expandedKeys = [...new Set([...expandedKeys.concat([key])])];
                                //         // 查下级
                                //         node &&
                                // 			this.loadTreeChildrenDataIfNeeded({ props: { treeNodeData: node } });
                                //         this.setState({ expandedKeys });
                                //     }
                                // }
                            },
                            enter: (event) => {
                                let {
                                    isAddButtonShow,
                                    currentButtonIndex,
                                    addButtonList,
                                    selectedValues,
                                } = this.state;
                                if (
                                    isAddButtonShow &&
                                    currentButtonIndex > -1
                                ) {
                                    let { appcode, pagecode, urlParam } =
                                        addButtonList[currentButtonIndex];
                                    pageTo.openTo(null, {
                                        appcode,
                                        pagecode,
                                        status: 'browse',
                                        ...(typeof urlParam === 'function' &&
                                            urlParam()),
                                    });
                                    this.setState({ isAddButtonShow: false });
                                } else if (this.getStatus().isShowStatus) {
                                    if (
                                        this.moreButtonMenu &&
                                        this.moreButtonMenu.contains(
                                            document.activeElement
                                        )
                                    ) {
                                        return;
                                    }

                                    //由于延时componentWillUnmount先执行,导致this.referInput是 null，因此先保存一下单元格
                                    let td =
                                        this.props.renderInTable &&
                                        this.referInput &&
                                        findParentTd(this.referInput);

                                    event.preventDefault();
                                    let { refType } = this.props,
                                        { selectedRowIndex, tableData } =
                                            this.state,
                                        record =
                                            tableData[0].rows[selectedRowIndex];
                                    if (
                                        refType === 'tree' &&
                                        this.refTree &&
                                        this.refTree.contains(
                                            document.activeElement
                                        )
                                    ) {
                                        // this.onTreeNodeDoubleClick
                                        // enter会触发树的双击事件,这里先执行，click后执行，导致判断出问题，放到click事件中执行
                                        this.triggerTreeNodeDoubleClick = true;
                                        // 这个方法里有个聚焦操作 根据判断条件才调用 避免焦点丢失
                                        // this.onHotKeyClose();
                                    } else if (
                                        refType !== 'tree' &&
                                        this.table &&
                                        this.table.contains(
                                            document.activeElement
                                        )
                                    ) {
                                        // 默认情况下 焦点在表头  record 可能是没有值的 然后就会报错
                                        !record &&
                                            console.log(
                                                '焦点在表头或者没有获取到选中记录！'
                                            );
                                        record &&
                                            this.onRowDoubleClick(
                                                record,
                                                selectedRowIndex,
                                                event
                                            );
                                        record && this.onHotKeyClose();
                                    }

                                    // onEnter 逻辑添加 by bbqin
                                    setTimeout(() => {
                                        let target = td || this.referInput;
                                        // 加一个isShow判断逻辑 弹窗关闭之后才可以跳转
                                        let isShow = this.state.isShow;
                                        let lifecycleStatus =
                                            this.lifecycleStatus;

                                        // 用于解决参照如果enter后出现闪烁的问题
                                        const disableEnter =
                                            document.querySelector(
                                                '.enter-is-disabled'
                                            );

                                        if (
                                            executePopOverEnterSelect({
                                                isShow,
                                                lifecycleStatus,
                                            }) &&
                                            !disableEnter
                                        ) {
                                            this.props.onEnter &&
                                                this.props.onEnter({
                                                    e: event,
                                                    target,
                                                    eventKey: 'Enter',
                                                });
                                        }
                                        // 改成40  保证关闭之后执行
                                    }, 40);
                                }
                            },
                            up: () => {
                                let { isAddButtonShow, addButtonList } =
                                    this.state;
                                if (isAddButtonShow) {
                                    let length = addButtonList.length;
                                    this.setState(({ currentButtonIndex }) => ({
                                        currentButtonIndex:
                                            ((--currentButtonIndex % length) +
                                                length) %
                                            length,
                                    }));
                                } else {
                                    this.onTableKeyPress(true);
                                    if (
                                        document.activeElement ===
                                        this.moreButton
                                    ) {
                                        this.setState({
                                            isMoreButtonShow: false,
                                        });
                                    }
                                }
                            },
                            down: () => {
                                let {
                                    isAddButtonShow,
                                    addButtonList,
                                    isMoreButtonShow,
                                } = this.state;

                                if (isAddButtonShow) {
                                    let length = addButtonList.length;
                                    this.setState(({ currentButtonIndex }) => ({
                                        currentButtonIndex:
                                            ((++currentButtonIndex % length) +
                                                length) %
                                            length,
                                    }));
                                } else {
                                    this.onTableKeyPress(false);
                                    if (
                                        document.activeElement ===
                                        this.moreButton
                                    ) {
                                        if (isMoreButtonShow === true) {
                                            if (this.moreButtonMenu) {
                                                this.moreButtonMenu?.focus();
                                            }
                                        } else {
                                            this.setState(
                                                { isMoreButtonShow: true },
                                                () => {
                                                    let intervalId = null;
                                                    intervalId = setInterval(
                                                        () => {
                                                            if (
                                                                this
                                                                    .moreButtonMenu
                                                            ) {
                                                                this.moreButtonMenu?.focus();
                                                                clearInterval(
                                                                    intervalId
                                                                );
                                                            }
                                                        },
                                                        50
                                                    );
                                                }
                                            );
                                        }
                                    }
                                }
                            },
                            toUsual: () => {
                                if (
                                    this.getStatus().isShowStatus &&
                                    (refType === 'gridTree' ||
                                        refType === 'tree') &&
                                    isShowUsual
                                ) {
                                    this.setState(
                                        { activeKey: '2' },
                                        this.show.bind(this, true)
                                    );
                                    this.popWindow && this.popWindow.focus();
                                }
                            },
                            toAll: () => {
                                if (
                                    this.getStatus().isShowStatus &&
                                    (refType === 'gridTree' ||
                                        refType === 'tree') &&
                                    isShowUsual
                                ) {
                                    this.setState(
                                        { activeKey: '1' },
                                        this.show.bind(this, true)
                                    );
                                    this.popWindow && this.popWindow.focus();
                                }
                            },
                            pageLeft: () => {
                                if (
                                    this.getStatus().isShowStatus &&
                                    refType !== 'tree'
                                ) {
                                    let { tableData } = this.state;
                                    let { page } = tableData[0];
                                    if (page) {
                                        let newPage = --page.pageIndex;
                                        newPage < 0 && (newPage = 0);
                                        this.onPageChange({
                                            pageIndex: newPage + 1,
                                        });
                                    }
                                }
                            },
                            pageRight: () => {
                                if (
                                    this.getStatus().isShowStatus &&
                                    refType !== 'tree'
                                ) {
                                    let { tableData } = this.state;
                                    let { page } = tableData[0];
                                    if (page) {
                                        let newPage = ++page.pageIndex;
                                        newPage > page.totalPage - 1 &&
                                            (newPage = page.totalPage - 1);
                                        this.onPageChange({
                                            pageIndex: newPage + 1,
                                        });
                                    }
                                }
                            },
                            batchSelectTableRow: () => {
                                let isShowStatus =
                                    this.getStatus().isShowStatus;

                                if (
                                    isShowStatus &&
                                    document.activeElement.contains(
                                        this.table
                                    ) &&
                                    this.spaceKeyDown === true
                                ) {
                                    let {
                                        selectedValues,
                                        selectedRowIndex,
                                        tableData,
                                    } = this.state,
                                        row =
                                            tableData[0].rows[selectedRowIndex];

                                    if (isMultiSelectedEnabled) {
                                        this.toggleValueForMapOrObject(
                                            selectedValues,
                                            row.refpk,
                                            row
                                        );
                                    }

                                    this.setState({
                                        isMultiSelectMode: true,
                                        selectedValues,
                                    });
                                }
                            },
                            spaceKeyUp: () => {
                                this.spaceKeyDown = false;
                                this.spaceKeyPress = false;
                            },
                            batchSelectTreeNode: () => {
                                let isShowStatus =
                                    this.getStatus().isShowStatus;

                                if (
                                    isShowStatus &&
                                    this.refTree &&
                                    this.refTree.contains(
                                        document.activeElement
                                    ) &&
                                    this.spaceKeyDown === true
                                ) {
                                    // this.pressOnTreeNode = false;
                                    this.setState(
                                        { isMultiSelectMode: true },
                                        () => {
                                            this.selectTreeNodeWithBatch = true;
                                            let checkboxEl =
                                                document.activeElement.parentElement.querySelector(
                                                    '[treeCheckboxTarget=default-target]'
                                                );
                                            checkboxEl && checkboxEl.click();
                                            this.selectTreeNodeWithBatch = false;
                                        }
                                    );
                                }
                            },
                        }}
                        attach={document.body}
                        focused={true}
                    />
                )}
            </div>,
            newContainer
        );
    };

    // 复写原型方法：渲染弹出层头部
    renderPopoverHeader = () => {
        const { refName, refName_db } = this.props; // 后台要加的
        let { max } = this.state;
        return [
            // <img className="refer-header-img" src={require('../../static/images/modal-img.png')} />,
            <div
                className="refer-title cancel-drag"
                key="1"
                fieldid={getSysFieldid(`${refName_db || refName}_title`)}
            >
                {refName_db || refName}
            </div>,
            <div className="refer-header-extend" key="2">
                {this.renderPopoverHeaderExtend()}
            </div>,
            <Tooltip
                placement="top"
                overlay={this.state.jsonInsideRefer['containers-refer-refresh']}
                delayHide={1}
                delayShow={1000}
            >
                <div
                    className="refer-refresh iconfont icon-shuaxin1 cancel-drag"
                    onClick={debounce(this.refresh, 500)}
                    key="3"
                />
            </Tooltip>,
            <Tooltip
                placement="top"
                overlay={
                    max
                        ? this.state.jsonInsideRefer[
                        'containers-refer-reduction'
                        ]
                        : this.state.jsonInsideRefer['containers-refer-max']
                }
                delayHide={1}
                delayShow={1000}
            >
                <div
                    className={`refer-max iconfont ${max ? 'icon-zuixiaohua' : 'icon-zuidahua'
                        } cancel-drag`}
                    onClick={() => {
                        this.max();
                    }}
                    key="4"
                />
            </Tooltip>,
            <Tooltip
                placement="top"
                overlay={this.state.jsonInsideRefer['containers-refer-close']}
                delayHide={1}
                delayShow={1000}
            >
                <div
                    className="refer-close iconfont icon-guanbi cancel-drag"
                    onClick={this.cancel}
                    key="5"
                />
            </Tooltip>,
        ];
    };

    // 调用与【常用】相关的一系列接口
    usualAction = async (action, pk, index, useStarFlag, rowpk) => {
        const { queryGridUrl, usualDataSize, pageid, ts } = this.props;
        let { selectedValues, tableData, collectUsualData } = this.state;
        let param = { queryCondition: { UsualActionURL: queryGridUrl } },
            url;
        param.pageid = pageid;
        param.ts = ts;
        let useUsualCache = false;
        switch (action) {
            case 'save':
                let data = await this.loadUsualData(false, useUsualCache),
                    dataLength = data.rows.length,
                    totalLength = dataLength + this.getSelections().length;
                if (totalLength > usualDataSize) {
                    toast({
                        color: 'warning',
                        content: this.state.jsonInsideRefer[
                            'containers-refer-0042'
                        ]
                            .replace('${0042-a}', totalLength - usualDataSize)
                            .replace('${0042-b}', usualDataSize),
                    });
                    return;
                } else {
                    url = SAVE_USUAL_URL;
                    param.queryCondition.UsualActionPks = [
                        ...selectedValues.keys(),
                        // ...collectUsualData.keys(),
                    ].join(','); //若是星标直接收藏，这这里就不能用selectedValues,把点击的值传进来处理，取消收藏时候同delete
                }
                break;
            case 'clear':
                url = DELETE_USUAL_URL;
                param.queryCondition.UsualActionPks = tableData[0].rows
                    .map((e) => e.refpk)
                    .join(',');
                break;
            case 'delete':
                url = DELETE_USUAL_URL;
                param.queryCondition.UsualActionPks = pk;
                break;
            default:
                throw new Error("'action' expect 'save', 'clear', or 'delete'");
        }
        if (!param.queryCondition.UsualActionPks) {
            // 您还没有选择数据
            toast({
                color: 'warning',
                content: this.state.jsonInsideRefer['containers-refer-0013'],
            });
            return;
        }
        ajax({
            url,
            data: param,
            loading: false,
            success: (res) => {
                if (res.success) {
                    let content = String(res.data || '');
                    if (action === 'delete') {
                        selectedValues.delete(pk);
                        collectUsualData.delete(pk);
                        tableData[0].rows.splice(index, 1);
                        content = this.state.jsonInsideRefer['containers-refer-0066'];
                    } else if (action === 'clear') {
                        tableData[0].rows.forEach((e) => {
                            selectedValues.delete(e.refpk);
                            collectUsualData.delete(e.refpk);
                        });
                        tableData[0].rows = [];
                    } else if (action === 'save') {
                        [...selectedValues.values()].forEach((e) => {
                            collectUsualData.set(e.refpk, e);
                        });
                        content = this.state.jsonInsideRefer['containers-refer-0067'];
                    }
                    this.setState({
                        tableData,
                        selectedValues,
                        collectUsualData,
                        loading: false,
                    });
                    toast({
                        color: 'success',
                        content: content,
                    });
                } else {
                    this.setState({ loading: false });
                    // throw new Error(res.error.message);
                }
            },
            error: (e) => {
                toast({ color: 'danger', content: e.message });
                this.setState({ loading: false });
                // throw new Error(e);
            },
        });
    };

    //收藏与常用按钮关联
    usualCollectAction = async (action, pk, index, useStarFlag, rowpk) => {
        const { queryGridUrl, usualDataSize, pageid, ts } = this.props;
        let { selectedValues, tableData, collectUsualData, activeKey } =
            this.state;
        let param = { queryCondition: { UsualActionURL: queryGridUrl } },
            url;
        param.pageid = pageid;
        param.ts = ts;
        let useUsualCache = false; //这里用缓存不行啊，每次的请求参数都是一样的，每次都不发请求可还行

        switch (action) {
            case 'save':
                let data = await this.loadUsualData(false, useUsualCache),
                    dataLength = data.rows.length,
                    totalLength = dataLength + this.getSelections().length,
                    collectUsualKeys = [];
                if (JSON.stringify(data) !== '{}' && data.rows) {
                    data.rows.forEach((e) => {
                        collectUsualKeys.push(e.refpk);
                        collectUsualData.set(e.refpk, e);

                        // this.toggleValueForMapOrObject(
                        //     collectUsualData,
                        //     e.refpk,
                        //     e
                        // );
                    });
                }

                if (totalLength > usualDataSize) {
                    toast({
                        color: 'warning',
                        content: this.state.jsonInsideRefer[
                            'containers-refer-0042'
                        ]
                            .replace('${0042-a}', totalLength - usualDataSize)
                            .replace('${0042-b}', usualDataSize),
                    });
                    return;
                } else {
                    url = SAVE_USUAL_URL;
                    param.queryCondition.UsualActionPks = [
                        rowpk.refpk,
                        // ...collectUsualData.keys(),
                        // ...collectUsualKeys,
                    ].join(','); //若是星标直接收藏，这这里就不能用selectedValues,把点击的值传进来处理，取消收藏时候同delete,,该接口可以传递多个值，但传递的值中若包含已常用的值时，该设置不生效
                }
                break;
            case 'clear':
                url = DELETE_USUAL_URL;
                param.queryCondition.UsualActionPks = tableData[0].rows
                    .map((e) => e.refpk)
                    .join(',');
                break;
            case 'delete':
                url = DELETE_USUAL_URL;
                param.queryCondition.UsualActionPks = pk;
                break;
            default:
                throw new Error("'action' expect 'save', 'clear', or 'delete'");
        }
        if (!param.queryCondition.UsualActionPks) {
            // 您还没有选择数据
            toast({
                color: 'warning',
                content: this.state.jsonInsideRefer['containers-refer-0013'],
            });
            return;
        }
        ajax({
            url,
            data: param,
            loading: false,
            success: (res) => {
                if (res.success) {
                    if (action === 'delete') {
                        collectUsualData.delete(pk);
                        // tableData[0].rows.splice(index, 1);//取消星标收藏，不用更新表格的数据量

                        toast({
                            color: 'success',
                            content:
                                this.state.jsonInsideRefer[
                                'containers-refer-0066'
                                ],
                        });

                        // if (activeKey == 2) {
                        //     if (collectUsualData.size > 0) {
                        //         this.checkUsual();
                        //     }
                        // }
                    } else if (action === 'clear') {
                        tableData[0].rows.forEach((e) => {
                            collectUsualData.delete(e.refpk);
                        });
                        tableData[0].rows = [];
                    } else if (action === 'save') {
                        // this.toggleValueForMapOrObject(
                        //     collectUsualData,
                        //     rowpk.refpk,
                        //     rowpk
                        // );
                        collectUsualData.set(rowpk.refpk, rowpk);

                        toast({
                            color: 'success',
                            content:
                                this.state.jsonInsideRefer[
                                'containers-refer-0067'
                                ],
                        });
                    }
                    this.setState({
                        // tableData,
                        collectUsualData,
                        loading: false,
                    }); //这里返回的数据能更新collectUsualData的值？？
                    // toast({
                    //     color: 'success',
                    //     content: String(res.data || ''),
                    // });
                } else {
                    this.setState({ loading: false });
                    // throw new Error(res.error.message);
                }
            },
            error: (e) => {
                toast({ color: 'danger', content: e.message });
                this.setState({ loading: false });
                // throw new Error(e);
            },
        });
    };

    // 渲染：【全部 or 常用页签】
    renderTabs = (key) => {
        let { activeKey } = this.state;
        const { refType, isShowUsual, pageSize } = this.props;
        return (
            // isShowUsual &&
            // activeKey === key &&
            isShowUsual &&
            (refType === 'grid' ? (
                <div
                    className="refer-search-left-area"
                    style={{ marginRight: '28px' }}
                    key="1"
                >
                    {
                        <div className={`refer-left-tab refer-left-tab-map`}>
                            <Tabs
                                tabIndex={this.getTabIndex(
                                    this.hotKeyElement.tabs
                                )}
                                activeKey={activeKey}
                                onChange={(k) => {
                                    this.sortCol = null;
                                    this.setState(
                                        {
                                            activeKey: k,
                                            tableData: [
                                                {
                                                    rows: [],
                                                    page: {
                                                        pageIndex: 0,
                                                        pageSize,
                                                        totalPage: 1,
                                                    },
                                                },
                                            ],
                                        },
                                        this.show.bind(this, true)
                                    );
                                }}
                            >
                                {/* 全部 */}
                                <TabPane
                                    tab={
                                        this.state.jsonInsideRefer[
                                        'containers-refer-0015'
                                        ]
                                    }
                                    key="1"
                                />
                                {/* 常用 */}
                                <TabPane
                                    tab={
                                        this.state.jsonInsideRefer[
                                        'containers-refer-0014'
                                        ]
                                    }
                                    key="2"
                                />
                            </Tabs>
                        </div>
                    }
                </div>
            ) : (
                <div
                    className="refer-search-left-area"
                    key="1"
                    style={refType === 'gridTree' ? { marginTop: '2px' } : {}}
                >
                    {refType === 'gridTree' && (activeKey !== '1' || key) && (
                        <div
                            className={`refer-left-tab ${activeKey == 2 && 'refer-left-tab-map-usual'
                                }`}
                        >
                            <Tabs
                                tabIndex={this.getTabIndex(
                                    this.hotKeyElement.tabs
                                )}
                                activeKey={activeKey}
                                onChange={(k) => {
                                    this.sortCol = null;
                                    this.setState(
                                        {
                                            activeKey: k,
                                            loading: false,
                                            tableData: [
                                                {
                                                    rows: [],
                                                    page: {
                                                        pageIndex: 0,
                                                        pageSize,
                                                        totalPage: 1,
                                                    },
                                                },
                                            ],
                                        },
                                        this.show.bind(this, true)
                                    );
                                }}
                            >
                                {/* 全部 */}
                                <TabPane
                                    tab={
                                        this.state.jsonInsideRefer[
                                        'containers-refer-0015'
                                        ]
                                    }
                                    key="1"
                                />
                                {/* 常用 */}
                                <TabPane
                                    tab={
                                        this.state.jsonInsideRefer[
                                        'containers-refer-0014'
                                        ]
                                    }
                                    key="2"
                                />
                                {/* 
                                最近使用
                                <TabPane tab={'最近使用'} key="3" /> */}
                            </Tabs>
                        </div>
                    )}
                </div>
            ))
        );
    };

    // 渲染：【搜索grid的搜索框】
    renderSearchTableInput = () => {
        let { searchVal, columnConfig } = this.state;
        let {
            name: names,
            search = {},
            fullTxtCode,
            fullTxtCodeDisable = [],
        } = columnConfig[0];
        names = names && JSON.parse(JSON.stringify(names));
        const {
            refType,
            refName,
            refName_db, // 后台要加的
            isShowTableSearch,
            allowSearchConfig,
            searchTrigger,
        } = this.props;
        let a = classNames({
            'refer-search-table-input': true,
            'refer-search-table-input-padding': refType == 'gridTree',
        });
        const liArray = allowSearchConfig && columnConfig[0].code
            .filter((e, i) => {
                if (fullTxtCode && !fullTxtCode.hasOwnProperty(e)) {
                    names[i] = '';
                }
                return !(fullTxtCode && !fullTxtCode.hasOwnProperty(e));
            })
            .map((e, i) => {
                names = names.filter(e => e);
                let name = names[i];
                return (
                    <li
                        className="refer-search-config-item"
                        // title={e} //王晓测试说显示有意义的提示（bs），先注掉
                        key={e}
                    >
                        <label>
                            <Checkbox
                                tabIndex="-1"
                                checked={
                                    e === 'refname' ||
                                    e === 'refcode' ||
                                    (search || {})[e] ||
                                    (
                                        !(search || {}).hasOwnProperty(e) &&
                                        fullTxtCode &&
                                        fullTxtCode[e]
                                    )
                                }
                                value={e}
                                onClick={evt => {
                                    evt.stopPropagation();
                                    search[e] = !(search[e] === true);
                                    columnConfig[0].search = search;
                                    this.setState({ columnConfig },
                                        () => { this.pushToColumnConfig(); },
                                    );
                                }}
                                disabled={
                                    e === 'refname' ||
                                    e === 'refcode' ||
                                    fullTxtCodeDisable.includes(e)
                                }
                            >
                                {name}
                            </Checkbox>
                        </label>
                    </li>
                );
            }) || [];

        let searchPadding = '0px';
        if (searchVal && allowSearchConfig && liArray.length > 0) {
            searchPadding = '60px';
        } else if (searchVal || (allowSearchConfig && liArray.length > 0)) {
            searchPadding = '40px';
        } else {
            searchPadding = '24px';
        }
        return (
            refType !== 'tree' &&
            isShowTableSearch && (
                <div className={a} key="2">
                    <FormControl
                        className={`search-input ${GRID_TREE_SEARCH_INPUT}`}
                        style={{ paddingRight: searchPadding }}
                        // 搜索
                        placeholder={`${this.state.jsonInsideRefer[
                            'containers-refer-0016'
                        ]?.replace('{1}', refName_db || refName)}`}
                        value={searchVal}
                        onClick={(e) => {
                            let ncc_automated = getGlobalStorage(
                                'localStorage',
                                '_ncc_automated_'
                            );
                            if (ncc_automated == '1') {
                                // 自动化测试开关打开
                                let v = e.target.value;
                                this.popSearchTable(v);
                            }
                        }}
                        onChange={(v) => {
                            this.setState({ searchVal: v });
                            let ncc_automated = getGlobalStorage(
                                'localStorage',
                                '_ncc_automated_'
                            );
                            if (ncc_automated != '1') {
                                // 自动化测试开关关闭
                                if (searchTrigger === 'input') {
                                    this.interval = new Date().getTime();
                                    let s = setTimeout(() => {
                                        // 停止输入0.5s后执行
                                        if (
                                            new Date().getTime() -
                                            this.interval >=
                                            500
                                        ) {
                                            this.popSearchTable(v);
                                        }
                                        clearTimeout(s);
                                    }, 500);
                                }
                            }
                        }}
                        tabIndex={this.getTabIndex(
                            this.hotKeyElement.tableSearchInput
                        )}
                        onKeyDown={this.resetHotKeyLoop.bind(
                            this,
                            this.hotKeyElement.tableSearchInput
                        )}
                        ref={(dom) => {
                            this.searchTableInput = ReactDOM.findDOMNode(dom);
                        }}
                        fieldid={getSysFieldid('search')}
                    />
                    <Tooltip
                        placement="top"
                        overlay={
                            this.state.jsonInsideRefer[
                            'containers-refer-search'
                            ]
                        }
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i
                            className="refer-search-i iconfont icon-sousuo"
                            onClick={() => {
                                if (searchTrigger === 'click') {
                                    //默认searchTrigger为input
                                    this.popSearchTable(this.state.searchVal);
                                }
                            }}
                        />
                    </Tooltip>
                    {searchVal && (
                        <Tooltip
                            placement="top"
                            overlay={
                                this.state.jsonInsideRefer[
                                'containers-refer-clear'
                                ]
                            }
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className="refer-del-i refer-tree-del-i iconfont icon-qingkong"
                                style={{ marginRight: (allowSearchConfig && liArray.length > 0) ? 20 : 0 }}
                                onClick={() => {
                                    this.popSearchTable('');
                                    this.setState({ searchVal: '' });
                                    this.searchTableInput.focus();
                                }}
                            />
                        </Tooltip>
                    )}
                    {/* 搜索设置 */}
                    {/* {false && ( */}
                    {allowSearchConfig && liArray.length > 0 && (
                        <Popover
                            container={this.popover ? this.popover : null}
                            className="popover-in-refer popover-for-search-config"
                            trigger="click"
                            placement="bottom"
                            content={
                                <div
                                    fieldid={getSysFieldid(
                                        'search-config_list'
                                    )}
                                    className="refer-popover-container search-config"
                                >
                                    <ul className="search-config-ul">
                                        {liArray}
                                    </ul>
                                    <div
                                        className="refer-dnd-bottom"
                                    // style={{ paddingLeft: '138px' }}
                                    >
                                        <span
                                            className="to-default"
                                            onClick={() => {
                                                this.resetSearchColumnConfig();
                                            }}
                                        >
                                            {/* 恢复默认 */}
                                            {
                                                this.state.jsonInsideRefer[
                                                'containers-refer-0005'
                                                ]
                                            }
                                        </span>
                                    </div>
                                </div>
                            }
                        >
                            <Tooltip
                                placement="top"
                                overlay={
                                    this.state.jsonInsideRefer[
                                    'containers-refer-setting'
                                    ]
                                }
                                delayHide={1}
                                delayShow={1000}
                            >
                                <i
                                    className="search-setting iconfont icon-shezhi"
                                    style={{ display: 'block' }}
                                />
                            </Tooltip>
                        </Popover>
                    )}
                </div>
            )
        );
    };

    // 渲染：【显示停用】dom
    renderShowDisabledData = () => {
        const {
            isShowDisabledData,
            isHasDisabledData,
            refType,
            isMultiSelectedEnabled,
            onlyLeafCanSelect,
            isTreelazyLoad,
        } = this.props;
        let className = 'include-isShowDisabledData';
        if (
            refType === 'tree' &&
            isMultiSelectedEnabled &&
            !onlyLeafCanSelect &&
            !isTreelazyLoad
        ) {
            className += ' isShowDisabledData-border';
        }
        return (
            isHasDisabledData &&
            isShowDisabledData && (
                <Checkbox
                    className={className}
                    checked={this.state.isShowDisabledData}
                    disabled={this.state.isDisabledDataDisabled}
                    onClick={() => {
                        this.setState(
                            {
                                isShowDisabledData:
                                    !this.state.isShowDisabledData,
                            },
                            () => {
                                // 不传true 会整个弹窗重新渲染，位置归位，如有其他问题最好不要调整这个位置
                                this.show(true);
                            }
                        );
                    }}
                    tabIndex={this.getTabIndex(
                        this.hotKeyElement.showDisabledData
                    )}
                    onKeyDown={this.resetHotKeyLoop.bind(
                        this,
                        this.hotKeyElement.showDisabledData
                    )}
                    ref={(dom) => {
                        this.disableDataCheckbox = ReactDOM.findDOMNode(dom);
                    }}
                >
                    {typeof isShowDisabledData === 'string'
                        ? isShowDisabledData
                        : // 显示停用
                        this.state.jsonInsideRefer['containers-refer-0017']}
                </Checkbox>
            )
        );
    };

    // 渲染：【包含下级】dom
    renderIncludeChildren = () => {
        const {
            refType,
            isMultiSelectedEnabled,
            onlyLeafCanSelect,
            isTreelazyLoad,
            isShowIncludeChildren,
        } = this.props;
        return (
            isShowIncludeChildren &&
            isMultiSelectedEnabled &&
            refType === 'tree' &&
            !onlyLeafCanSelect &&
            !isTreelazyLoad && (
                <Checkbox
                    className="include-children"
                    checked={this.state.includeChildren}
                    onClick={() => {
                        // 点包含下级时，变为多选模式
                        let { includeChildren, includeSon } = this.state;
                        if (!includeChildren) {
                            includeSon = false;
                        }
                        this.setState({
                            includeSon,
                            includeChildren: !includeChildren,
                            isMultiSelectMode: true,
                        });
                    }}
                    tabIndex={this.getTabIndex(
                        this.hotKeyElement.includeChildren
                    )}
                    onKeyDown={this.resetHotKeyLoop.bind(
                        this,
                        this.hotKeyElement.includeChildren
                    )}
                    ref={(dom) => {
                        this.includeAllCheckbox = ReactDOM.findDOMNode(dom);
                    }}
                >
                    {/* 包含下级 */}
                    {this.state.jsonInsideRefer['containers-refer-0018']}
                </Checkbox>
            )
        );
    };

    // 渲染：【包含直接下级】dom
    renderIncludeSon = () => {
        const {
            refType,
            isMultiSelectedEnabled,
            onlyLeafCanSelect,
            isTreelazyLoad,
            isShowIncludeSon,
        } = this.props;
        let themeName = getTheme(false);
        let donghuaClass =
            themeName === 'black'
                ? 'dark donghua-container'
                : 'donghua-container';
        return (
            isShowIncludeSon &&
            isMultiSelectedEnabled &&
            refType === 'tree' &&
            !onlyLeafCanSelect &&
            !isTreelazyLoad && (
                <div
                    className={`include-son-container ${this.state.largeSizeMore ? 'shuxian' : ''
                        }`}
                >
                    <Checkbox
                        className="include-son"
                        checked={this.state.includeSon}
                        onClick={() => {
                            // 点包含直接下级时，变为多选模式
                            let { includeChildren, includeSon } = this.state;
                            if (!includeSon) {
                                includeChildren = false;
                            }
                            this.setState({
                                includeChildren,
                                includeSon: !includeSon,
                                isMultiSelectMode: true,
                            });
                        }}
                        tabIndex={this.getTabIndex(
                            this.hotKeyElement.includeSon
                        )}
                        onKeyDown={this.resetHotKeyLoop.bind(
                            this,
                            this.hotKeyElement.includeSon
                        )}
                        ref={(dom) => {
                            this.includeSonCheckbox = ReactDOM.findDOMNode(dom);
                        }}
                    >
                        {/* 包含直接下级 */}
                        {this.state.jsonInsideRefer['containers-refer-0062']}
                    </Checkbox>
                    {
                        <Popover
                            placement="bottomRight"
                            className="include-son-tips"
                            arrowPointAtCenter={true}
                            // container={this.popWindow}
                            content={
                                <div className="refer-shuoming">
                                    <div className="shuoming-container">
                                        <p>
                                            {
                                                this.state.jsonInsideRefer[
                                                'containers-refer-0063'
                                                ]
                                            }
                                        </p>
                                        <p>
                                            {
                                                this.state.jsonInsideRefer[
                                                'containers-refer-0064'
                                                ]
                                            }
                                        </p>
                                    </div>
                                    <div className={donghuaClass}></div>
                                </div>
                            }
                        >
                            <i
                                className="iconfont icon-bangzhutishi nc-theme-refer-font-c"
                                style={{ cursor: 'pointer' }}
                            />
                        </Popover>
                    }
                </div>
            )
        );
    };

    selectLeaf = () => {
        let { treeData } = this.state;
        this.setState({
            selectedValues: new Map(
                treeData.filter((e) => e.isleaf).map((e) => [e.refpk, e])
            ),
        });
    };

    selectSection = (start, end) => {
        let { treeData } = this.state;
        this.setState({
            selectedValues: new Map(
                treeData
                    .filter((e) => e.level >= start && e.level <= end)
                    .map((e) => [e.refpk, e])
            ),
        });
    };

    // 渲染：【更多按钮】dom
    renderMoreButton = () => {
        let { treeData, selectLevel } = this.state;
        const { isMultiSelectedEnabled, refType, idKey, isTreelazyLoad, showSelectLevel = true } =
            this.props;
        if (!(refType === 'tree' && !isTreelazyLoad)) {
            return;
        }
        // let maxLevel = Math.max(...treeData.map((e) => e.level || 0)),
        let maxLevel = treeData
            .map((e) => e.level || 0)
            .reduce((a, b) => Math.max(a, b), -Infinity),
            currentLevel,
            arr = [...new Array(maxLevel)].map((e, i) => i + 1);

        const menu = (
            <Menu
                key={this.state.moreMenuKey}
                keyboard
                tabIndex={this.getTabIndex(this.hotKeyElement.moreButton)}
                ref={(dom) => {
                    this.moreButtonMenu = ReactDOM.findDOMNode(dom);
                }}
                // openKeys={this.state.openKeys}
                // onOpenChange={(openKeys)=>{
                // 	this.setState({openKeys})
                // }}
                // vertical
                onClick={({ key }) => {
                    this.moreButton && this.moreButton.focus();
                    this.setState({
                        isMoreButtonShow: false,
                        moreMenuKey: getSafeRandom(),
                    });
                    if (key === 'select-leaf') {
                        this.selectLeaf();
                    } else if (key === 'expandAll') {
                        this.setState({
                            expandedKeys: treeData.map((e) => e[idKey]),
                        });
                    } else if (key === 'unExpandAll') {
                        this.setState({ expandedKeys: [] });
                    } else if (key && key.indexOf('expand') !== -1) {
                        currentLevel = Number(key.split('expand')[1]);
                        this.setState({
                            expandedKeys: treeData
                                .filter((e) => e.level <= currentLevel - 1)
                                .map((e) => e[idKey]),
                        });
                    } else if (key && key.indexOf('select') !== -1) {
                        currentLevel = Number(key.split('select')[1]);
                        this.setState({
                            selectedValues: new Map(
                                treeData
                                    .filter((e) => e.level === currentLevel)
                                    .map((e) => [e.refpk, e])
                            ),
                        });
                    }
                }}
            >
                {/* 全部展开 */}
                <Item
                    key="expandAll"
                    title={this.state.jsonInsideRefer['containers-refer-0006']}
                >
                    {this.state.jsonInsideRefer['containers-refer-0006']}
                </Item>
                {/* 全部收起 */}
                <Item
                    key="unExpandAll"
                    title={this.state.jsonInsideRefer['containers-refer-0007']}
                >
                    {this.state.jsonInsideRefer['containers-refer-0007']}
                </Item>
                {/* 级次展开 */}
                {!!arr.length && (
                    <SubMenu
                        key="3"
                        title={
                            this.state.jsonInsideRefer['containers-refer-0008']
                        }
                        popupClassName="refer-select-menu fieldid_more_btn_list"
                    >
                        {arr.map((e) => (
                            <Item
                                key={`expand${e}`}
                                title={(
                                    this.state.jsonInsideRefer[
                                    'containers-refer-0009'
                                    ] || ''
                                ).replace('${0009}', e)}
                            >
                                {/* 展开***级 */}
                                {(
                                    this.state.jsonInsideRefer[
                                    'containers-refer-0009'
                                    ] || ''
                                ).replace('${0009}', e)}
                            </Item>
                        ))}
                    </SubMenu>
                )}
                {!!arr.length && isMultiSelectedEnabled && showSelectLevel && (
                    // 级次选择
                    <SubMenu
                        key="4"
                        title={
                            this.state.jsonInsideRefer['containers-refer-0010']
                        }
                        popupClassName="refer-select-menu fieldid_more_btn_list"
                    >
                        {arr.map((e) => (
                            <Item
                                key={`select${e}`}
                                title={(
                                    this.state.jsonInsideRefer[
                                    'containers-refer-0011'
                                    ] || ''
                                ).replace('${0011}', e)}
                            >
                                {/* 选择***级 */}
                                {(
                                    this.state.jsonInsideRefer[
                                    'containers-refer-0011'
                                    ] || ''
                                ).replace('${0011}', e)}
                            </Item>
                        ))}
                        <Item
                            key={`select-leaf`}
                            title={
                                this.state.jsonInsideRefer[
                                'containers-refer-0050'
                                ] || ''
                            }
                        >
                            {/* 选择末级 */}
                            {this.state.jsonInsideRefer[
                                'containers-refer-0050'
                            ] || ''}
                        </Item>
                    </SubMenu>
                )}
                {!!arr.length && isMultiSelectedEnabled && showSelectLevel && (
                    // 自定义级次选择
                    <SubMenu
                        key="5"
                        title={
                            this.state.jsonInsideRefer['containers-refer-0049']
                        }
                        popupClassName="refer-custom-select-menu"
                    >
                        <Item key="custom-select">
                            <div
                                className="custom-select"
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                ref={(dom) => {
                                    this.customSelect = dom;
                                }}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                            >
                                <div className="custom-select-panel">
                                    <div>
                                        {/* 开始级次 */}
                                        <div className="custom-select-from" title={this.state.jsonInsideRefer['containers-refer-0051']}>
                                            {this.state.jsonInsideRefer['containers-refer-0051']}
                                        </div>
                                        <div className="custom-select-level">
                                            <ul>
                                                {arr.map((level) => (
                                                    <li
                                                        onClick={() => {
                                                            selectLevel[0] =
                                                                level;
                                                            this.setState({
                                                                selectLevel,
                                                            });
                                                        }}
                                                        className={
                                                            selectLevel[0] ===
                                                            level &&
                                                            'custom-select-level-active'
                                                        }
                                                    >
                                                        {level}
                                                        {
                                                            this.state
                                                                .jsonInsideRefer[
                                                            'containers-refer-0053'
                                                            ]
                                                        }
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="custom-select-middle-line"></div>
                                    <div>
                                        {/* 结束级次 */}
                                        <div className="custom-select-to" title={this.state.jsonInsideRefer['containers-refer-0052']}>
                                            {this.state.jsonInsideRefer['containers-refer-0052']}
                                        </div>
                                        <div className="custom-select-level">
                                            <ul>
                                                {arr.map((level) => (
                                                    <li
                                                        onClick={() => {
                                                            selectLevel[1] =
                                                                level;
                                                            this.setState({
                                                                selectLevel,
                                                            });
                                                        }}
                                                        className={
                                                            selectLevel[1] ===
                                                            level &&
                                                            'custom-select-level-active'
                                                        }
                                                    >
                                                        {level}
                                                        {
                                                            this.state
                                                                .jsonInsideRefer[
                                                            'containers-refer-0053'
                                                            ]
                                                        }
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="custom-select-button-area">
                                    <span
                                        className="custom-select-sure"
                                        onClick={() => {
                                            if (
                                                selectLevel[0] > selectLevel[1]
                                            ) {
                                                toast({
                                                    color: 'danger',
                                                    content:
                                                        this.state
                                                            .jsonInsideRefer[
                                                        'containers-refer-0054'
                                                        ],
                                                });
                                                // return false;
                                            } else {
                                                this.selectSection(
                                                    ...selectLevel
                                                );
                                            }
                                            this.setState({
                                                isMoreButtonShow: false,
                                                openKeys: [],
                                                moreMenuKey: getSafeRandom(),
                                            });
                                        }}
                                    // 确定
                                    >
                                        {
                                            this.state.jsonInsideRefer[
                                            'containers-refer-0032'
                                            ]
                                        }
                                    </span>
                                    {/* <span 
										className="custom-select-cancel"
										onClick={() => {

										}}
										// 取消
									>{this.state.jsonInsideRefer['containers-refer-0033']}</span> */}
                                </div>
                            </div>
                        </Item>
                    </SubMenu>
                )}
            </Menu>
        );

        return (
            //计算DoM，当更多更多按钮的宽度小于68px时，渲染第二行的那个，否则还是按照原DOM渲染
            //(!this.moreButton || this.moreButton.clientHeight < 20)
            <Dropdown
                // container={document.body}
                className="more"
                // trigger={["click"]}
                placement="bottomCenter"
                overlay={menu}
                delayHide={0.1}
                visible={this.state.isMoreButtonShow}
                // visible={true}
                fieldid="more"
            >
                <div style={{ height: '26px', lineHeight: '26px' }}>
                    <span
                        className="more-button"
                        tabIndex={this.getTabIndex(
                            this.hotKeyElement.moreButton
                        )}
                        ref={(dom) => {
                            this.moreButton = dom;
                        }}
                        onKeyDown={this.resetHotKeyLoop.bind(
                            this,
                            this.hotKeyElement.moreButton
                        )}
                    >
                        {/* 更多 */}
                        {this.state.jsonInsideRefer['containers-refer-0012']}
                    </span>
                </div>
            </Dropdown>
        );
    };

    // 渲染：【设为常用】dom
    renderSetToUsual = () => {
        let { activeKey } = this.state;
        const { refType, isShowUsual } = this.props;
        return (
            isShowUsual &&
            (refType === 'gridTree' || refType === 'grid') && (
                <Button
                    className={`set-to-usual ${activeKey == '2' ? 'clear' : ''
                        }`}
                    onClick={this.usualAction.bind(
                        this,
                        activeKey == '2' ? 'clear' : 'save'
                    )}
                    fieldid={activeKey == '2' ? 'clear' : 'setusual'}
                >
                    {activeKey == '2'
                        ? // 清空
                        this.state.jsonInsideRefer['containers-refer-0019']
                        : // 设为常用
                        this.state.jsonInsideRefer['containers-refer-0020']}
                </Button>
            )
        );
    };

    // 渲染：【列设置】的DOM
    renderColumnConfig = () => {
        let {
            columnConfig,
            showColumnConfigPop,
            currentColumnConfigIndex,
            columnConfigFlag,
            dargname,
            configNamesList,
            jsonInsideRefer,
        } = this.state;
        // { name: names, code: codes, checked = {} } = columnConfig[0],
        let { allowColumnConfig, refType, type, treeConfig } = this.props;

        return (
            <DndColumnConfig
                columnConfig={columnConfig}
                treeConfig={treeConfig}
                showColumnConfigPop={showColumnConfigPop}
                allowColumnConfig={allowColumnConfig}
                refType={refType}
                type={type}
                jsonInsideRefer={jsonInsideRefer}
                pushToColumnConfig={this.pushToColumnConfig}
                resetColumnConfig={this.resetColumnConfig}
                updateColumnConfig={(updateColumnConfig) => {
                    this.setState({ columnConfig: updateColumnConfig });
                }}
                updateColumnConfigPop={(columnConfigPopFlag) => {
                    this.setState({ showColumnConfigPop: columnConfigPopFlag });
                }}
            ></DndColumnConfig>
        );

        // let {
        //         columnConfig,
        //         showColumnConfigPop,
        //         currentColumnConfigIndex,
        //         columnConfigFlag,
        //         dargname,
        //         configNamesList,
        //     } = this.state,
        //     { name: names, code: codes, checked = {} } = columnConfig[0],
        //     { allowColumnConfig, refType } = this.props;

        // configNamesList =
        //     configNamesList.length === 0 ? [...names] : [...configNamesList];

        // setTimeout(() => {
        //     this.dndElement = document.querySelector('.refer-dnd');
        // }, 50);

        // if (
        //     !(
        //         allowColumnConfig &&
        //         refType !== 'tree' &&
        //         Array.isArray(configNamesList) &&
        //         configNamesList.length > 3
        //     )
        // ) {
        //     return;
        // }
        // const list = configNamesList.map((e, i) => {
        //     let code = codes[i];
        //     return (
        //         <div
        //             name={e}
        //             code={code}
        //             key={code}
        //             fieldid={getSysFieldid(code)}
        //             onMouseOver={() => {
        //                 this.setState({
        //                     currentColumnConfigIndex: i,
        //                 });
        //             }}
        //             className={`${
        //                 currentColumnConfigIndex === i &&
        //                 'refer-column-config-hover'
        //             } ${
        //                 configNamesList.length <= 2 && 'refer-column-disabled'
        //             } ${
        //                 this.columnConfigFlag &&
        //                 dargname === e &&
        //                 'refer-column-disabled'
        //             }`}
        //         >
        //             {/* <Checkbox
        //                 onClick={(evt) => {
        //                     evt.stopPropagation();
        //                     checked[code] === false
        //                         ? (checked[code] = true)
        //                         : (checked[code] = false);
        //                     columnConfig[0].checked = checked;
        //                     this.setState({ columnConfig }, () => {
        //                         this.pushToColumnConfig();
        //                     });
        //                 }}
        //                 checked={(checked || {})[code] !== false}
        //                 // disabled={names.length <= 2 ? true : false}
        //             >
        //                 <span title={e}>{e}</span>
        //             </Checkbox> */}
        //             <span>
        //                 <span className="iconfont icon-tuozhuai1 column-config-tuozhuai"></span>
        //                 {checked[code] === false ? (
        //                     <React.Fragment>
        //                         <span
        //                             className="iconfont icon-yincang"
        //                             onClick={(evt) => {
        //                                 evt.stopPropagation();
        //                                 checked[code] === false
        //                                     ? (checked[code] = true)
        //                                     : (checked[code] = false);
        //                                 columnConfig[0].checked = checked;
        //                                 this.setState({ columnConfig }, () => {
        //                                     this.pushToColumnConfig();
        //                                 });
        //                             }}
        //                         ></span>
        //                         <span
        //                             title={e}
        //                             className="refer-column-config-yincang"
        //                         >
        //                             {e}
        //                         </span>
        //                     </React.Fragment>
        //                 ) : (
        //                     <React.Fragment>
        //                         <span
        //                             className="iconfont icon-xianshi"
        //                             onClick={(evt) => {
        //                                 evt.stopPropagation();
        //                                 if (
        //                                     Object.values(checked).filter(
        //                                         (item) => {
        //                                             return item !== false;
        //                                         }
        //                                     ).length <= 1
        //                                 ) {
        //                                     toast({
        //                                         color: 'warning',
        //                                         content: '至少保留一个字段',
        //                                     });
        //                                     return;
        //                                 }
        //                                 checked[code] === false
        //                                     ? (checked[code] = true)
        //                                     : (checked[code] = false);
        //                                 columnConfig[0].checked = checked;

        //                                 this.setState({ columnConfig }, () => {
        //                                     this.pushToColumnConfig();
        //                                 });
        //                             }}
        //                         ></span>
        //                         <span
        //                             className="refer-column-config-xinshi"
        //                             title={e}
        //                         >
        //                             {e}
        //                         </span>
        //                     </React.Fragment>
        //                 )}
        //             </span>

        //             {currentColumnConfigIndex === i && (
        //                 <span>
        //                     {i !== 0 && (
        //                         <Tooltip
        //                             placement="top"
        //                             overlay={
        //                                 this.state.jsonInsideRefer[
        //                                     'containers-refer-0001'
        //                                 ]
        //                             }
        //                             delayHide={1}
        //                             delayShow={1000}
        //                             overlayStyle={{ zIndex: 2000 }}
        //                         >
        //                             <span
        //                                 className={`refer-column-config-opt iconfont icon-xiangshang ${
        //                                     i === 0 &&
        //                                     'refer-column-config-disabled'
        //                                 } ${
        //                                     configNamesList.length <= 2 &&
        //                                     'refer-column-disabled'
        //                                 } ${
        //                                     currentColumnConfigIndex === i &&
        //                                     'refer-column-config-top-hover'
        //                                 }`}
        //                                 onClick={(evt) => {
        //                                     evt.stopPropagation();
        //                                     if (i !== 0) {
        //                                         columnConfig[0].name.splice(
        //                                             i,
        //                                             1
        //                                         );
        //                                         columnConfig[0].code.splice(
        //                                             i,
        //                                             1
        //                                         );
        //                                         columnConfig[0].name.unshift(e);
        //                                         columnConfig[0].code.unshift(
        //                                             code
        //                                         );
        //                                         this.setState(
        //                                             { columnConfig },
        //                                             () => {
        //                                                 this.pushToColumnConfig();
        //                                             }
        //                                         );
        //                                     }
        //                                 }}
        //                             >
        //                                 {/* 置顶 */}
        //                                 {/* {this.state.jsonInsideRefer['containers-refer-0001']} */}
        //                             </span>
        //                         </Tooltip>
        //                     )}
        //                     {i !== codes.length - 1 && (
        //                         <Tooltip
        //                             placement="top"
        //                             overlay={
        //                                 this.state.jsonInsideRefer[
        //                                     'containers-refer-0004'
        //                                 ]
        //                             }
        //                             delayHide={1}
        //                             delayShow={1000}
        //                             overlayStyle={{ zIndex: 2000 }}
        //                         >
        //                             <span
        //                                 className={`refer-column-config-opt iconfont icon-xiangxia
        //                             ${
        //                                 i === codes.length - 1 &&
        //                                 'refer-column-config-disabled'
        //                             } ${
        //                                     currentColumnConfigIndex === i &&
        //                                     'refer-column-config-bottom-hover'
        //                                 }`}
        //                                 onClick={(evt) => {
        //                                     evt.stopPropagation();
        //                                     if (i !== codes.length - 1) {
        //                                         columnConfig[0].name.splice(
        //                                             i,
        //                                             1
        //                                         );
        //                                         columnConfig[0].code.splice(
        //                                             i,
        //                                             1
        //                                         );
        //                                         columnConfig[0].name.push(e);
        //                                         columnConfig[0].code.push(code);
        //                                         this.setState(
        //                                             { columnConfig },
        //                                             () => {
        //                                                 this.pushToColumnConfig();
        //                                             }
        //                                         );
        //                                     }
        //                                 }}
        //                             >
        //                                 {/* 置底 */}
        //                                 {/* {this.state.jsonInsideRefer['containers-refer-0004']} */}
        //                             </span>
        //                         </Tooltip>
        //                     )}
        //                 </span>
        //             )}

        //             {/* <span
        //                 className={`refer-column-config-opt ${
        //                     i === 0 && 'refer-column-config-disabled'
        //                 }`}
        //                 onClick={(evt) => {
        //                     evt.stopPropagation();
        //                     if (i !== 0) {
        //                         columnConfig[0].name.splice(i, 1);
        //                         columnConfig[0].code.splice(i, 1);
        //                         columnConfig[0].name.splice(i - 1, 0, e);
        //                         columnConfig[0].code.splice(i - 1, 0, code);
        //                         this.setState({ columnConfig }, () => {
        //                             this.pushToColumnConfig();
        //                         });
        //                     }
        //                 }}
        //             >

        //             </span>
        //             <span
        //                 className={`refer-column-config-opt ${
        //                     i === codes.length - 1 &&
        //                     'refer-column-config-disabled'
        //                 }`}
        //                 onClick={(evt) => {
        //                     evt.stopPropagation();
        //                     if (i !== codes.length - 1) {
        //                         columnConfig[0].name.splice(i, 1);
        //                         columnConfig[0].code.splice(i, 1);
        //                         columnConfig[0].name.splice(i + 1, 0, e);
        //                         columnConfig[0].code.splice(i + 1, 0, code);
        //                         this.setState({ columnConfig }, () => {
        //                             this.pushToColumnConfig();
        //                         });
        //                     }
        //                 }}
        //             >

        //             </span> */}
        //         </div>
        //     );
        // });
        // return (
        //     <Popover
        //         className="popover-in-refer"
        //         trigger="click"
        //         placement="right"
        //         // container={this.popover ? this.popover : null}
        //         // style={{ display: showColumnConfigPop ? 'unset' : 'none' }}
        //         // show={showColumnConfigPop}
        //         // onHide={() => {
        //         //     this.setState({
        //         //         showColumnConfigPop: false,
        //         //     });
        //         // }}
        //         content={
        //             showColumnConfigPop && (
        //                 <div
        //                     className="refer-popover-container"
        //                     fieldid={getSysFieldid('column-config_list')}
        //                 >
        //                     <div className="column-config-title">
        //                         <span className="column-config-title-name">
        //                             列设置
        //                         </span>
        //                     </div>
        //                     <div
        //                         // style={{ flex: '1 1 auto', overflow: 'auto' }}
        //                         className="refer-config-column-scroll"
        //                     >
        //                         <Dnd
        //                             dragClass="refer-column-config-item"
        //                             dropClass="refer-dnd refer-column-config-list"
        //                             dragingClass="refer-column-config-item-darging"
        //                             list={list}
        //                             onStart={(drag, list) => {
        //                                 if (list) {
        //                                     this.columnConfigFlag = true;
        //                                     let dragColumnConfig = [
        //                                         ...columnConfig,
        //                                     ];

        //                                     dragColumnConfig[0].name = list.map(
        //                                         (e) => e.props.name
        //                                     );
        //                                     dragColumnConfig[0].code = list.map(
        //                                         (e) => e.props.code
        //                                     );
        //                                     let addIndex = drag.source.index;
        //                                     this.addIndex = addIndex;
        //                                     let dargname =
        //                                         dragColumnConfig[0].name[
        //                                             addIndex
        //                                         ];
        //                                     dragColumnConfig[0].name.splice(
        //                                         addIndex,
        //                                         0,
        //                                         dragColumnConfig[0].name[
        //                                             addIndex
        //                                         ]
        //                                     );
        //                                     dragColumnConfig[0].code.splice(
        //                                         addIndex,
        //                                         0,
        //                                         dragColumnConfig[0].code[
        //                                             addIndex
        //                                         ]
        //                                     );

        //                                     let element =
        //                                         document.querySelector(
        //                                             '.refer-dnd'
        //                                         );
        //                                     let copyElement =
        //                                         this.dndElement.children[
        //                                             addIndex
        //                                         ];
        //                                     // copyElement.className = '';
        //                                     // copyElement.transform = '';

        //                                     const referenceElement =
        //                                         element.children[addIndex + 1]; // 插入到第三个子元素之前

        //                                     // element.children.splice(
        //                                     //     addIndex,
        //                                     //     0,
        //                                     //     copyElement
        //                                     // );

        //                                     // const newElement =
        //                                     //     document.createElement('div');
        //                                     // newElement.textContent =
        //                                     //     'New Element';

        //                                     // const referenceElement =
        //                                     //     element.children[2]; // 插入到第三个子元素之前

        //                                     // const newElement =
        //                                     //     document.createElement('div');
        //                                     // newElement.appendChild(
        //                                     //     copyElement.firstChild
        //                                     // );
        //                                     // newElement.textContent =
        //                                     //     'New Element';
        //                                     // newElement.children[0] =
        //                                     //     copyElement;

        //                                     element.insertBefore(
        //                                         copyElement,
        //                                         referenceElement
        //                                     );

        //                                     // element.appendChild(copyElement);

        //                                     // element.insertBefore(
        //                                     //     copyElement,
        //                                     //     element.children[addIndex + 1]
        //                                     // );
        //                                     // Array.prototype.splice.apply(
        //                                     //     element.childNodes,
        //                                     //     [addIndex, 0, copyElement]
        //                                     // );

        //                                     console.log(element);

        //                                     // this.setState({
        //                                     //     configNamesList: [
        //                                     //         ...dragColumnConfig[0].name,
        //                                     //     ],
        //                                     //     dargname,
        //                                     // });

        //                                     // this.setState(
        //                                     //     {
        //                                     //         columnConfig,
        //                                     //         dargname,
        //                                     //     },
        //                                     //     () => {
        //                                     //         this.pushToColumnConfig();
        //                                     //     }
        //                                     // );
        //                                 }
        //                             }}
        //                             onStop={(drag, list) => {
        //                                 if (list) {
        //                                     this.columnConfigFlag = false;
        //                                     columnConfig[0].name = list.map(
        //                                         (e) => e.props.name
        //                                     );
        //                                     columnConfig[0].code = list.map(
        //                                         (e) => e.props.code
        //                                     );

        //                                     // let delIndex = drag.source.index;

        //                                     // if (
        //                                     //     drag.destination.index <
        //                                     //     this.addIndex
        //                                     // ) {
        //                                     //     columnConfig[0].name.splice(
        //                                     //         delIndex + 1,
        //                                     //         1
        //                                     //     );
        //                                     //     columnConfig[0].code.splice(
        //                                     //         delIndex + 1,
        //                                     //         1
        //                                     //     );
        //                                     // } else {
        //                                     //     columnConfig[0].name.splice(
        //                                     //         delIndex,
        //                                     //         1
        //                                     //     );
        //                                     //     columnConfig[0].code.splice(
        //                                     //         delIndex,
        //                                     //         1
        //                                     //     );
        //                                     // }
        //                                     // console.log(columnConfig);
        //                                     let newColumnConfig = [
        //                                         ...columnConfig,
        //                                     ];

        //                                     this.setState(
        //                                         {
        //                                             columnConfig: [
        //                                                 ...newColumnConfig,
        //                                             ],
        //                                             configNamesList: [
        //                                                 ...columnConfig[0].name,
        //                                             ],
        //                                         },
        //                                         () => {
        //                                             this.pushToColumnConfig();
        //                                         }
        //                                     );
        //                                 }
        //                             }}
        //                             fieldid="column-config_list"
        //                         />
        //                     </div>
        //                     <div className="refer-dnd-bottom">
        //                         <span
        //                             className="to-default"
        //                             onClick={() => {
        //                                 this.resetColumnConfig();
        //                             }}
        //                         >
        //                             {/* 恢复默认 */}
        //                             {
        //                                 this.state.jsonInsideRefer[
        //                                     'containers-refer-0005'
        //                                 ]
        //                             }
        //                         </span>
        //                     </div>
        //                 </div>
        //             )
        //         }
        //     >
        //         <Tooltip
        //             placement="top"
        //             overlay={
        //                 this.state.jsonInsideRefer[
        //                     'containers-refer-column-setting'
        //                 ]
        //             }
        //             delayHide={1}
        //             delayShow={1000}
        //         >
        //             <div className="refer-column-config" key="5">
        //                 <span fieldid={getSysFieldid('shezhi_btn')}>
        //                     <i
        //                         className="column-config iconfont icon-shezhi"
        //                         onClick={() => {
        //                             this.setState({
        //                                 showColumnConfigPop: true,
        //                             });
        //                         }}
        //                     />
        //                 </span>
        //             </div>
        //         </Tooltip>
        //     </Popover>
        // );
    };

    // 复写原型方法：渲染弹出层搜索区域
    renderPopoverSearchArea = () => {
        return [
            // 全部 or 常用页签
            this.renderTabs(),
            // 搜索表的搜索框
            this.renderSearchTableInput(),
            // 显示停用
            this.renderShowDisabledData(),
            // 树形参照是否包含下级
            this.renderIncludeChildren(),
            // 树形参照是否包含直接下级
            this.renderIncludeSon(),
            // 树形参照的更多按钮
            this.renderMoreButton(),
            // 搜索区域扩展区
            <div className="refer-search-area-extend" key="4">
                {this.renderPopoverSearchExtendArea()}
            </div>,
            // 设为常用
            this.renderSetToUsual(),
            // 列设置
            this.props.refType !== 'tree' && this.renderColumnConfig(),
        ];
    };

    //渲染下拉面板页签区域
    renderDropDownTabs = () => {
        return [
            // 全部 or 常用页签
            this.renderTabs(),
            // 列设置
            this.renderColumnConfig(),
        ];
    };

    // 复写原型方法：渲染弹出层内容区
    renderPopoverContain = () => {
        const { refType, attrcode, fieldid } = this.props;
        let treeWidth = this.getReferTreeConfig();
        let {
            activeKey,
            max,
            isExpandLeftArea,
            referContentAreaHeight,
            resizeHeight,
        } = this.state;
        let contentAreaHeight = referContentAreaHeight + resizeHeight + 'px';

        return (refType === 'gridTree' || refType === 'grid') &&
            activeKey == 2 ? (
            // 常用
            <Row
                className="refer-content-area"
                style={{
                    width: '100%',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    height: contentAreaHeight,
                }}
            >
                {this.renderPopoverRight()}
            </Row>
        ) : (
            <Row
                className="refer-content-area"
                style={{ height: contentAreaHeight }}
            >
                {refType === 'tree' && (
                    <div
                        style={{
                            width:
                                refType === 'tree'
                                    ? '100%'
                                    : isExpandLeftArea
                                        ? '100%'
                                        : treeWidth,
                        }}
                        fieldid={getSysFieldid(
                            `${fieldid || attrcode}_tree-area`
                        )}
                        className={`refer-tree ${isExpandLeftArea ? 'expand' : ''
                            }`}
                    >
                        {this.renderPopoverLeft()}
                    </div>
                )}
                {/* { refType === 'gridTree' && <div className="refer-expand-left" onClick={this.toggleExpandLeftArea} /> } */}
                {refType === 'grid' && (
                    <div
                        style={{
                            width: isExpandLeftArea
                                ? '0px'
                                : max
                                    ? 'auto'
                                    : refType === 'grid'
                                        ? '640px'
                                        : '780px',
                        }}
                        className={`refer-grid  ${isExpandLeftArea ? 'expand' : ''
                            }`}
                    >
                        <div className="refer-table">
                            {this.renderPopoverRight()}
                        </div>
                    </div>
                )}
                {refType === 'gridTree' && (
                    <DragWidthCom
                        useCache={false}
                        leftDom={
                            // drag  修改为 继承父元素的

                            <div
                                style={{
                                    width:
                                        refType === 'tree'
                                            ? '100%'
                                            : isExpandLeftArea
                                                ? '100%'
                                                : '100%',
                                }}
                                fieldid={getSysFieldid(
                                    `${fieldid || attrcode}_tree-area`
                                )}
                                className={`refer-tree ${isExpandLeftArea ? 'expand' : ''
                                    }`}
                            >
                                {this.renderPopoverLeft()}
                            </div>
                        }
                        showExpandBtn={false}
                        defLeftWid={treeWidth}
                        onDragStop={(width) => {
                            this.pushToReferTreeConfig(width);
                            this.forceUpdate();
                        }}
                        rightDom={
                            // refType === 'gridTree' && <div className="refer-expand-left" onClick={this.toggleExpandLeftArea} />
                            // drag  修改为 继承父元素的
                            <div
                                style={{
                                    width: isExpandLeftArea
                                        ? '0px'
                                        : max
                                            ? 'auto'
                                            : refType === 'grid'
                                                ? '640px'
                                                : '100%',
                                }}
                                className={`refer-grid  ${isExpandLeftArea ? 'expand' : ''
                                    }`}
                            >
                                <div className="refer-table">
                                    {this.renderPopoverRight()}
                                </div>
                            </div>
                        }
                    />
                )}
            </Row>
        );
    };

    /**
     * 判断一下树的根节点是否需要选中
     */
    shouldCheckedRootNode = (
        treeData,
        selectedValues,
        rootNode,
        idKey,
        virtualNodeSet
    ) => {
        // console.log('shouldCheckedRootNode', idKey);
        if (!rootNode || !selectedValues || !treeData) {
            return null;
        }

        if (
            selectedValues.size &&
            treeData
                .filter(
                    (e) =>
                        !this.isDisabled(e) &&
                        e.refpk !== (rootNode.refpk || rootNode[idKey]) &&
                        !this.getRowValuesBykey(e, 'virtualRootNote')
                )
                .every((e) => selectedValues.has(e[idKey]))
        ) {
            // selectedValues.set(rootNode[idKey], rootNode);
            return 'all';
        } else {
            selectedValues.delete(rootNode[idKey]);
            let selectedArray = [...selectedValues.keys()].filter(
                (e) => !virtualNodeSet.has(e)
            );
            if (selectedArray.length > 0) {
                return 'indeterminate';
            }
            return null;
        }
    };

    // 复写原型方法：渲染弹出层左侧
    renderPopoverLeft = () => {
        let {
            selectedKeys,
            expandedKeys,
            selectedValues,
            treeData,
            treeSearchVal,
            isTreeSearch,
            treeDataWithChildren,
            keyMap,
            virtualNodeSet,
            group,
            largeSizeMore,
            marginLength,
        } = this.state;
        const {
            refType,
            isMultiSelectedEnabled,
            isTreelazyLoad,
            rootNode,
            onlyLeafCanSelect,
            idKey,
            pidKey,
            isShowTreeSearch,
            isShowUsual,
            fieldValued,
            fieldid,
            attrcode,
            searchTrigger,
            hideTreeIcon = false,
            fieldidKey,
            lazyLoad = true//树节点层级较多时懒加载问题
        } = this.props;
        let search = this.renderPopoverSearchArea();
        // 判断根节点 是否应该选中 by bbqin
        this.shouldCheckedRoot = this.shouldCheckedRootNode(
            treeData,
            selectedValues,
            rootNode,
            idKey,
            virtualNodeSet
        );
        let halfChecked =
            this.shouldCheckedRoot === 'indeterminate' ? [rootNode[idKey]] : [];
        let checkedKeys = [];
        let checkable = refType === 'tree' && isMultiSelectedEnabled;
        if (checkable) {
            for (const [key, value] of selectedValues) {
                let checkedKey = value[idKey] || value[fieldValued];
                if (
                    keyMap[checkedKey] &&
                    !(
                        this.getRowValuesBykey(
                            keyMap[checkedKey],
                            'virtualRootNote'
                        ) || checkedKey === rootNode[idKey]
                    )
                ) {
                    checkedKeys.push(checkedKey);
                }
            }
            //确定虚拟父节点的选中状态
            for (const key of virtualNodeSet) {
                let groupNode = Array.isArray(group[key])
                    ? [...group[key]]
                    : [];
                let checkflag =
                    groupNode.length || selectedValues.has(key)
                        ? this.checkAllOrHalfCheck(groupNode, selectedValues)
                        : '';
                switch (checkflag) {
                    case 'allCheck':
                        checkedKeys.push(key);
                        break;
                    case 'halfCheck':
                        halfChecked.push(key);
                        break;
                    default:
                        break;
                }
            }
        }

        // let checkedKeys = [...selectedValues.values()].map(e => e[idKey] || e[fieldValued]);
        if (this.shouldCheckedRoot === 'all') {
            // checkedKeys = [...new Set(checkedKeys.concat(rootNode[idKey]))];
            checkedKeys.push(rootNode[idKey]);
        }

        // checkedKeys = checkable ? (Array.isArray(checkedKeys) ? checkedKeys : []).filter(
        // 	e => keyMap[e],
        // ) : [];

        return [
            // 全部 or 常用页签，传入true，控制树表参照的页签显隐
            this.renderTabs(true),
            /* 搜索树的搜索框 */
            refType !== 'grid' && (
                <React.Fragment>
                    <div
                        className={`refer-tree-header  ${refType === 'gridTree' &&
                            isShowUsual &&
                            ' refer-tree-header-bb'
                            }`}
                    >
                        {isShowTreeSearch && (
                            <div className="refer-search-table-input">
                                <FormControl
                                    className="search-input"
                                    style={{
                                        paddingRight: treeSearchVal && 40,
                                    }}
                                    type="text"
                                    // 搜索
                                    placeholder={`${this.state.jsonInsideRefer[
                                        'containers-refer-0016'
                                    ]?.replace('{1}', rootNode.refname)}`}
                                    value={treeSearchVal}
                                    onClick={(e) => {
                                        let ncc_automated = getGlobalStorage(
                                            'localStorage',
                                            '_ncc_automated_'
                                        );
                                        if (ncc_automated == '1') {
                                            // 自动化测试开关打开
                                            let v = e.target.value;
                                            this.popSearchTree(v);
                                        }
                                    }}
                                    onChange={(v) => {
                                        this.setState({ treeSearchVal: v });
                                        let ncc_automated = getGlobalStorage(
                                            'localStorage',
                                            '_ncc_automated_'
                                        );
                                        if (ncc_automated != '1') {
                                            // 自动化测试开关关闭
                                            if (searchTrigger === 'input') {
                                                this.interval =
                                                    new Date().getTime();
                                                let s = setTimeout(() => {
                                                    // 停止输入0.5s后执行
                                                    if (
                                                        new Date().getTime() -
                                                        this.interval >=
                                                        500
                                                    ) {
                                                        this.popSearchTree(v);
                                                    }
                                                    clearTimeout(s);
                                                }, 500);
                                            }
                                        }
                                    }}
                                    tabIndex={this.getTabIndex(
                                        this.hotKeyElement.treeSearchInput
                                    )}
                                    onKeyDown={this.resetHotKeyLoop.bind(
                                        this,
                                        this.hotKeyElement.treeSearchInput
                                    )}
                                    ref={(dom) => {
                                        this.searchTreeInput =
                                            ReactDOM.findDOMNode(dom);
                                    }}
                                    fieldid={getSysFieldid('search')}
                                />
                                <i
                                    className="refer-search-i iconfont icon-sousuo"
                                    onClick={() => {
                                        if (searchTrigger === 'click') {
                                            this.popSearchTree(
                                                this.state.treeSearchVal
                                            );
                                        }
                                    }}
                                />
                                {treeSearchVal && (
                                    <i
                                        className="refer-del-i iconfont icon-qingkong"
                                        onClick={() => {
                                            this.popSearchTree('');
                                            this.setState({
                                                treeSearchVal: '',
                                            });
                                            this.searchTreeInput.focus();
                                        }}
                                    />
                                )}
                            </div>
                        )}
                        {refType === 'tree' && (<div className='refer-tree-search-right'>{search}</div>)}
                    </div>
                    {/* {largeSizeMore && marginLength > 0 && (
                        <div
                            className="large-size-button"
                            style={{ marginLeft: marginLength + 'px' }}
                        >
                            {this.renderMoreButton()}
                        </div>
                    )} */}
                </React.Fragment>
            ),
            this.renderPopoverLeftHeader(),

            <div
                className="refer-tree-wrapper"
                fieldid={getSysFieldid(`${fieldid || attrcode}_tree`)}
            >
                <div
                    className={`refer-tree-container`}
                    onKeyDown={isIE() && this.controlTabSequenceInIE}
                >
                    <ArrayTree
                        checkable={checkable}
                        fieldidKey={fieldidKey}
                        data={[...treeData.values()]}
                        onSelect={this.onTreeNodeSelect}
                        onDoubleClick={this.onTreeNodeDoubleClick}
                        onExpand={this.onTreeNodeExpand}
                        onCheck={this.onTreeNodeCheck}
                        checkedKeys={{
                            checked: checkedKeys,
                            halfChecked: halfChecked,
                        }}
                        selectedKeys={selectedKeys}
                        expandedKeys={expandedKeys}
                        isTreelazyLoad={isTreelazyLoad}
                        lazyLoad={lazyLoad}
                        root={rootNode}
                        onlyLeafCanSelect={onlyLeafCanSelect}
                        id={idKey}
                        pid={pidKey}
                        isTreeSearch={isTreeSearch}
                        treeDataWithChildren={treeDataWithChildren}
                        keyMap={keyMap}
                        tabIndexValue={this.getTabIndex(
                            this.hotKeyElement.referTree
                        )}
                        // onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.referTree)}
                        // keyDown 事件 回调
                        keyFun={(e) => {
                            if (
                                [e.keyCode, e.which, e.charCode].find(
                                    (e) => e === 13
                                ) ||
                                e.key === 'Enter'
                            ) {
                                e.stopPropagation();
                            }

                            if (e.repeat === true && e.keyCode === 32) {
                                this.pressOnTreeNode = true;
                            }
                        }}
                        ref={(dom) => {
                            this.refTree = ReactDOM.findDOMNode(dom);
                        }}
                        onFocus={this.onTreeFocus}
                        // autoSelectWhenFocus={refType === 'gridTree'} //快捷键上下键移动时触发树的onSelect函数
                        treeSearchKey={treeSearchVal} // tree 搜索高亮 关键字
                        hideTreeIcon={hideTreeIcon} // 是否隐藏文件夹图标
                    />
                </div>
            </div>,
        ];
    };

    // 复写原型方法：渲染弹出层右侧
    renderPopoverRight = () => {
        const {
            refType,
            rowKey,
            attrcode,
            fieldid,
            columnConfig,
            showClassification,
            fieldValued,
            isShowUsual,
            pageTemplate,
            isMultiSelectedEnabled,
            defaultCheckedTreeNode,
        } = this.props;
        let {
            tableData,
            activeKey,
            isFirstShow,
            isShow,
            tableScrollHeight,
            isSearch,
            keyMap,
            selectedKeys,
            searchVal,
            selectedValues,
            jsonInsideRefer,
            collectUsualData,
            forceUpdateColumn,
        } = this.state,
            { sort, width = {} } = columnConfig[0],
            columns = [],
            // scrollTop = this.scrollTop || this.scrollTop === 0 ? this.scrollTop : -1,
            search = this.renderPopoverSearchArea(),
            pageArea = this.renderPopoverPageArea();
        // delete this.scrollTop;
        // columns.length = 0;

        // let isTotal = this.getConfigcolumnIsTotal();
        let isTotal = false;

        width = this.state.columnConfig[0].width
            ? this.state.columnConfig[0].width
            : {};
        isShowUsual &&
            columns.push({
                isSort: false,
                // 序号
                // title: (
                //     <span fieldid={getSysFieldid('numberindex')} title={'收藏'}>
                //         收藏
                //     </span>
                // ), // 序号列
                key: '__collect__',
                width:
                    width['__collect__'] ||
                    (this.props.isMultiSelectedEnabled ? '26px' : '30px'),
                fixed: 'left',
                render: (text, row, index) => {
                    return (
                        <span
                            fieldid={getSysFieldid('numberindex')}
                            title={
                                collectUsualData.size !== 0
                                    ? collectUsualData.get(row[fieldValued]) ||
                                        collectUsualData.get(row.refpk)
                                        ? jsonInsideRefer[
                                        'containers-refer-0068'
                                        ]
                                        : jsonInsideRefer[
                                        'containers-refer-0020'
                                        ]
                                    : jsonInsideRefer['containers-refer-0020']
                            }
                        >
                            {/* {index + 1} */}
                            <span
                                className={`iconfont ${collectUsualData.size !== 0
                                        ? collectUsualData.get(
                                            row[fieldValued]
                                        ) || collectUsualData.get(row.refpk)
                                            ? 'icon-shoucangdianliang'
                                            : 'icon-shoucang'
                                        : 'icon-shoucang'
                                    // starStatus
                                    //     ? 'icon-shoucangdianliang'
                                    //     : 'icon-shoucang'
                                    }`}
                                style={{ cursor: 'pointer' }}
                                // onClick={() => {
                                //     console.log(row.refpk, row);
                                //     let useStar = true;

                                //     if (
                                //         collectUsualData.size !== 0 &&
                                //         !!(
                                //             collectUsualData.get(
                                //                 row[fieldValued]
                                //             ) || collectUsualData.get(row.refpk)
                                //         )
                                //     ) {
                                //         this.usualCollectAction(
                                //             'delete',
                                //             row.refpk,
                                //             index
                                //         );
                                //     } else if (
                                //         collectUsualData.size === 0 ||
                                //         !(
                                //             collectUsualData.get(
                                //                 row[fieldValued]
                                //             ) || collectUsualData.get(row.refpk)
                                //         )
                                //     ) {
                                //         this.usualCollectAction(
                                //             'save',
                                //             '',
                                //             0,
                                //             useStar,
                                //             row
                                //         );
                                //     }
                                // }}
                                // onClick={this.props.usualAction.bind(this, 'save')}

                                onClick={() => {
                                    if (!this.timer) {
                                        this.timer = setTimeout(() => {
                                            clearTimeout(this.timer);
                                            this.timer = 0;

                                            console.log(row.refpk, row);
                                            let useStar = true;

                                            if (
                                                collectUsualData.size !== 0 &&
                                                !!(
                                                    collectUsualData.get(
                                                        row[fieldValued]
                                                    ) ||
                                                    collectUsualData.get(
                                                        row.refpk
                                                    )
                                                )
                                            ) {
                                                this.usualCollectAction(
                                                    'delete',
                                                    row.refpk,
                                                    index
                                                );
                                            } else if (
                                                collectUsualData.size === 0 ||
                                                !(
                                                    collectUsualData.get(
                                                        row[fieldValued]
                                                    ) ||
                                                    collectUsualData.get(
                                                        row.refpk
                                                    )
                                                )
                                            ) {
                                                this.usualCollectAction(
                                                    'save',
                                                    '',
                                                    0,
                                                    useStar,
                                                    row
                                                );
                                            }
                                        }, 300);
                                    }
                                }}
                                onDoubleClick={() => {
                                    // clearTimeout(this.timer);
                                    // this.timer = 0;

                                    clearTimeout(this.timer);
                                    this.timer = 0;

                                    console.log(row.refpk, row);
                                    let useStar = true;

                                    if (
                                        collectUsualData.size !== 0 &&
                                        !!(
                                            collectUsualData.get(
                                                row[fieldValued]
                                            ) || collectUsualData.get(row.refpk)
                                        )
                                    ) {
                                        this.usualCollectAction(
                                            'delete',
                                            row.refpk,
                                            index
                                        );
                                    } else if (
                                        collectUsualData.size === 0 ||
                                        !(
                                            collectUsualData.get(
                                                row[fieldValued]
                                            ) || collectUsualData.get(row.refpk)
                                        )
                                    ) {
                                        this.usualCollectAction(
                                            'save',
                                            '',
                                            0,
                                            useStar,
                                            row
                                        );
                                    }
                                }}
                            ></span>
                        </span>
                    );
                },
            });

        columns.push({
            isSort: false,
            // 序号
            title: (
                <span
                    className='refer-table-title'
                    fieldid={getSysFieldid('numberindex')}
                    title={jsonInsideRefer['containers-refer-0021']}
                >
                    {jsonInsideRefer['containers-refer-0021']}
                </span>
            ), // 序号列
            key: '__index__',
            width: width['__index__'] || '60px',
            fixed: 'left',
            render: (text, row, index) => {
                return (
                    <span fieldid={getSysFieldid('numberindex')}>
                        {index + 1}
                    </span>
                );
            },
        });
        this.props.isMultiSelectedEnabled &&
            columns.unshift({
                isSort: false,
                title: (
                    <label className="refer-table-label">
                        <span
                            className="checkbox-column"
                            fieldid={getSysFieldid('firstcol')}
                        >
                            <Checkbox
                                onChange={this.checkAll}
                                checked={this.isAllChecked()}
                                tabIndex={40}
                                // 增加一个中间态
                                indeterminate={this.isIndeterminated()}
                                className={TABLE_HEAD_CHECKBOX_CLASS_NAME}
                                onKeyDown={this.handleTableHeadCheckboxKeyDown}
                                onKeyUp={this.preventDefaultTableCheckbox}
                            />
                            {!pageTemplate && (
                                <Dropdown
                                    overlayClassName="refer-all-select"
                                    trigger={['click']}
                                    overlay={
                                        <ul>
                                            <li
                                                onClick={() => {
                                                    let data;
                                                    if (activeKey == 2) {
                                                        data =
                                                            tableData[0].rows;
                                                    } else {
                                                        data =
                                                            this.loadTableDataSync(
                                                                this.__getParam(
                                                                    {
                                                                        pageInfo:
                                                                        {
                                                                            pageIndex:
                                                                                -1,
                                                                        },
                                                                        pid: selectedKeys[0],
                                                                        keyword:
                                                                            searchVal,
                                                                    }
                                                                )
                                                            )?.rows || [];
                                                    }

                                                    data.forEach((row) =>
                                                        selectedValues.set(
                                                            row.refpk,
                                                            row
                                                        )
                                                    );
                                                    this.setState({
                                                        selectedValues,
                                                    });
                                                }}
                                            >
                                                {/* 全选 */}
                                                {
                                                    jsonInsideRefer[
                                                    'containers-refer-0059'
                                                    ]
                                                }
                                                {/* {this.isRealAllChecked() && <i className="iconfont icon-liucheng1"></i>} */}
                                            </li>
                                            <li onClick={this.checkCurrentPage}>
                                                {/* 仅当前页 */}
                                                {
                                                    jsonInsideRefer[
                                                    'containers-refer-0060'
                                                    ]
                                                }
                                                {/* {this.isCurrentAllChecked() && <i className="iconfont icon-liucheng1"></i>} */}
                                            </li>
                                            <li
                                                onClick={() => {
                                                    this.setState({
                                                        selectedValues:
                                                            new Map(),
                                                    });
                                                }}
                                            >
                                                {/* 全消 */}
                                                {
                                                    jsonInsideRefer[
                                                    'containers-refer-0061'
                                                    ]
                                                }
                                            </li>
                                        </ul>
                                    }
                                >
                                    <i className="iconfont icon-xiajiantou"></i>
                                </Dropdown>
                            )}
                        </span>
                    </label>
                ), // 全选效果
                key: '__checkbox__',
                width: width['__checkbox__'] || '48px',
                fixed: 'left',
                render: (text, row, index) => {
                    return (
                        <label className="refer-table-label">
                            <span
                                fieldid={getSysFieldid('firstcol')}
                                onClickCapture={(e) => {
                                    if (e.ctrlKey || e.metaKey) {
                                        e.stopPropagation();
                                    }
                                }}
                            >
                                <Checkbox
                                    onClick={(e) => {
                                        let {
                                            selectedValues,
                                            isMultiSelectMode,
                                            selectedKeys,
                                        } = this.state;
                                        e.stopPropagation();

                                        // 额外进行批选操作
                                        let dataForBatch =
                                            this.batchSelectTableData(
                                                row,
                                                index
                                            );
                                        if (dataForBatch.length === 0) {
                                            this.toggleValueForMapOrObject(
                                                selectedValues,
                                                row.refpk,
                                                row
                                            );
                                        } else {
                                            dataForBatch.forEach((item) => {
                                                // this.toggleValueForMapOrObject(
                                                //     selectedValues,
                                                //     item.refpk,
                                                //     item
                                                // );
                                                if (item.refpk) {
                                                    selectedValues.set(
                                                        item.refpk,
                                                        item
                                                    );
                                                }
                                            });
                                        }

                                        // this.toggleValueForMapOrObject(
                                        //     selectedValues,
                                        //     row.refpk,
                                        //     row
                                        // );
                                        if(defaultCheckedTreeNode){
                                            selectedKeys = row && [row.pid];
                                        }
                                        isMultiSelectMode ||
                                            this.onRowClick(row, index, e);
                                        this.setState({
                                            isMultiSelectMode: true,
                                            selectedValues,
                                            selectedKeys,
                                        });
                                    }}
                                    checked={
                                        !!(
                                            this.state.selectedValues.get(
                                                row[fieldValued]
                                            ) ||
                                            this.state.selectedValues.get(
                                                row.refpk
                                            )
                                        )
                                    }
                                    tabIndex="-1"
                                />
                            </span>
                        </label>
                    );
                },
            });

        showClassification &&
            refType !== 'grid' &&
            (activeKey == '2' || (refType === 'gridTree' && isSearch)) &&
            columns.push({
                // 所属分类
                title: (
                    <span
                        fieldid={getSysFieldid('category')}
                        title={
                            this.state.jsonInsideRefer['containers-refer-0055']
                        }
                    >
                        {this.state.jsonInsideRefer['containers-refer-0055']}
                    </span>
                ),
                key: '__category__',
                width: width['__category__'] || '150px',
                isSort: true,
                sorter: function (a, b) {
                    let aValue = keyMap[a.pid]?._display;
                    let bValue = keyMap[b.pid]?._display;
                    return aValue >= bValue ? 1 : -1;
                },
                // fixed: 'left',
                render: (text, row) => {
                    return (
                        <span fieldid={getSysFieldid('category')}>
                            {keyMap[row.pid]?._display}
                        </span>
                    );
                },
            });

        columns.push(...this.getCommonColumns());
        // console.log(columns);
        // console.log(tableData);
        // tableData[0].rows = [];
        // console.log(tableData);

        // 【常用】页签时，增加【移除】列
        if (activeKey == '2') {
            columns.push({
                // 操作
                title: (
                    <span
                        fieldid={getSysFieldid('opr')}
                        className="refer-table-title"
                        title={
                            this.state.jsonInsideRefer['containers-refer-0022']
                        }
                    >
                        {this.state.jsonInsideRefer['containers-refer-0022']}
                    </span>
                ), // 全选效果
                key: '__opt__',
                width: width['__opt__'] || '90px',
                fixed: 'right',
                render: (text, row, index) => {
                    return (
                        <span
                            className="refer-del"
                            fieldid={getSysFieldid('opr')}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.usualAction('delete', row.refpk, index);
                            }}
                            onDoubleClick={(e) => {
                                // 阻止双击表格行的事件，防止参照关闭
                                e.stopPropagation();
                            }}
                        >
                            {/* 移除 */}
                            {
                                this.state.jsonInsideRefer[
                                'containers-refer-0023'
                                ]
                            }
                        </span>
                    );
                },
            });
        }

        // //表格中添加'设置'按钮this.renderColumnConfig()
        // columns.push({
        //     // 操作
        //     title: (
        //         <span fieldid={getSysFieldid('column')}>
        //             {this.renderColumnConfig()}
        //         </span>
        //     ), // 全选效果
        //     key: '__column__',
        //     width: width['__column__'] || '60px',
        //     fixed: 'right',
        //     render: (text, row, index) => {
        //         return;
        //     },
        // });

        columns.forEach((element) => {
            if (
                this.sortCol &&
                this.sortCol[0] &&
                this.sortCol[0].field === element.key
            ) {
                element.sortFlag = true;
                element.order = this.sortCol[0].order;
            }
        });

        // 以下各种判断为了满足UI的“设计”
        return [
            search && (
                <div
                    className={`refer-search ${refType === 'gridTree' && ' refer-search-bc'
                        }`}
                    style={{
                        paddingLeft:
                            refType === 'grid'
                                ? isShowUsual
                                    ? ''
                                    : '16px'
                                : '0',
                        // borderBottom: refType === 'gridTree' ? '1px solid #d0d0d0' : 'none' // 使用className控制
                    }}
                    ref={(dom) => {
                        this.referSearchDom = dom;
                    }}
                    fieldid={getSysFieldid('search-area')}
                >
                    {isFirstShow || search}
                </div>
            ),
            <div
                className={`refer-grid ${refType === 'gridTree' ? ' refer-grid-blf' : ''
                    }`}
                style={{
                    padding: '0 16px',
                    marginTop: '10px',
                    // borderLeft: refType === 'gridTree' ? '1px solid #dbdbdb' : 'none' // 转化为className
                }}
                ref={(dom) => {
                    this.referTable = dom;
                    if (
                        isShow &&
                        dom &&
                        dom.offsetHeight - tableRowHeight !== tableScrollHeight
                    ) {
                        this.setState({
                            tableScrollHeight: dom
                                ? dom.offsetHeight - tableRowHeight
                                : 0,
                        });
                    }
                }}
                fieldid={getSysFieldid(`${fieldid || attrcode}_table`)}
            >
                <div
                    className={`refer-table selectable-${attrcode} ${activeKey == 1 && 'clear-flex-boxshadow'
                        }`}
                >
                    {/* {this.props.isMultiSelectedEnabled && (
                        <Selectable
                            canvas={`.selectable-${attrcode}`}
                            // 注意可以加下前后空格
                            selector=" tbody tr "
                            unitKey="refpk"
                            series
                            disabled={
                                !this.props.isMultiSelectedEnabled || 'slide'
                            } // 可选值 true false 'shift' 'ctrl' 'slide'
                            userSelect={true} // 启用用户文字选中
                            unitsData={tableData[0].rows}
                            // 开始项  主要配合外部的 单选事件处理 以及初始化时的  shift 操作
                            // 如果设置为空  内部会根据dom查找一次  但是dom还没渲染  可能会有问题
                            startItem={
                                tableData[0].rows[0] &&
                                tableData[0].rows[0]['refpk']
                            }
                            onSelect={(d, type) => {
                                console.log(type);
                                let data = tableData[0].rows,
                                    rowLen = data.length;
                                if (rowLen > 0) {
                                    let { selectedValues } = this.state;
                                    data.forEach((element) => {
                                        let refpk = element['refpk'];
                                        if (d[refpk]) {
                                            selectedValues.set(refpk, element);
                                        }
                                        if (
                                            !d[refpk] &&
                                            selectedValues.get(refpk)
                                        ) {
                                            selectedValues.delete(refpk);
                                        }
                                    });
                                    this.setState({
                                        selectedValues,
                                        isMultiSelectMode: true,
                                    });
                                }
                            }}
                        />
                    )} */}
                    <Table
                        filterConfig={{
                            enable: true,
                            //将整个过滤的东西都传下去，包括了过滤弹窗的打开和关闭
                            filterCondition: this.state.filterCondition,
                            onFilter: (conditions, logic) => {
                                this.setState(
                                    {
                                        filterCondition: {
                                            ...this.state.filterCondition,
                                            conditions,
                                            logic,
                                        },
                                    },
                                    () => {
                                        this.loadAndSetTableData({
                                            pid: selectedKeys[0],
                                            pageInfo: tableData[0].page,
                                            keyword: searchVal,
                                            queryInfo: this.getQueryInfo(),
                                        });
                                    }
                                );
                            },
                        }}
                        lazyload={
                            tableData &&
                            tableData[0] &&
                            tableData[0].page &&
                            tableData[0].page.pageSize > 50
                        }
                        height={tableRowHeight}
                        headerHeight={tableRowHeight}
                        onRowClick={this.onRowClick}
                        onRowDoubleClick={this.onRowDoubleClick}
                        rowKey={(record) =>
                            this.getDisplayOrValue(record, rowKey)
                        }
                        // rowKey={'total-row'} //不是这个不更新columns,即bodyColumn
                        columns={columns}
                        forceUpdateColumn={forceUpdateColumn}
                        data={tableData[0].rows}
                        scroll={{
                            // 补正1px 避免表格横向滚动条被遮住1px
                            y: isTotal
                                ? this.referTable?.clientHeight -
                                totalTableHeight -
                                30 -
                                1
                                : this.referTable?.clientHeight - 30 - 1,
                            x: true,
                        }}
                        rowClassName={this.rowClassName}
                        // 补正1px 避免表格横向滚动条被遮住1px
                        bodyStyle={{
                            height: isTotal
                                ? this.referTable?.clientHeight -
                                totalTableHeight -
                                30 -
                                1
                                : this.referTable?.clientHeight - 30 - 1,
                        }}
                        focusable
                        tabIndex={this.getTabIndex(
                            this.hotKeyElement.referTable
                        )}
                        // onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.referTable)}
                        // className="refer-base-table"
                        className={`refer-base-table ${isMultiSelectedEnabled &&
                            isShowUsual &&
                            'refer-base-table-firstcol'
                            }`}
                        bodyClassName="refer-base-table-scroll-body"
                        ref={(dom) => {
                            this.table =
                                ReactDOM.findDOMNode(dom)?.querySelector(
                                    `.refer-base-table`
                                );
                        }}
                        // scrollTop={scrollTop}
                        addBlankCol={false}
                        customSort={sort}
                        // {...emptyText}
                        emptyClassName="refer-select-empty"
                        columnWidthConfig={false}
                        sort={{ sortFun: this.handleSort }}
                        onDropBorderHandler={this.onDropBorderHandler}
                    // isTotal={isTotal}
                    // handleFooter={(columns) => this.handleFooter(columns)}
                    />
                </div>
            </div>,
            // 常用页签不分页
            activeKey == '1' && pageArea && (
                <div
                    fieldid={getSysFieldid(`${fieldid || attrcode}_table`)}
                    className="pagination-div"
                >
                    <div
                        // 行内样式模式  迁移为class模式
                        fieldid={getSysFieldid('pagination-div')}
                        className={`refer-page ${refType === 'gridTree' ? 'refer-page-gridtree' : ''
                            }`}
                    // style={{
                    // 	borderLeft: refType === 'gridTree' ? '1px solid #dbdbdb' : 'none'
                    // }}
                    >
                        {pageArea}
                    </div>
                </div>
            ),
        ];
    };

    //判断是否显示合计行
    // getConfigcolumnIsTotal = () => {
    //     let columnInfo = this.getCommonColumns();
    //     return columnInfo.some(
    //         (item) => item.istotal && item.itemtype === 'number'
    //     );
    // };

    //计算勾选行的合计值
    getTotalData = () => {
        let { selectedValues, tableData, jsonInsideRefer } = this.state;
        let { isMultiSelectedEnabled } = this.props;
        let columnInfo = this.getCommonColumns();

        let columnkeys = {};

        if (selectedValues.size === 0) {
            //计算当前表格的所有值
            if (tableData[0] && tableData[0].rows) {
                columnInfo.forEach((item) => {
                    // if (item.istotal && item.itemtype === 'number') {
                    let curTotal = 1.23;
                    // tableData[0].rows.forEach((e) => {
                    //     curTotal += Number(e.values[item.key].value);
                    // });
                    columnkeys[item.key] = curTotal;
                    // }
                });
            }
        } else {
            columnInfo.forEach((item) => {
                // if (item.istotal && item.itemtype === 'number') {
                let curTotal = 1.23;
                // for (let key in selectedValues) {
                //     curTotal += Number(
                //         selectedValues[key].values[item.key].value
                //     );
                // }
                // selectedValues.forEach((e) => {
                //     curTotal += Number(e.values[item.key].value);
                // });
                columnkeys[item.key] = curTotal;
                // }
            });
        }

        //合计文字
        isMultiSelectedEnabled
            ? (columnkeys['__checkbox__'] =
                jsonInsideRefer['containers-refer-0069'] || '合计')
            : (columnkeys['__index__'] =
                jsonInsideRefer['containers-refer-0069'] || '合计');

        return [columnkeys];
    };

    //合计列数据
    getTotalColumns = (columns) => {
        let newColumns = [];

        columns.forEach((item) => {
            const { key, width, istotal, scale, itemtype, fixed } = item;
            let finalFixed = fixed;
            let colItem = {
                key,
                attrcode: key,
                itemtype,
                width,
                fixed: finalFixed,
                istotal,
                scale,
            };

            //合计行中数字类型，右对齐
            if (key !== '__collect__') {
                colItem.render = (text, record) => {
                    // let iWidth = 'calc(100% - 46px)';
                    // 三大表与 转单 树表等不一样
                    // let iWidth = 'calc(100% - ' + numberPd + 'px)';
                    // let styleObj = { textAlign: 'right', width: iWidth };
                    return record[key] ? (
                        <div
                            className="total-row-table-cell"
                            // style={styleObj}
                            fieldid={getSysFieldid(key)}
                        >
                            <Tooltip
                                className="tooltip-word-color table-pagination-tip"
                                placement="top"
                                delay={1}
                                overlay={record[key]}
                            >
                                <span className="ellipsis">
                                    {formatNumber(record[key])}
                                </span>
                            </Tooltip>
                        </div>
                    ) : (
                        <span> &nbsp;</span>
                    );
                };
            }
            newColumns.push(colItem);
        });
        return newColumns;
    };

    //表格合计行
    handleFooter = (columns) => {
        let totalData = this.getTotalData();
        let finalColumns = [];
        finalColumns = this.getTotalColumns(columns);

        return (
            <div
                fieldid={getSysFieldid('total-row')}
            // style={{ pointerEvents: 'none' }}
            >
                <Table
                    minColumnWidth={80}
                    height={totalTableHeight}
                    ref={(dom) => {
                        this.total = ReactDOM.findDOMNode(dom);
                    }}
                    className={'total-row'}
                    addBlankCol={false}
                    data={totalData}
                    columns={[...finalColumns]}
                    rowKey={'total-row'}
                    showHeader={false}
                    headerScroll={false}
                    scroll={{}}
                    bodyStyle={{
                        minHeight: totalTableHeight,
                        overflowX: 'auto',
                    }}
                    bodyClassName="refer-total-table-scroll-body"
                />
            </div>
        );
    };

    getQueryInfo = () => {
        let { filterCondition } = this.state;

        if (filterCondition?.conditions?.length) {
            return {
                logic: filterCondition.logic,
                conditions: filterCondition.conditions.map(
                    ({ key, value, operator }) => ({
                        field: key,
                        oprtype: operator,
                        value: { firstvalue: value, secondvalue: '' },
                    })
                ),
            };
        }
    };

    handleTableHeadCheckboxKeyDown = (e) => {
        let { tableData } = this.state,
            tableBody =
                this.table &&
                this.table.querySelector(`.refer-base-table-scroll-body`),
            len = tableData[0].rows.length - 1;
        if (e.keyCode === 38 || e.keyCode === 40) {
            e.keyCode === 38
                ? selectToLastRow.call(this, { tableDataLen: len, tableBody })
                : selectToFirstRow.call(this);

            //为了onTableKeyPress中的此判断条件 document.activeElement === this.table 把this.table设为聚焦状态
            this.table.focus();
        }

        if (e.keyCode === 32 && this.spaceKeyPress !== true) {
            e.target && e.target.click();
        }
    };

    preventDefaultTableCheckbox = (e) => {
        /*
         * checkbox space键 keyup时才触发选中效果，但UE要求space键按下时就触发选中效果,
         * 因此keyDown时执行选中效果，keyup时阻止默认行为
         */
        e.preventDefault();
    };

    // 复写原型方法：渲染弹出层分页区
    renderPopoverPageArea = () => {
        let { tableData, jsonInsideRefer, paginationRefreshKey } = this.state;
        const {
            refType,
            pageSizeOptions,
            pageSize,
            showPagination = true,
        } = this.props;
        let { page } = tableData[0];
        if (refType === 'tree') {
            return null;
        }
        return (
            page &&
            // Number(page.totalPage) > 1 &&
            showPagination && (
                // 这个被封装了，改内部的方法就行
                <Pagination
                    key={paginationRefreshKey}
                    defaultPageSize={pageSize}
                    local={jsonInsideRefer}
                    total={Number(page.total || 0)}
                    pageSize={Number(page.pageSize || 50)}
                    items={Number(page.totalPage) || 1}
                    activePage={Number(page.pageIndex) + 1}
                    onPageIndexChange={(pageIndex) =>
                        this.onPageChange({ pageIndex })
                    }
                    onPageSizeChange={(pageSize) =>
                        this.onPageChange({ pageSize })
                    }
                    pageSizeOptions={pageSizeOptions}
                />
            )
        );
    };

    onPageChange = ({ pageSize, pageIndex }) => {
        let { tableData, selectedKeys, isSearch, searchVal } = this.state,
            { rootNode, idKey } = this.props;
        if (pageSize) {
            tableData[0].page.pageSize = Number(pageSize);
            tableData[0].page.pageIndex = 0;
        } else {
            pageSize = tableData[0].page.pageSize;
        }
        if (pageIndex) {
            pageIndex--;
            tableData[0].page.pageIndex = Number(pageIndex);
        } else {
            pageIndex = tableData[0].page.pageIndex;
        }

        // 根据页码重新查数据
        this.setState(
            {
                tableData,
                pagPageInfo: tableData[0].page,
                usePagaPageInfo: true,
            },
            () => {
                this.referTable &&
                    (this.referTable.querySelector(
                        `.refer-base-table-scroll-body`
                    ).scrollTop = 0);
                this.loadAndSetTableDataAgainIfEmpty({
                    pid:
                        selectedKeys[0] === (rootNode.refpk || rootNode[idKey])
                            ? ''
                            : selectedKeys[0] || '',
                    pageInfo: tableData[0].page,
                    keyword: isSearch ? searchVal : '',
                    queryInfo: this.getQueryInfo(),
                    filterPks: (this.allpks || []).slice(
                        (pageIndex - 1) * pageSize,
                        pageIndex * pageSize
                    ),
                });
            }
        );
    };

    // 复写原型方法：渲染弹出层底部
    renderPopoverBottom = () => {
        let {
            selectedShow,
            addButtonList,
            isAddButtonShow,
            currentButtonIndex,
        } = this.state;
        // let selectColumns = this.getSelectColumns();
        let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
        const {
            isMultiSelectedEnabled,
            refType,
            isRunWithChildren,
            hasAddButton,
            isQuerySelectedData,
            isShowSelectedBtn,
        } = this.props;
        // selectColumns.push({
        // 	// 操作
        // 	title: <span fieldid={getSysFieldid('opr')}> {this.state.jsonInsideRefer['containers-refer-0025']} </span>,
        // 	key: 'operate',
        // 	width: 100,
        // 	fixed: 'right',
        // 	render: (text, row, index) => {
        // 		return (
        // 			<span
        // 				fieldid={getSysFieldid('opr')}
        // 				className="refer-del"
        // 				onClick={this.onSelectedRowClick.bind(null, row, index)}
        // 			>
        // 				{/* 移除 */}
        // 				{this.state.jsonInsideRefer['containers-refer-0026']}
        // 			</span>
        // 		);
        // 	},
        // });

        // selectColumns.unshift(...this.getCommonColumns(selectedShow));

        return [
            isMultiSelectedEnabled && isShowSelectedBtn && (
                <div className="refer-selected" key="1">
                    <Button
                        fieldid="selected"
                        onClick={() => {
                            !selectedShow &&
                                isQuerySelectedData &&
                                this.loadSelectedData();
                            this.setState({ selectedShow: !selectedShow });
                        }}
                    >
                        {/* 已选 */}
                        {`${this.state.jsonInsideRefer['containers-refer-0027']
                            }:（${this.getSelections().length}）`}
                    </Button>
                </div>
            ),
            // 树形参照是否执行时包含下级
            // isMultiSelectedEnabled &&
            refType === 'tree' &&
            // !onlyLeafCanSelect &&
            isRunWithChildren && (
                <Checkbox
                    className="include-children"
                    checked={this.state.runWithChildren}
                    onClick={() => {
                        this.setState({
                            runWithChildren: !this.state.runWithChildren,
                        });
                    }}
                    tabIndex={this.getTabIndex(
                        this.hotKeyElement.runWithChildren
                    )}
                >
                    {/* 执行时包含下级 */}
                    {this.state.jsonInsideRefer['containers-refer-0031']}
                </Checkbox>
            ),
            <div className="refer-bottom-extend" key="2">
                {this.renderPopoverBottomExtend()}
            </div>,
            <div className="buttons" key="3">
                {(() => {
                    if (hasAddButton && Array.isArray(addButtonList)) {
                        switch (addButtonList.length) {
                            case 0:
                                return null;
                            case 1:
                                return (
                                    <Tooltip
                                        placement="top"
                                        inverse
                                        overlay={`${this.state.jsonInsideRefer['containers-refer-0046']}  (${NCHotKeys.USUAL_KEYS.ADD})`}
                                        trigger={['hover', 'focus']}
                                        className="model-helper-overlay"
                                    >
                                        <Button
                                            onClick={() => {
                                                let {
                                                    appcode,
                                                    pagecode,
                                                    urlParam,
                                                } = addButtonList[0];
                                                pageTo.openTo(null, {
                                                    appcode,
                                                    pagecode,
                                                    status: 'browse',
                                                    ...(typeof urlParam ===
                                                        'function' &&
                                                        urlParam()),
                                                });

                                                // this.setState({
                                                //     isShow: false,
                                                //     selectedShow: false,
                                                // });
                                            }}
                                        >
                                            {/* 新增 */}
                                            {
                                                this.state.jsonInsideRefer[
                                                'containers-refer-0046'
                                                ]
                                            }
                                            (
                                            <span className="text-decoration-underline">
                                                /
                                            </span>
                                            )
                                        </Button>
                                    </Tooltip>
                                );
                            default:
                                let length = addButtonList.length;
                                return (
                                    <Popover
                                        container={this.popWindow}
                                        className="popover-in-refer add"
                                        // trigger="click"
                                        trigger={
                                            ncc_automated === '1'
                                                ? ['click']
                                                : ['hover']
                                        }
                                        placement="top"
                                        content={
                                            <div className="add-button-wrapper">
                                                {addButtonList.map(
                                                    (
                                                        {
                                                            name,
                                                            appcode,
                                                            pagecode,
                                                            urlParam,
                                                        },
                                                        i
                                                    ) => {
                                                        return (
                                                            <div
                                                                className={`add-button-item ${currentButtonIndex >
                                                                        -1 &&
                                                                        ((currentButtonIndex %
                                                                            length) +
                                                                            length) %
                                                                        length ===
                                                                        i
                                                                        ? 'selected'
                                                                        : ''
                                                                    }`}
                                                                key={name}
                                                                onClick={() => {
                                                                    pageTo.openTo(
                                                                        null,
                                                                        {
                                                                            appcode,
                                                                            pagecode,
                                                                            status: 'browse',
                                                                            ...(typeof urlParam ===
                                                                                'function' &&
                                                                                urlParam()),
                                                                        }
                                                                    );
                                                                    // this.setState(
                                                                    //     {
                                                                    //         isShow: false,
                                                                    //         selectedShow: false,
                                                                    //     }
                                                                    // );
                                                                }}
                                                            >
                                                                {name}
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        }
                                        fieldid="more_btn_menu"
                                        show={isAddButtonShow}
                                        onVisibleChange={(isAddButtonShow) => {
                                            this.setState({ isAddButtonShow });
                                        }}
                                    >
                                        <Tooltip
                                            placement="top"
                                            inverse
                                            overlay={`${this.state.jsonInsideRefer['containers-refer-0046']}  (${NCHotKeys.USUAL_KEYS.ADD})`}
                                            className="model-helper-overlay"
                                            onMouseEnter={() => {
                                                this.addTimer = setTimeout(
                                                    () => {
                                                        if (
                                                            !this.state
                                                                .isAddButtonShow
                                                        ) {
                                                            this.setState({
                                                                addTipVisible: true,
                                                            });
                                                        }
                                                    },
                                                    500
                                                );
                                            }}
                                            onMouseLeave={() => {
                                                if (this.addTimer) {
                                                    clearTimeout(this.addTimer);
                                                }
                                                if (this.state.addTipVisible) {
                                                    this.setState({
                                                        addTipVisible: false,
                                                    });
                                                }
                                            }}
                                            visible={this.state.addTipVisible}
                                        >
                                            <Button
                                                onClick={() => {
                                                    this.setState(
                                                        ({
                                                            isAddButtonShow,
                                                        }) => ({
                                                            isAddButtonShow:
                                                                !isAddButtonShow,
                                                            addTipVisible:
                                                                !!isAddButtonShow,
                                                        })
                                                    );
                                                }}
                                            >
                                                {/* 新增 */}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    {
                                                        <span>
                                                            {
                                                                this.state
                                                                    .jsonInsideRefer[
                                                                'containers-refer-0046'
                                                                ]
                                                            }
                                                        </span>
                                                    }
                                                    (
                                                    <span className="text-decoration-underline">
                                                        /
                                                    </span>
                                                    )
                                                    <i
                                                        className="iconfont icon-hangcaozuoxiala1"
                                                        style={{
                                                            lineHeight: '24px',
                                                            height: '22px',
                                                        }}
                                                    ></i>
                                                </span>
                                            </Button>
                                        </Tooltip>
                                    </Popover>
                                );
                        }
                    }
                })()}
                <Tooltip
                    placement="top"
                    inverse
                    overlay={`${this.state.jsonInsideRefer['containers-refer-0032']}  (${NCHotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                    trigger={['hover', 'focus']}
                    className="model-helper-overlay sure-overlay"
                    onMouseLeave={(e) => {
                        // 预算大数据量的时候处理, 先这样处理，有问题再注释
                        const currentTooltip = document.querySelector('.model-helper-overlay.sure-overlay')
                        if (currentTooltip) {
                            currentTooltip.style.display = 'none';
                        }
                    }}
                >
                    <Button
                        ref={this.sureBtnRef}
                        onClick={this.handleSureButtonClick}
                        className="sure-btn"
                        fieldid="sure"
                        disabled={this.isSureButtonDisabled()}
                    >
                        {/* 确定 */}
                        {this.state.jsonInsideRefer['containers-refer-0032']}(
                        <span className="text-decoration-underline">Y</span>)
                    </Button>
                </Tooltip>
                <Tooltip
                    placement="top"
                    inverse
                    overlay={`${this.state.jsonInsideRefer['containers-refer-0033']}  (${NCHotKeys.USUAL_KEYS.MODAL_CALCEL})`}
                    trigger={['hover', 'focus']}
                    className="model-helper-overlay"
                >
                    <Button
                        onClick={this.handleCancelButtonClick}
                        className="cancel-btn"
                        fieldid="cancel"
                    >
                        {/* 取消 */}
                        {this.state.jsonInsideRefer['containers-refer-0033']}(
                        <span className="text-decoration-underline">N</span>)
                    </Button>
                </Tooltip>
            </div>,
        ];
    };

    isSureButtonDisabled = () => {
        let { refType, isMultiSelectedEnabled } = this.props,
            { selectedValues } = this.state;
        return (
            refType === 'tree' &&
            !isMultiSelectedEnabled &&
            this.isDisabled([...selectedValues.values()][0] || {})
        );
    };

    handleSureButtonClick = async () => {
        let { isMultiSelectedEnabled, onSureBtnClick } = this.props;
        let selections = this.getSelections();
        if (isFunction(onSureBtnClick)) {
            let closeFlag = await onSureBtnClick(selections);
            if (closeFlag === false) {
                return;
            }
        }
        if (isMultiSelectedEnabled) {
            let result = await this.multiSelect();
            if (result === false) {
                return;
            }
        } else {
            this.singleSelect(this.getSelections()[0]);
        }
        // isMultiSelectedEnabled ? this.multiSelect() : this.singleSelect(this.getSelections()[0]);
        this.handlePopoverBlur();
    };

    handleCancelButtonClick = () => {
        this.cancel();
    };

    /**
     * @param e {object} 事件源
     * @param direction {string} 拖动方向
     * @param ref {dom} 拖动的元素
     * @param d {object} 移动偏移量
     * @note 请不要删除onResize里参数里的事件源对象
     */
    onResize(e, direction, ref, d) {
        // if (direction === 'topLeft' || direction === 'topRight') return;
        let { resizePosition } = this.state;

        /* resize 之前的值 */
        let originX = resizePosition.x;
        let originY = resizePosition.y;

        /* 移动的位移 */
        let moveW = d.width;
        let moveH = d.height;
        let refHeight = parseFloat(ref.style.height);
        let refMinHeight = parseFloat(ref.style.minHeight);
        /* 移动的位移 */
        let x = null;
        let y = null;

        /* 处理左边缘 */
        if (/left/i.test(direction)) {
            x = originX - moveW;
            y = originY;
            this.position = { x, y };
        } else if (/top/i.test(direction)) {
            /* 处理上边缘 */

            x = originX;
            y =
                refHeight === refMinHeight || refHeight < refMinHeight
                    ? parseFloat(ref.style.transform.split(',')[1])
                    : originY - moveH;
            this.position = { x, y };
        } else {
            this.position = null;
        }

        if (resizeOnVertical(direction)) {
            if (
                parseFloat(ref.style.height) <
                parseFloat(ref.style.minHeight) &&
                direction === 'top'
            ) {
                return;
            }

            d.height !== this.state.resizeHeight &&
                this.setState({ resizeHeight: d.height });
        }

        if (x || y) {
            ref.style.transform = `translate(${x}px, ${y}px)`;
        }
    }

    /**
     * @desc: 窗口改变大小结束后重新给弹窗内容与table设置高度
     */
    onResizeStop(e, direction, ref, d) {
        let { top } = ref.getBoundingClientRect();
        let a = ref.style.transform.replace(/(-?\d+.?\d+)px\)/, (a, p1) => {
            return Number(p1) - top + 'px)';
        });

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let langseq = (userData && userData.langseq) || '';
        if (top < 0) {
            ref.style.transform = a;
            this.position && (this.position.y -= top);
        }

        if (this.position) {
            this.setState({ resizePosition: this.position });
        }

        if (resizeOnVertical(direction)) {
            let { tableScrollHeight, referContentAreaHeight } = this.state;

            this.setState({
                tableScrollHeight: tableScrollHeight + d.height,
                referContentAreaHeight: referContentAreaHeight + d.height,
                resizeHeight: 0,
            });
        }

        if (
            this.includeSonCheckbox &&
            (this.includeSonCheckbox.offsetWidth === 122 || this.includeSonCheckbox.offsetWidth === 125)
        ) {
            if (this.popover && this.popover.clientWidth > 688) {
                this.setState({ largeSizeMore: false });
            }
        } else if (
            this.includeSonCheckbox &&
            this.includeSonCheckbox.offsetWidth === 134
        ) {
            if (this.popover && this.popover.clientWidth > 722) {
                this.setState({ largeSizeMore: false });
            }
        } else if (
            this.includeSonCheckbox &&
            this.includeSonCheckbox.offsetWidth === 189
        ) {
            if (this.popover && this.popover.clientWidth > 722) {
                this.setState({ largeSizeMore: false });
            }
        }
        if (this.moreButton && this.moreButton.offsetHeight > 35) {
            this.setState({ largeSizeMore: true });
            // let fitmargin =
            //     this.popover &&
            //     this.popover.clientWidth -
            //         32 -
            //         (this.searchTableInput &&
            //             this.searchTableInput.clientWidth +
            //                 this.disableDataCheckbox &&
            //             this.disableDataCheckbox.clientWidth +
            //                 this.includeAllCheckbox &&
            //             this.includeAllCheckbox.clientWidth +
            //                 this.includeSonCheckbox &&
            //             this.includeSonCheckbox.clientWidth);

            // setTimeout(() => {
            //     let fitmargin =
            //         (this.searchTableInput &&
            //             this.searchTableInput.clientWidth +
            //                 this.disableDataCheckbox &&
            //             this.disableDataCheckbox.clientWidth +
            //                 this.includeAllCheckbox &&
            //             this.includeAllCheckbox.clientWidth +
            //                 this.includeSonCheckbox &&
            //             this.includeSonCheckbox.clientWidth) -
            //         (this.moreButton && this.moreButton.clientWidth) +
            //         16 -
            //         20;

            //     if (this.moreButton && this.moreButton.clientHeight > 35) {
            //         this.setState({
            //             largeSizeMore: true,
            //             marginLength: fitmargin,
            //         });
            //     }
            // }, 100);
        }

        if (
            this.searchTreeInput &&
            this.disableDataCheckbox &&
            this.includeAllCheckbox &&
            this.includeSonCheckbox &&
            langseq === '3' &&
            this.popover.clientWidth < 722
        ) {
            this.setState({ largeSizeMore: true });
        }

        setTimeout(() => {
            if (this.state.largeSizeMore) {
                if (
                    this.searchTreeInput &&
                    this.disableDataCheckbox &&
                    this.includeAllCheckbox &&
                    this.includeSonCheckbox
                ) {
                    let moreButtonWidth;
                    if (this.includeSonCheckbox.offsetWidth === 122 || this.includeSonCheckbox.offsetWidth === 125) {
                        moreButtonWidth = 62;
                    } else if (this.includeSonCheckbox.offsetWidth === 134) {
                        moreButtonWidth = 68;
                    } else if (this.includeSonCheckbox.offsetWidth === 189) {
                        moreButtonWidth = 68;
                    }
                    let fitmargin =
                        this.searchTreeInput.clientWidth +
                        this.disableDataCheckbox.clientWidth +
                        this.includeAllCheckbox.clientWidth +
                        this.includeSonCheckbox.offsetWidth -
                        moreButtonWidth +
                        36;

                    this.setState({ marginLength: fitmargin });
                }
            } else {
                this.setState({ marginLength: 0 });
            }
        }, 100);
        this.setState({
            changeWidthFlag: true,
        });
    }

    onDragStart() {
        this.state.dragStartPosition !== null &&
            this.setState({ dragStartPosition: null });
        // 清空一些状态
        this.state.isMoreButtonShow === true &&
            this.setState({ isMoreButtonShow: false });
        this.setState({
            dragOverflow: true,
        });
    }

    onDragStop = (e, draggableData) => {
        modalAlwaysShowInView.call(this, e, draggableData);
        // this.setState({
        //     dragOverflow: true,
        // });
    };

    /**
     * @desc IE中gridTree类型参照中在树节点中点tab直接跳转到了地址搜索栏中所以IE浏览器特殊控制一下顺序
     * @params e {object}
     */
    controlTabSequenceInIE = (e) => {
        let { refType } = this.props;
        if (e.key === 'Tab' && refType === 'gridTree') {
            let searchInput =
                this.referSearchDom &&
                this.referSearchDom.querySelector(`.${GRID_TREE_SEARCH_INPUT}`);
            e.stopPropagation();
            e.preventDefault();
            /**
             * 不添加定时器不聚焦
             * https://stackoverflow.com/questions/2600186/focus-doesnt-work-in-ie
             */
            let timer = setTimeout(() => {
                searchInput && searchInput.focus();
                clearTimeout(timer);
            }, 100);
        }
    };

    //根据下拉面板的页签，决定打开弹窗时渲染那个页签
    updateDropTabsActiveKey = (updateDropTabsKey) => {
        this.setState({
            // DropTabsKey: updateDropTabsKey,
            activeKey: updateDropTabsKey,
        });
    };

    updateShowColumnConfigPop = () => {
        this.setState({ showColumnConfigPop: false });
    };
}
